<template>
  <div>
    <div class="row mt-4">
      <div class="col">
        <div class="card custom-form__card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Treinamento para a Inteligência Artificial</h5>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              :disabled="!podeAbrirPlayground"
              :title="tituloBotaoPlayground"
              @click="abrirPlayground"
            >
              <i class="fa fa-flask mr-1"></i> Playground
            </button>
          </div>
          
          <!-- Seção de Agendamentos Cal.com - Estatísticas -->
          <div v-if="selectedTrainingId && form.calcomIntegracaoAtiva && estatisticasAgendamentos" class="card-body border-bottom calcom-estatisticas">
            <div class="row align-items-center">
              <div class="col-md-12">
                <h6 class="mb-2">
                  <i class="fa fa-calendar mr-2"></i>
                  Agendamentos Cal.com
                </h6>
                <div class="d-flex flex-wrap mb-2" style="gap: 0.75rem;">
                  <span class="badge badge-info">
                    <i class="fa fa-calendar mr-1"></i>
                    Total: {{ estatisticasAgendamentos.estatisticas.total }}
                  </span>
                  <span class="badge badge-warning">
                    <i class="fa fa-hourglass mr-1"></i>
                    Pendentes: {{ estatisticasAgendamentos.estatisticas.pendentes }}
                  </span>
                  <span class="badge badge-success">
                    <i class="fa fa-check mr-1"></i>
                    Aceitos: {{ estatisticasAgendamentos.estatisticas.aceitos }}
                  </span>
                  <span class="badge badge-danger">
                    <i class="fa fa-times mr-1"></i>
                    Cancelados: {{ estatisticasAgendamentos.estatisticas.cancelados }}
                  </span>
                  <span class="badge badge-secondary">
                    <i class="fa fa-check-circle mr-1"></i>
                    Concluídos: {{ estatisticasAgendamentos.estatisticas.concluidos }}
                  </span>
                </div>
                <div v-if="estatisticasAgendamentos.proximos && estatisticasAgendamentos.proximos.length > 0" class="mt-2">
                  <small class="text-muted d-block mb-1">
                    <strong>Próximos agendamentos:</strong>
                  </small>
                  <div class="d-flex flex-wrap" style="gap: 0.5rem;">
                    <span
                      v-for="agendamento in estatisticasAgendamentos.proximos"
                      :key="agendamento.id"
                      class="badge badge-light border"
                      :class="{
                        'badge-warning': agendamento.status === 'pending',
                        'badge-success': agendamento.status === 'accepted'
                      }"
                      :title="`${agendamento.nome_participante} - ${agendamento.email_participante}`"
                    >
                      {{ agendamento.data_inicio }}
                      <small class="ml-1">({{ agendamento.nome_participante }})</small>
                    </span>
                  </div>
                </div>
                <div v-else class="mt-2">
                  <small class="text-muted">Nenhum agendamento futuro encontrado.</small>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">
            <!-- Seletor de Treinamento -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Selecionar Treinamento Existente</label>
              <select
                class="form-control"
                v-model="selectedTrainingId"
                @change="carregarTreinamentoExistente(selectedTrainingId)"
              >
                <option disabled value="">Edite um treinamento existente...</option>
                <option value="__novo__" style="color: blue; font-weight: bold;">Criar novo treinamento</option>
                <option
                  v-for="t in treinamentosExistentes"
                  :key="t.id"
                  :value="t.id"
                >
                  {{ t.nome }}
                </option>
              </select>
            </div>



            <!-- Seletor de Nome do Treinamento -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Nome do Treinamento</label>
              <input
                type="text"
                class="form-control"
                v-model="form.nome"
                placeholder="Ex: Atendimento IA - Locação"
              />
            </div>

            <!-- XML de Treinamento -->
            <div class="form-group" v-if="isSuper">
              <label style="font-weight: 600; font-size: 1.3rem;">
                XML de Treinamento
                <small class="text-muted d-block" style="font-weight: 400; font-size: 0.85rem;">
                  Instruções de comportamento e fluxo da conversa (não armazene aqui o conhecimento operacional — use a base de conhecimento abaixo).
                </small>
              </label>
              <textarea class="form-control" v-model="form.training" rows="6"></textarea>
            </div>

            <!-- Base de Conhecimento (RAG) -->
            <div class="form-group" v-if="selectedTrainingId && selectedTrainingId !== '__novo__'">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="mb-0" style="font-weight: 600; font-size: 1.3rem;">Base de conhecimento</label>
                <span v-if="resumoConhecimento.total > 0" class="text-muted small">
                  <strong>{{ resumoConhecimento.prontos }}</strong>/{{ resumoConhecimento.total }} prontos
                  <span v-if="resumoConhecimento.chunks > 0">
                    · {{ resumoConhecimento.chunks }} trechos
                  </span>
                </span>
              </div>
              <small class="text-muted d-block mb-3">
                Arquivos da empresa ou páginas públicas na web (manuais, FAQs, políticas, catálogos) consultados pela IA durante a conversa.
              </small>

              <div class="form-row align-items-start" v-if="isSuper">
                <div class="form-group col-md-7 mb-3">
                  <Check
                    v-model="form.conhecimentoVetorialAtivo"
                    description="Quando ativo, a IA recebe trechos relevantes da base junto com cada mensagem."
                  >
                    Ativar consulta nas conversas
                  </Check>
                </div>
                <div class="form-group col-md-5 mb-3">
                  <label class="mb-1" style="font-weight: 600;">Trechos por resposta (top_k)</label>
                  <input
                    type="number"
                    class="form-control"
                    min="1"
                    max="50"
                    step="1"
                    v-model.number="form.conhecimentoVetorialTopK"
                  />
                  <small class="text-muted d-block mt-1">
                    Quantos trechos a IA recebe por mensagem (1 a 50).
                  </small>
                </div>
              </div>

              <div
                class="kb-uploader mb-3"
                :class="{ 'kb-uploader--dragging': conhecimentoDragAtivo }"
                @dragenter.prevent="onArrastarArquivosConhecimento(true)"
                @dragover.prevent="onArrastarArquivosConhecimento(true)"
                @dragleave.prevent="onArrastarArquivosConhecimento(false)"
                @drop.prevent="onSoltarArquivosConhecimento"
              >
                <input
                  ref="inputKnowledgeFile"
                  type="file"
                  class="d-none"
                  accept=".txt,.md,.csv,.html,.htm,.json,.xml,.log,.pdf,.doc,.docx"
                  multiple
                  @change="onSelecionarArquivosConhecimento"
                />
                <div class="kb-uploader__header">
                  <div class="kb-uploader__icon">
                    <i :class="conhecimentoDragAtivo ? 'fa fa-cloud-upload-alt' : 'fa fa-paperclip'"></i>
                  </div>
                  <div class="kb-uploader__content">
                    <strong>{{ conhecimentoDragAtivo ? 'Solte os arquivos aqui' : 'Anexar arquivos de conhecimento' }}</strong>
                    <small class="text-muted d-block">
                      Arraste os arquivos para esta caixa ou selecione manualmente.
                    </small>
                    <small class="text-muted d-block">
                      TXT, MD, CSV, HTML, JSON, XML, LOG, PDF, DOC, DOCX · máx. 50MB cada.
                    </small>
                  </div>
                  <div class="kb-uploader__actions">
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      :disabled="conhecimentoUploading"
                      @click="$refs.inputKnowledgeFile && $refs.inputKnowledgeFile.click()"
                    >
                      <i class="fa fa-plus mr-1"></i>Selecionar arquivos
                    </button>
                  </div>
                </div>

                <div v-if="arquivosConhecimentoSelecionados.length > 0" class="kb-selected-files mt-3">
                  <div class="kb-selected-files__summary">
                    <strong>{{ textoResumoArquivosConhecimento() }}</strong>
                    <button
                      v-if="!conhecimentoUploading"
                      class="btn btn-link text-muted p-0"
                      type="button"
                      @click="limparArquivosSelecionados"
                    >
                      Limpar seleção
                    </button>
                  </div>

                  <div class="kb-selected-files__list">
                    <div
                      v-for="(arquivo, index) in arquivosConhecimentoSelecionados"
                      :key="arquivoConhecimentoKey(arquivo, index)"
                      class="kb-selected-file"
                    >
                      <i class="kb-selected-file__icon" :class="iconePorExtensao(arquivo.name)"></i>
                      <div class="kb-selected-file__info">
                        <strong class="kb-selected-file__name" :title="arquivo.name">{{ arquivo.name }}</strong>
                        <span class="kb-selected-file__size">{{ formatarTamanho(arquivo.size) }}</span>
                      </div>
                      <button
                        v-if="!conhecimentoUploading"
                        class="btn btn-link text-muted p-0"
                        type="button"
                        title="Remover arquivo"
                        @click="removerArquivoConhecimentoSelecionado(index)"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>

                  <div class="text-right mt-3">
                    <button
                      class="btn btn-primary"
                      type="button"
                      :disabled="conhecimentoUploading"
                      @click="enviarArquivosConhecimento"
                    >
                      <i class="fa" :class="conhecimentoUploading ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                      {{ conhecimentoUploading ? ' Enviando...' : ' Enviar arquivos' }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="kb-url-import mb-3">
                <label class="mb-1 d-block" style="font-weight: 600;">
                  <i class="fa fa-link mr-1 text-primary"></i>Importar de URL
                </label>
                <small class="text-muted d-block mb-2">
                  Extrai apenas texto da página (sem executar scripts). HTTPS obrigatório; domínios internos e IPs bloqueados.
                </small>
                <div class="d-flex flex-wrap align-items-stretch" style="gap: 0.5rem;">
                  <input
                    v-model.trim="conhecimentoUrlInput"
                    type="url"
                    class="form-control flex-grow-1"
                    style="min-width: 220px;"
                    placeholder="https://www.suaempresa.com.br/faq"
                    :disabled="conhecimentoUrlImportando"
                    @keyup.enter="importarUrlConhecimento"
                  />
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    :disabled="conhecimentoUrlImportando || !conhecimentoUrlInput"
                    @click="importarUrlConhecimento"
                  >
                    <i class="fa" :class="conhecimentoUrlImportando ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
                    {{ conhecimentoUrlImportando ? ' Importando...' : ' Importar' }}
                  </button>
                </div>
              </div>

              <div
                v-if="conhecimentoCarregando && conhecimentoDocumentos.length === 0"
                class="text-center text-muted py-4"
              >
                <i class="fas fa-spinner fa-spin mr-1"></i> Carregando documentos...
              </div>

              <div
                v-else-if="conhecimentoDocumentos.length === 0"
                class="kb-empty text-center"
              >
                <i class="far fa-file-alt kb-empty-icon"></i>
                <p class="mb-1 mt-2"><strong>Nenhum documento enviado ainda.</strong></p>
                <small class="text-muted">
                  Envie arquivos ou importe uma URL pública para a IA consultar como contexto.
                </small>
              </div>

              <ul v-else class="kb-list list-unstyled mb-0">
                <li
                  v-for="doc in conhecimentoDocumentos"
                  :key="doc.id"
                  class="kb-item"
                  :class="`kb-item--${doc.status}`"
                >
                  <div class="kb-item__icon">
                    <i :class="iconeDocumentoConhecimento(doc)"></i>
                  </div>
                  <div class="kb-item__body">
                    <div class="kb-item__title" :title="tituloDocumentoConhecimento(doc)">
                      {{ doc.nome_original }}
                      <span v-if="doc.source_type === 'url'" class="badge badge-light ml-1">URL</span>
                    </div>
                    <div class="kb-item__meta text-muted small">
                      <span v-if="doc.source_type === 'url' && doc.source_url" class="kb-item__url" :title="doc.source_url">
                        {{ truncar(doc.source_url, 72) }}
                      </span>
                      <span v-if="doc.source_type === 'url' && doc.source_url" class="kb-sep">·</span>
                      <span>{{ formatarTamanho(doc.tamanho_bytes) }}</span>
                      <span class="kb-sep">·</span>
                      <span><strong>{{ doc.chunks_count || 0 }}</strong> trecho(s)</span>
                      <span class="kb-sep">·</span>
                      <span :title="doc.fetched_at || doc.created_at">
                        {{ formatarData(doc.fetched_at || doc.created_at) }}
                      </span>
                    </div>
                    <div
                      v-if="doc.status === 'error' && doc.error_message"
                      class="text-danger small mt-1"
                    >
                      <i class="fa fa-exclamation-triangle mr-1"></i>{{ truncar(doc.error_message, 160) }}
                    </div>
                  </div>
                  <div class="kb-item__status">
                    <span class="badge" :class="statusBadgeClass(doc.status)">
                      <i class="mr-1" :class="statusIcon(doc.status)"></i>
                      {{ statusLabel(doc.status) }}
                    </span>
                  </div>
                  <div class="kb-item__actions">
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      type="button"
                      :disabled="doc.status === 'processing'"
                      @click="reindexarDocumentoConhecimento(doc)"
                      title="Reprocessar"
                    >
                      <i class="fas fa-sync-alt"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-outline-danger"
                      type="button"
                      :disabled="doc.status === 'processing'"
                      @click="abrirModalRemoverConhecimento(doc)"
                      title="Remover"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </li>
              </ul>

              <div v-if="temDocumentoProcessando" class="mt-3">
                <small class="text-info">
                  <i class="fa fa-spinner fa-spin mr-1"></i>
                  Indexando documentos... a lista atualiza sozinha.
                </small>
              </div>
            </div>

            <!-- Modelo, Temperatura e limite de tokens -->
            <div class="form-row" v-if="isSuper">
              <div class="form-group col-md-4">
                <label style="font-weight: 600; font-size: 1.3rem;">Modelo</label>
                <select class="form-control" v-model="form.model">
                <option v-for="model in modelosDisponiveis" :key="model.id" :value="model.id">
                  {{ model.id }}
                </option>
                </select>
                <div v-if="form.model" class="mt-2">
                  <small class="text-muted">Modelo selecionado: {{ form.model }}</small>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label style="font-weight: 600; font-size: 1.3rem;">Temperatura</label>
                <select class="form-control" v-model="form.temperature">
                  <option v-for="temp in temperaturas" :key="temp.valor" :value="temp.valor">
                    {{ temp.valor }} - {{ temp.descricao }}
                  </option>
                </select>
                <small class="text-muted d-block mt-1">
                  Controla a criatividade das respostas: valores baixos (0.1-0.3) são mais determinísticos, valores altos (0.8-1.0) são mais criativos.
                </small>
              </div>
              <div class="form-group col-md-4">
                <label style="font-weight: 600; font-size: 1.3rem;">Máx. tokens (resposta)</label>
                <input
                  type="number"
                  class="form-control"
                  min="100"
                  step="50"
                  v-model.number="form.maxTokensResposta"
                />
                <small class="text-muted d-block mt-1">
                  Limite de tokens gerados por resposta do modelo (mínimo 100). Quanto maior o valor, mais longa pode ser a resposta e maior o custo.
                </small>
              </div>
            </div>
            <div class="form-row" v-if="isSuper">
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Dividir resposta em várias mensagens</label>
                <select class="form-control w-100" v-model="form.dividirRespostaSmart">
                  <option :value="true">Sim (padrão), parágrafos e frases em mensagens separadas</option>
                  <option :value="false">Não, enviar o texto completo em uma única mensagem</option>
                </select>
                <small class="text-muted d-block mt-1">
                  Quando desativado, a resposta da IA é enviada de uma vez, sem quebrar em várias bolhas no WhatsApp.
                  Se a resposta incluir imagem em markdown (<code>![...](url)</code>), cada imagem continua em mensagem separada.
                </small>
              </div>
            </div>

            <!-- Ferramentas -->
            <div class="form-group">
              <label class="mb-2" style="font-weight: 600; font-size: 1.3rem;">Ferramentas Disponíveis</label>
              <div class="row">
                <div
                  v-for="(info, key) in toolsDisponiveis"
                  :key="key"
                  class="col-md-4 mb-2"
                >
                  <div class="d-flex align-items-start h-100">
                    <!-- Redirecionar Outros Assuntos -->
                    <div v-if="key === 'redirecionar_outros_assuntos'" class="d-flex flex-column w-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <Check
                          v-model="form.tools"
                          :optionValue="key"
                          :description="''"
                          @change="checkRedirecionamentoSelecionado(key)"
                        >
                          {{ info.nome }}
                        </Check>

                        <button
                          v-if="redirecionamentoAtivo"
                          class="btn btn-xs btn-outline-primary ml-2 py-1 px-2"
                          style="font-size: 0.75rem; line-height: 1.2;"
                          @click="mostrarModalRedirecionamento = true"
                        >
                          Configurar
                        </button>
                      </div>
                      <small class="text-muted">{{ info.descricao }}</small>
                    </div>

                    <!-- versão com botão de configuração para finalizar_locacao -->
                    <div v-else-if="key === 'finalizar_locacao'" class="d-flex flex-column w-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <Check
                          v-model="form.tools"
                          :optionValue="key"
                          :description="''"
                          @change="checkFinalizarLocacaoSelecionado(key)"
                        >
                          {{ info.nome }}
                        </Check>

                        <button
                          v-if="finalizarLocacaoAtivo"
                          class="btn btn-xs btn-outline-primary ml-2 py-1 px-2"
                          style="font-size: 0.75rem; line-height: 1.2;"
                          @click="mostrarModalFinalizarLocacao = true"
                        >
                          Configurar
                        </button>
                      </div>
                      <small class="text-muted">{{ info.descricao }}</small>
                    </div>

                    <div v-else-if="key === 'enviar_contrato_assinatura'" class="d-flex flex-column w-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <Check
                          v-model="form.tools"
                          :optionValue="key"
                          :description="''"
                          @change="checkRedirecionamentoSelecionado(key)"
                        >
                          {{ info.nome }}
                        </Check>

                        <button
                          v-if="contratoAssinaturaAtivo"
                          class="btn btn-xs btn-outline-primary ml-2 py-1 px-2"
                          style="font-size: 0.75rem; line-height: 1.2;"
                          type="button"
                          @click="abrirModalContratoAssinatura"
                        >
                          Configurar
                        </button>
                      </div>
                      <small class="text-muted">{{ info.descricao }}</small>
                    </div>

                    <!-- Buscar Equipamento + modal de opções -->
                    <div v-else-if="key === 'buscar_equipamento'" class="d-flex flex-column w-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <Check
                          v-model="form.tools"
                          :optionValue="key"
                          :description="''"
                          @change="checkRedirecionamentoSelecionado(key)"
                        >
                          {{ info.nome }}
                        </Check>

                        <button
                          v-if="form.tools.includes('buscar_equipamento')"
                          type="button"
                          class="btn btn-xs btn-outline-primary ml-2 py-1 px-2"
                          style="font-size: 0.75rem; line-height: 1.2;"
                          @click="mostrarModalBuscaEquipamento = true"
                        >
                          Configurar
                        </button>
                      </div>
                      <small class="text-muted">{{ info.descricao }}</small>
                    </div>

                    <!-- Integração Cal.com -->
                    <div v-else-if="key === 'integracao_agenda'" class="d-flex flex-column w-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <Check
                          v-model="form.calcomIntegracaoAtiva"
                          :description="''"
                          @change="onCalcomIntegracaoChange"
                        >
                          {{ info.nome }}
                        </Check>

                        <button
                          v-if="form.calcomIntegracaoAtiva"
                          class="btn btn-xs btn-outline-primary ml-2 py-1 px-2"
                          style="font-size: 0.75rem; line-height: 1.2;"
                          @click="mostrarModalCalcom = true"
                        >
                          Configurar
                        </button>
                      </div>
                      <small class="text-muted">{{ info.descricao }}</small>
                    </div>

                    <!-- versão normal para os demais -->
                    <div v-else>
                      <Check
                        v-model="form.tools"
                        :optionValue="key"
                        :description="info.descricao"
                        @change="checkRedirecionamentoSelecionado(key)"
                      >
                        {{ info.nome }}
                      </Check>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tools HTTP internas -->
            <div class="form-group ia-http-tools-panel">
              <div class="ia-http-tools-panel__header">
                <div class="ia-http-tools-panel__header-text">
                  <label class="mb-1" style="font-weight: 600; font-size: 1.3rem;">Requisições internas (Tools HTTP)</label>
                  <p class="text-muted small mb-0">
                    Configure chamadas HTTP que a Elis poderá acionar pelo slug da tool. Use o preview para validar a request e a saída enviada para a IA.
                  </p>
                </div>
                <div class="ia-http-tools-panel__header-actions">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="abrirNovaHttpTool">
                    <i class="fa fa-plus mr-1"></i> Nova tool HTTP
                  </button>
                </div>
              </div>

              <div v-if="!form.httpTools.length" class="text-muted small mb-3">
                Nenhuma tool HTTP configurada neste treinamento.
              </div>

              <div v-else class="table-responsive mb-3">
                <table class="table table-sm table-bordered mb-0 ia-http-tools-table">
                  <thead>
                    <tr>
                      <th>Ativa</th>
                      <th>Nome</th>
                      <th>Slug</th>
                      <th>Método</th>
                      <th class="ia-http-tools-table__url-col">URL</th>
                      <th class="text-right">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(tool, index) in form.httpTools" :key="tool.slug || index">
                      <td>
                        <span :class="tool.enabled ? 'badge badge-success' : 'badge badge-secondary'">
                          {{ tool.enabled ? 'Sim' : 'Não' }}
                        </span>
                      </td>
                      <td>{{ tool.name }}</td>
                      <td><code>{{ tool.slug }}</code></td>
                      <td>{{ tool.method }}</td>
                      <td class="text-truncate ia-http-tools-table__url-col" style="max-width: 280px;">{{ tool.url }}</td>
                      <td class="text-right">
                        <button type="button" class="btn btn-xs btn-outline-primary mr-1" @click="editarHttpTool(index)">Editar</button>
                        <button type="button" class="btn btn-xs btn-outline-danger" @click="removerHttpTool(index)">Remover</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="httpToolEditorOpen" class="card ia-http-tool-editor">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                  <strong>{{ httpToolEditingIndex === null ? 'Nova tool HTTP' : 'Editar tool HTTP' }}</strong>
                  <button type="button" class="btn btn-sm btn-link" @click="fecharHttpToolEditor">Fechar</button>
                </div>
                <div class="card-body">
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label>Nome</label>
                      <input class="form-control" v-model.trim="httpToolDraft.name" @input="onHttpToolNameInput" placeholder="Chamada Amazon" />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Slug</label>
                      <input class="form-control" v-model.trim="httpToolDraft.slug" placeholder="chamada_amazon" @input="httpToolSlugTouched = true" />
                      <small class="text-muted">Este é o nome que o treinamento poderá chamar.</small>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Método</label>
                      <select class="form-control" v-model="httpToolDraft.method">
                        <option>GET</option>
                        <option>POST</option>
                        <option>PUT</option>
                        <option>PATCH</option>
                        <option>DELETE</option>
                      </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Status</label>
                      <select class="form-control" v-model="httpToolDraft.enabled">
                        <option :value="true">Ativa</option>
                        <option :value="false">Inativa</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Descrição para a IA</label>
                    <textarea class="form-control" rows="2" v-model.trim="httpToolDraft.description" placeholder="Explique quando a IA deve usar esta tool."></textarea>
                  </div>

                  <div class="form-group">
                    <label>URL</label>
                    <input class="form-control" v-model.trim="httpToolDraft.url" placeholder="https://api.exemplo.com/recurso" @focus="registrarHttpToolCampoFocado('url')" />
                    <small class="text-muted">
                      Use <code>[[nome]]</code> para variáveis preenchidas pela IA e <code>((chave))</code> para variáveis do sistema (loja, cliente, oportunidade).
                    </small>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label>Autenticação</label>
                      <select class="form-control" v-model="httpToolDraft.auth.type">
                        <option value="none">Sem autenticação</option>
                        <option value="bearer">Bearer token</option>
                        <option value="basic">Basic auth</option>
                        <option value="api_key">API key</option>
                      </select>
                    </div>
                    <div class="form-group col-md-4" v-if="httpToolDraft.auth.type === 'bearer' || httpToolDraft.auth.type === 'api_key'">
                      <label>Token/valor</label>
                      <input
                        class="form-control"
                        type="password"
                        v-model.trim="httpToolDraft.auth.value"
                        placeholder="Informe o token de autenticação"
                        autocomplete="new-password"
                      />
                      <small v-if="httpToolDraft.auth.value_configured" class="text-muted">
                        Token configurado, preencha apenas para alterar.
                      </small>
                    </div>
                    <div class="form-group col-md-2" v-if="httpToolDraft.auth.type === 'api_key'">
                      <label>Nome da chave</label>
                      <input class="form-control" v-model.trim="httpToolDraft.auth.key" placeholder="x-api-key" />
                    </div>
                    <div class="form-group col-md-2" v-if="httpToolDraft.auth.type === 'api_key'">
                      <label>Enviar em</label>
                      <select class="form-control" v-model="httpToolDraft.auth.in">
                        <option value="header">Header</option>
                        <option value="query">Query</option>
                      </select>
                    </div>
                    <div class="form-group col-md-4" v-if="httpToolDraft.auth.type === 'basic'">
                      <label>Usuário</label>
                      <input class="form-control" v-model.trim="httpToolDraft.auth.username" />
                    </div>
                    <div class="form-group col-md-4" v-if="httpToolDraft.auth.type === 'basic'">
                      <label>Senha</label>
                      <input
                        class="form-control"
                        type="password"
                        v-model.trim="httpToolDraft.auth.password"
                        placeholder="Informe a senha"
                        autocomplete="new-password"
                      />
                      <small v-if="httpToolDraft.auth.password_configured" class="text-muted">
                        Senha configurada, preencha apenas para alterar.
                      </small>
                    </div>
                  </div>

                  <div class="form-row ia-http-config-row">
                    <div class="form-group col-md-6 ia-http-config-block">
                      <div class="ia-http-subsection-header">
                        <span class="ia-http-subsection-header__title">Headers</span>
                        <button type="button" class="btn btn-xs btn-outline-primary ia-http-subsection-header__btn" @click="adicionarHttpToolKeyValue('headers')">
                          <i class="fa fa-plus mr-1"></i>Header
                        </button>
                      </div>
                      <div v-if="!httpToolDraft.headers.length" class="text-muted small mb-2">
                        Nenhum header adicional configurado.
                      </div>
                      <div v-else class="ia-http-scroll-list">
                        <div
                          v-for="(header, index) in httpToolDraft.headers"
                          :key="'header-' + index"
                          class="ia-http-kv-row"
                        >
                          <div class="ia-http-kv-row__key">
                            <input class="form-control form-control-sm" v-model.trim="header.key" placeholder="Chave. Ex: Accept" />
                          </div>
                          <div class="ia-http-kv-row__value">
                            <input class="form-control form-control-sm" v-model="header.value" placeholder="Valor. Ex: application/json" @focus="registrarHttpToolCampoFocado('header', index)" />
                          </div>
                          <button type="button" class="btn btn-xs btn-outline-danger ia-http-kv-row__remove" @click="removerHttpToolKeyValue('headers', index)">
                            &times;
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6 ia-http-config-block">
                      <div class="ia-http-subsection-header">
                        <span class="ia-http-subsection-header__title">Query params</span>
                        <button type="button" class="btn btn-xs btn-outline-primary ia-http-subsection-header__btn" @click="adicionarHttpToolKeyValue('query_params')">
                          <i class="fa fa-plus mr-1"></i>Parâmetro
                        </button>
                      </div>
                      <div v-if="!httpToolDraft.query_params.length" class="text-muted small mb-2">
                        Nenhum query param configurado.
                      </div>
                      <div v-else class="ia-http-scroll-list">
                        <div
                          v-for="(param, index) in httpToolDraft.query_params"
                          :key="'query-param-' + index"
                          class="ia-http-kv-row"
                        >
                          <div class="ia-http-kv-row__key">
                            <input class="form-control form-control-sm" v-model.trim="param.key" placeholder="Chave. Ex: cliente" />
                          </div>
                          <div class="ia-http-kv-row__value">
                            <input class="form-control form-control-sm" v-model="param.value" :placeholder="httpToolPlaceholders.queryParamValue" @focus="registrarHttpToolCampoFocado('query', index)" />
                          </div>
                          <button type="button" class="btn btn-xs btn-outline-danger ia-http-kv-row__remove" @click="removerHttpToolKeyValue('query_params', index)">
                            &times;
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-row ia-http-config-row">
                    <div class="form-group col-md-6 ia-http-config-block">
                      <div class="ia-http-subsection-header">
                        <span class="ia-http-subsection-header__title">Body JSON</span>
                        <button
                          type="button"
                          class="btn btn-xs btn-outline-primary ia-http-subsection-header__btn ia-http-subsection-header__btn--placeholder"
                          tabindex="-1"
                          aria-hidden="true"
                          disabled
                        >
                          <i class="fa fa-plus mr-1"></i>Variável
                        </button>
                      </div>
                      <textarea class="form-control" rows="6" v-model="httpToolDraft.bodyJson" :placeholder="httpToolPlaceholders.body" @focus="registrarHttpToolCampoFocado('body')"></textarea>
                      <small class="text-muted">Exemplo: <code>{"cliente_id":"((cliente_id))","termo":"[[termo]]","loja":"((loja_id))"}</code>. Com body vazio, variáveis da IA não são enviadas — referencie cada uma com <code>[[nome]]</code>.</small>
                    </div>
                    <div class="form-group col-md-6 ia-http-config-block">
                      <div class="ia-http-subsection-header">
                        <span class="ia-http-subsection-header__title">Variáveis</span>
                        <button type="button" class="btn btn-xs btn-outline-primary ia-http-subsection-header__btn" @click="adicionarHttpToolVariable">
                          <i class="fa fa-plus mr-1"></i>Variável
                        </button>
                      </div>
                      <p class="ia-http-subsection-hint text-muted small">
                        Cadastre aqui as variáveis preenchidas pela IA com <code>[[nome_da_variavel]]</code>.
                      </p>
                      <div v-if="!httpToolDraft.variables.length" class="alert alert-info py-2 small">
                        Nenhuma variável cadastrada. A IA chamará esta tool sem preencher dados.
                      </div>
                      <div v-else class="ia-http-scroll-list ia-http-variables-list">
                        <div
                          v-for="(variable, index) in httpToolDraft.variables"
                          :key="'http-variable-' + index"
                          class="ia-http-variable-row"
                        >
                          <div class="ia-http-variable-row__name">
                            <label class="small mb-1">Nome</label>
                            <input class="form-control form-control-sm" v-model.trim="variable.name" placeholder="termo" @input="variable.name = normalizarHttpToolVariableName(variable.name)" />
                          </div>
                          <div class="ia-http-variable-row__type">
                            <label class="small mb-1">Tipo</label>
                            <select class="form-control form-control-sm" v-model="variable.type">
                              <option value="string">Texto</option>
                              <option value="number">Número</option>
                              <option value="integer">Inteiro</option>
                              <option value="boolean">Sim/Não</option>
                              <option value="array">Lista</option>
                              <option value="object">Objeto</option>
                            </select>
                          </div>
                          <div class="ia-http-variable-row__required">
                            <label class="small mb-1">Obrigatória</label>
                            <select class="form-control form-control-sm" v-model="variable.required">
                              <option :value="true">Sim</option>
                              <option :value="false">Não</option>
                            </select>
                          </div>
                          <button type="button" class="btn btn-xs btn-outline-danger ia-http-variable-row__remove" @click="removerHttpToolVariable(index)">
                            &times;
                          </button>
                          <div class="ia-http-variable-row__description">
                            <input class="form-control form-control-sm" v-model.trim="variable.description" placeholder="Descrição para a IA entender quando preencher esta variável" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group ia-http-system-variables-panel">
                    <button
                      type="button"
                      class="ia-http-system-variables-panel__toggle"
                      :aria-expanded="httpToolSystemVariablesExpanded ? 'true' : 'false'"
                      @click="httpToolSystemVariablesExpanded = !httpToolSystemVariablesExpanded"
                    >
                      <span class="ia-http-system-variables-panel__toggle-text">
                        <span class="ia-http-system-variables-panel__title">Variáveis do sistema</span>
                        <span class="ia-http-system-variables-panel__subtitle">
                          Preenchidas automaticamente com <code>((chave))</code>, clique para inserir no campo em foco
                        </span>
                      </span>
                      <span class="ia-http-system-variables-panel__toggle-icon">
                        <i class="fa" :class="httpToolSystemVariablesExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      </span>
                    </button>

                    <div v-show="httpToolSystemVariablesExpanded" class="ia-http-system-variables-panel__body">
                      <div class="ia-http-variables-legend">
                        <span class="ia-http-variables-legend__item">
                          <code>[[nome]]</code>
                          <span class="text-muted">preenchido pela IA</span>
                        </span>
                        <span class="ia-http-variables-legend__divider">·</span>
                        <span class="ia-http-variables-legend__item">
                          <code>((chave))</code>
                          <span class="text-muted">preenchido pelo sistema</span>
                        </span>
                      </div>

                      <div v-if="httpToolSystemVariablesLoading" class="text-muted small py-2">Carregando dicionário...</div>
                      <div v-else-if="!httpToolSystemVariables.length" class="text-muted small py-2">Dicionário indisponível no momento.</div>
                      <template v-else>
                        <div class="ia-http-system-variables-toolbar">
                          <input
                            v-model.trim="httpToolSystemVariablesSearch"
                            type="search"
                            class="form-control form-control-sm ia-http-system-variables-search"
                            placeholder="Buscar por nome ou chave..."
                          />
                          <div v-if="!httpToolSystemVariablesSearch" class="ia-http-system-variables-tabs" role="tablist">
                            <button
                              v-for="group in httpToolSystemVariables"
                              :key="'sys-tab-' + group.id"
                              type="button"
                              class="ia-http-system-variables-tab"
                              :class="{ 'ia-http-system-variables-tab--active': httpToolSystemVariablesActiveGroup === group.id }"
                              @click="httpToolSystemVariablesActiveGroup = group.id"
                            >
                              {{ group.label }}
                              <span class="ia-http-system-variables-tab__count">{{ group.variables.length }}</span>
                            </button>
                          </div>
                        </div>

                        <div v-if="httpToolSystemVariablesSearch && !httpToolSystemVariablesFilteredFlat.length" class="text-muted small py-2">
                          Nenhuma variável encontrada para "{{ httpToolSystemVariablesSearch }}".
                        </div>

                        <div v-else class="ia-http-system-variables-chips">
                          <button
                            v-for="variable in httpToolSystemVariablesDisplayed"
                            :key="'sys-var-' + variable.key"
                            type="button"
                            class="ia-http-system-variable-chip"
                            :title="variable.description || variable.label"
                            @click="inserirHttpToolSystemVariable(variable.key)"
                          >
                            <code class="ia-http-system-variable-chip__key">(({{ variable.key }}))</code>
                            <span class="ia-http-system-variable-chip__label">{{ variable.label }}</span>
                            <span
                              v-if="httpToolSystemVariablesSearch && variable.groupLabel"
                              class="ia-http-system-variable-chip__group"
                            >
                              {{ variable.groupLabel }}
                            </span>
                          </button>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div v-if="httpToolVariableReferences.length || httpToolSystemVariableReferences.length" class="ia-http-section-card py-2 mb-3">
                    <label class="small font-weight-bold d-block mb-2">Variáveis usadas na request</label>
                    <span
                      v-for="ref in httpToolVariableReferences"
                      :key="'dyn-' + ref.name"
                      class="badge mr-1 mb-1"
                      :class="ref.exists ? 'badge-success' : 'badge-danger'"
                    >
                      [[{{ ref.name }}]] {{ ref.exists ? 'cadastrada' : 'não cadastrada' }}
                    </span>
                    <span
                      v-for="ref in httpToolSystemVariableReferences"
                      :key="'sys-' + ref.key"
                      class="badge badge-info mr-1 mb-1"
                      :class="{ 'badge-danger': !ref.valid }"
                    >
                      (({{ ref.key }})) {{ ref.valid ? 'sistema' : 'desconhecida' }}
                    </span>
                  </div>

                  <div class="ia-http-output-builder">
                    <div class="ia-http-section-card">
                      <div class="d-flex justify-content-between align-items-start mb-3">
                        <div>
                          <h6 class="mb-1">1. Dados para testar a chamada</h6>
                          <p class="text-muted small mb-0">
                            Use valores de exemplo para executar a request e descobrir quais campos a API retorna.
                          </p>
                        </div>
                        <button type="button" class="btn btn-outline-info btn-sm" :disabled="httpToolPreviewLoading" @click="previewHttpTool">
                          {{ httpToolPreviewLoading ? 'Executando...' : 'Executar preview' }}
                        </button>
                      </div>
                      <textarea class="form-control" rows="4" v-model="httpToolPreviewArgumentsJson" placeholder='{"termo":"exemplo"}'></textarea>
                      <div class="form-group mt-2 mb-0">
                        <label class="small mb-1">Oportunidade para preview (opcional)</label>
                        <input
                          class="form-control form-control-sm"
                          v-model.trim="httpToolPreviewOportunidadeId"
                          type="number"
                          min="1"
                          placeholder="ID da oportunidade para testar variáveis do sistema"
                        />
                        <small class="text-muted">Use para preencher ((cliente_nome)), ((oportunidade_id)) etc. com dados reais.</small>
                      </div>
                    </div>

                    <div class="ia-http-section-card">
                      <div class="d-flex justify-content-between align-items-start mb-3">
                        <div>
                          <h6 class="mb-1">2. Escolha o que a IA vai receber</h6>
                          <p class="text-muted small mb-0">
                            Clique nos campos encontrados no preview ou adicione manualmente. Se não escolher nada, a IA recebe a resposta completa.
                          </p>
                        </div>
                        <div class="ia-http-output-builder__actions d-flex flex-wrap justify-content-end">
                          <button type="button" class="btn btn-sm btn-outline-secondary mr-1 mb-1" @click="limparHttpToolResponseMapping">
                            Usar resposta completa
                          </button>
                          <button type="button" class="btn btn-sm btn-outline-primary mb-1" @click="adicionarHttpToolResponsePath">
                            Adicionar campo
                          </button>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-7">
                          <div v-if="!httpToolDraft.response_paths.length" class="alert alert-info py-2 small">
                            Nenhum filtro selecionado. A saída para IA será a resposta completa da API.
                          </div>
                          <div class="ia-http-selected-fields">
                            <div
                              v-for="(field, index) in httpToolDraft.response_paths"
                              :key="'response-path-' + index"
                              class="ia-http-field-row"
                            >
                              <div class="ia-http-field-row__alias">
                                <label class="small mb-1">Nome para IA</label>
                                <input class="form-control form-control-sm" v-model.trim="field.alias" placeholder="Ex: status" />
                              </div>
                              <div class="ia-http-field-row__path">
                                <label class="small mb-1">Campo da resposta</label>
                                <input class="form-control form-control-sm" v-model.trim="field.path" placeholder="Ex: calls.*.createdAt" />
                              </div>
                              <button type="button" class="btn btn-xs btn-outline-danger ia-http-field-row__remove" @click="removerHttpToolResponsePath(index)">
                                &times;
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5">
                          <label class="small font-weight-bold d-block mb-2">Campos encontrados no preview</label>
                          <div v-if="!httpToolPreviewSuggestedPaths.length" class="text-muted small">
                            Execute o preview para listar campos como <code>calls.*.id</code>.
                          </div>
                          <div v-else class="ia-http-suggestions">
                            <button
                              v-for="suggestion in httpToolPreviewSuggestedPaths"
                              :key="suggestion.path"
                              type="button"
                              class="btn btn-xs btn-outline-secondary mr-1 mb-1"
                              @click="adicionarHttpToolResponsePathFromSuggestion(suggestion)"
                            >
                              {{ suggestion.path }}
                              <small class="text-muted">({{ suggestion.type }})</small>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="ia-http-section-card ia-http-ai-output-card">
                      <div class="d-flex justify-content-between align-items-start mb-3">
                        <div>
                          <h6 class="mb-1">3. Prévia visual da saída para a IA</h6>
                          <p class="text-muted small mb-0">
                            Este é o conteúdo que será usado como contexto para a IA responder ao cliente.
                          </p>
                        </div>
                        <div>
                          <button type="button" class="btn btn-primary btn-sm mr-2" @click="salvarHttpToolDraft">Salvar tool</button>
                          <button type="button" class="btn btn-link btn-sm" @click="fecharHttpToolEditor">Cancelar</button>
                        </div>
                      </div>
                      <pre class="ia-http-preview ia-http-preview--ai">{{ httpToolConfiguredAiOutput }}</pre>
                    </div>

                    <div v-if="httpToolPreviewResult" class="row">
                      <div class="col-md-6">
                        <label class="small font-weight-bold">Request executada</label>
                        <pre class="ia-http-preview">{{ formatJson(httpToolPreviewRequest) }}</pre>
                      </div>
                      <div class="col-md-6">
                        <label class="small font-weight-bold">Resposta original da API</label>
                        <pre class="ia-http-preview">{{ formatJson(httpToolPreviewRawResponse) }}</pre>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tags na oportunidade ao executar ferramentas (Elis) -->
            <div class="form-group">
              <label class="mb-2" style="font-weight: 600; font-size: 1.3rem;">Tags na oportunidade (Elis)</label>
              <p class="text-muted small mb-2">
                Quando a IA executar uma ferramenta com sucesso, as tags marcadas serão adicionadas à oportunidade (sem remover as já existentes).
              </p>
              <div v-if="loadingTagsTreinamento" class="text-muted small">Carregando tags...</div>
              <div v-else-if="!tagsTreinamento.length" class="text-muted small">Cadastre tags na loja para poder associá-las aqui.</div>
              <div v-else>
                <div class="form-group mb-3" v-if="tagsTreinamento.length > 6">
                  <input
                    type="search"
                    class="form-control form-control-sm ia-tag-search"
                    v-model.trim="tagPickerSearchElis"
                    placeholder="Filtrar tags por nome..."
                    autocomplete="off"
                  />
                </div>
                <div class="row">
                  <div
                    v-for="toolKey in toolKeysForTagConfig"
                    :key="'tag-' + toolKey"
                    v-show="form.tools.includes(toolKey)"
                    class="col-md-6 mb-3"
                  >
                    <label class="small font-weight-bold d-block mb-2">{{ toolsDisponiveis[toolKey].nome }}</label>
                    <div class="ia-tag-picker">
                      <div
                        v-for="t in tagsFiltradasElis"
                        :key="'el-' + toolKey + '-' + t.id"
                        class="custom-control custom-checkbox ia-tag-picker__item"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'ia-elis-' + toolKey + '-' + t.id"
                          :checked="isToolTagSelected(toolKey, t.id)"
                          @change="toggleToolTag(toolKey, t.id)"
                        />
                        <label class="custom-control-label ia-tag-picker__label" :for="'ia-elis-' + toolKey + '-' + t.id">
                          <span class="ia-tag-dot" :style="{ backgroundColor: t.cor || '#6c757d' }" />
                          {{ t.nome }}
                        </label>
                      </div>
                      <p v-if="!tagsFiltradasElis.length" class="text-muted small mb-0 px-1">Nenhuma tag com esse filtro.</p>
                    </div>
                  </div>
                  <template v-if="form.calcomIntegracaoAtiva && (calcomPodeAgendar || calcomPodeCancelar || calcomSugerirHorarios)">
                    <div v-if="calcomSugerirHorarios" class="col-md-6 mb-3">
                      <label class="small font-weight-bold d-block mb-2">Buscar horários (Cal.com)</label>
                      <div class="ia-tag-picker">
                        <div
                          v-for="t in tagsFiltradasElis"
                          :key="'el-h-' + t.id"
                          class="custom-control custom-checkbox ia-tag-picker__item"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'ia-elis-buscar_horarios-' + t.id"
                            :checked="isToolTagSelected('buscar_horarios', t.id)"
                            @change="toggleToolTag('buscar_horarios', t.id)"
                          />
                          <label class="custom-control-label ia-tag-picker__label" :for="'ia-elis-buscar_horarios-' + t.id">
                            <span class="ia-tag-dot" :style="{ backgroundColor: t.cor || '#6c757d' }" />
                            {{ t.nome }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div v-if="calcomPodeAgendar" class="col-md-6 mb-3">
                      <label class="small font-weight-bold d-block mb-2">Marcar reunião (Cal.com)</label>
                      <div class="ia-tag-picker">
                        <div
                          v-for="t in tagsFiltradasElis"
                          :key="'el-m-' + t.id"
                          class="custom-control custom-checkbox ia-tag-picker__item"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'ia-elis-marcar_reuniao-' + t.id"
                            :checked="isToolTagSelected('marcar_reuniao', t.id)"
                            @change="toggleToolTag('marcar_reuniao', t.id)"
                          />
                          <label class="custom-control-label ia-tag-picker__label" :for="'ia-elis-marcar_reuniao-' + t.id">
                            <span class="ia-tag-dot" :style="{ backgroundColor: t.cor || '#6c757d' }" />
                            {{ t.nome }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div v-if="calcomPodeCancelar" class="col-md-6 mb-3">
                      <label class="small font-weight-bold d-block mb-2">Cancelar reunião (Cal.com)</label>
                      <div class="ia-tag-picker">
                        <div
                          v-for="t in tagsFiltradasElis"
                          :key="'el-c-' + t.id"
                          class="custom-control custom-checkbox ia-tag-picker__item"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'ia-elis-cancelar_reuniao-' + t.id"
                            :checked="isToolTagSelected('cancelar_reuniao', t.id)"
                            @change="toggleToolTag('cancelar_reuniao', t.id)"
                          />
                          <label class="custom-control-label ia-tag-picker__label" :for="'ia-elis-cancelar_reuniao-' + t.id">
                            <span class="ia-tag-dot" :style="{ backgroundColor: t.cor || '#6c757d' }" />
                            {{ t.nome }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Tarefas automáticas ao executar ferramentas (Elis) -->
            <div class="form-group">
              <div
                class="tool-task-automation-card"
                :class="{ 'tool-task-automation-card--disabled': !form.toolTasksEnabled }"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <div class="pr-3">
                    <label class="mb-1" style="font-weight: 600; font-size: 1.3rem;">Tarefas automáticas por ferramenta</label>
                    <p class="text-muted small mb-0">
                      Quando a IA executar uma ferramenta com sucesso, este treinamento poderá criar tarefas vinculadas à oportunidade.
                    </p>
                  </div>
                  <span
                    class="badge"
                    :class="form.toolTasksEnabled ? 'badge-success' : 'badge-secondary'"
                  >
                    {{ form.toolTasksEnabled ? 'Ativado' : 'Desativado' }}
                  </span>
                </div>

                <div class="mt-3">
                  <Check
                    v-model="form.toolTasksEnabled"
                    :description="form.toolTasksEnabled
                      ? 'As ferramentas ativas abaixo podem receber regras de criação de tarefas.'
                      : 'Nenhuma tarefa será criada por tools deste treinamento enquanto estiver desativado.'"
                  >
                    Criar tarefas por execução de tools
                  </Check>
                </div>
              </div>

              <div v-if="form.toolTasksEnabled && !toolKeysForTaskConfig.length" class="text-muted small">
                Ative uma ferramenta para configurar tarefas automáticas.
              </div>
              <div v-else-if="form.toolTasksEnabled" class="row">
                <div
                  v-for="toolKey in toolKeysForTaskConfig"
                  :key="'task-' + toolKey"
                  class="col-md-6 mb-3"
                >
                  <div class="tool-task-config-card">
                    <div>
                      <strong>{{ toolTaskToolLabel(toolKey) }}</strong>
                      <small class="text-muted d-block">{{ toolTaskSummary(toolKey) }}</small>
                    </div>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary"
                      @click="abrirModalToolTasks(toolKey)"
                    >
                      Configurar tarefas
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Fases e Atendentes -->
            <div class="form-row">
              <!-- === Fase ao finalizar locação === -->
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Fase ao finalizar locação</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Pipeline</label>
                    <select class="form-control" v-model="form.pipelineWhenToEndLease" @change="onPipelineChangeLoadFases('endLease')">
                      <option value="">– Nenhuma pipeline –</option>
                      <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Fase</label>
                    <select
                      class="form-control"
                      v-model="form.phaseWhenToEndLease"
                      :disabled="!form.pipelineWhenToEndLease"
                    >
                      <option value="">– Nenhuma fase –</option>
                      <option v-for="f in fases.endLease" :key="f.id" :value="f.id">{{ f.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- === Fase ao gerar orçamento === -->
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Fase ao gerar orçamento</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Pipeline</label>
                    <select class="form-control" v-model="form.pipelineWhenGenerateBudget" @change="onPipelineChangeLoadFases('generateBudget')">
                      <option value="">– Nenhuma pipeline –</option>
                      <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Fase</label>
                    <select
                      class="form-control"
                      v-model="form.phaseWhenGenerateBudget"
                      :disabled="!form.pipelineWhenGenerateBudget"
                    >
                      <option value="">– Nenhuma fase –</option>
                      <option v-for="f in fases.generateBudget" :key="f.id" :value="f.id">{{ f.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- === Fase quando offline === -->
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Fase quando o cliente ficar offline</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Pipeline</label>
                    <select class="form-control" v-model="form.pipelineWhenOffline" @change="onPipelineChangeLoadFases('offline')">
                      <option value="">– Nenhuma pipeline –</option>
                      <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Fase</label>
                    <select
                      class="form-control"
                      v-model="form.offlinePhase"
                      :disabled="!form.pipelineWhenOffline"
                    >
                      <option value="">– Nenhuma fase –</option>
                      <option v-for="f in fases.offline" :key="f.id" :value="f.id">{{ f.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- === Fase ao pedir humano === -->
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Fase quando cliente quiser falar com um consultor</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Pipeline</label>
                    <select class="form-control" v-model="form.pipelineWhenWantsAttendant" @change="onPipelineChangeLoadFases('human')">
                      <option value="">– Nenhuma pipeline –</option>
                      <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Fase</label>
                    <select
                      class="form-control"
                      v-model="form.phaseWhenWantsAttendant"
                      :disabled="!form.pipelineWhenWantsAttendant"
                    >
                      <option value="">– Nenhuma fase –</option>
                      <option v-for="f in fases.human" :key="f.id" :value="f.id">{{ f.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- === Atendentes === -->
              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Atendente quando for finalizada a locação</label>
                <Check
                  v-model="form.attendantBalanceamentoFinalizarLocacao"
                  description="Usa a mesma regra do Bot (carteira B2B, config da loja/pipeline). Requer atribuição automática ativa."
                  @change="onToggleBalanceamentoAtendente('attendantWhenEndLease', form.attendantBalanceamentoFinalizarLocacao)"
                >
                  Atribuir por balanceamento de carga (igual Bot)
                </Check>
                <select
                  class="form-control mt-2"
                  v-model="form.attendantWhenEndLease"
                  :disabled="form.attendantBalanceamentoFinalizarLocacao"
                >
                  <option disabled value="">Selecione um atendente</option>
                  <option :value="null">– Nenhum atendente –</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">
                    {{ u.name }} ({{ u.email }})
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Atendente ao gerar orçamento</label>
                <Check
                  v-model="form.attendantBalanceamentoGerarOrcamento"
                  description="Usa a mesma regra do Bot (carteira B2B, config da loja/pipeline). Requer atribuição automática ativa."
                  @change="onToggleBalanceamentoAtendente('attendantWhenGenerateBudget', form.attendantBalanceamentoGerarOrcamento)"
                >
                  Atribuir por balanceamento de carga (igual Bot)
                </Check>
                <select
                  class="form-control mt-2"
                  v-model="form.attendantWhenGenerateBudget"
                  :disabled="form.attendantBalanceamentoGerarOrcamento"
                >
                  <option disabled value="">Selecione um atendente</option>
                  <option :value="null">– Nenhum atendente –</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">
                    {{ u.name }} ({{ u.email }})
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Atendente quando o cliente ficar offline</label>
                <Check
                  v-model="form.attendantBalanceamentoOffline"
                  description="Usa a mesma regra do Bot (carteira B2B, config da loja/pipeline). Requer atribuição automática ativa."
                  @change="onToggleBalanceamentoAtendente('attendantWhenOffline', form.attendantBalanceamentoOffline)"
                >
                  Atribuir por balanceamento de carga (igual Bot)
                </Check>
                <select
                  class="form-control mt-2"
                  v-model="form.attendantWhenOffline"
                  :disabled="form.attendantBalanceamentoOffline"
                >
                  <option disabled value="">Selecione um atendente</option>
                  <option :value="null">– Nenhum atendente –</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">
                    {{ u.name }} ({{ u.email }})
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Atendente quando cliente quiser falar com um consultor</label>
                <Check
                  v-model="form.attendantBalanceamentoConsultor"
                  description="Usa a mesma regra do Bot (carteira B2B, config da loja/pipeline). Requer atribuição automática ativa."
                  @change="onToggleBalanceamentoAtendente('wantsAttendant', form.attendantBalanceamentoConsultor)"
                >
                  Atribuir por balanceamento de carga (igual Bot)
                </Check>
                <select
                  class="form-control mt-2"
                  v-model="form.wantsAttendant"
                  :disabled="form.attendantBalanceamentoConsultor"
                >
                  <option disabled value="">Selecione um atendente</option>
                  <option :value="null">– Nenhum atendente –</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">
                    {{ u.name }} ({{ u.email }})
                  </option>
                </select>
              </div>
            </div>

            <!-- Ações Customizadas -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Ações Customizadas</label>
              <div class="row">
                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-start h-100">
                    <Check
                      v-model="form.sendProductPrice"
                      description="Envia o preço do produto diretamente para o cliente."
                    >
                      Enviar Preço do Produto
                    </Check>
                  </div>
                </div>

                <div class="col-md-4 mb-2 d-flex align-items-stretch">
                  <Check
                    v-model="form.sendImageInListing"
                    description="Envia imagem dos produtos na listagem para o cliente."
                  >
                    Enviar imagem
                  </Check>
                </div>

                <div
                  v-if="form.sendImageInListing || form.tools.includes('enviar_foto_equipamento')"
                  class="col-md-4 mb-2 d-flex align-items-stretch"
                >
                  <Check
                    v-model="form.sendAllProductImages"
                    description="Envia a foto principal e todas as imagens da galeria do produto. Desmarcado, envia apenas a principal."
                  >
                    Enviar todas as fotos do produto
                  </Check>
                </div>

                <div class="col-md-4 mb-2 d-flex align-items-stretch">
                  <Check
                    v-model="form.sendDocumentBudgetConversation"
                    description="Ao gerar um orçamento, o documento será enviado automaticamente na conversa com o cliente."
                  >
                    Enviar documento do orçamento
                  </Check>
                </div>
              </div>
              <div v-if="form.sendDocumentBudgetConversation" class="row">
                <div class="col-md-12 mb-2">
                  <label class="d-block font-weight-bold">Modelo de orçamento para envio na conversa</label>
                  <select class="form-control" v-model="form.modeloOrcamentoEnvioConversaId">
                    <option value="">Modelo padrão do sistema</option>
                    <option v-for="m in modelosOrcamentoDisponiveis" :key="m.id" :value="String(m.id)">
                      {{ m.nome }}
                    </option>
                  </select>
                  <small class="text-muted d-block mt-1">
                    Define o modelo padrão da impressão ou um template importado para o PDF enviado no WhatsApp.
                  </small>
                </div>
              </div>
            </div>

            <!-- Exibição dos Equipamentos -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Exibição dos Equipamentos</label>
              <select class="form-control" v-model.number="form.displayExibition">
                <option v-for="opt in displayOptions" :key="opt.id" :value="opt.id">
                  {{ opt.label }}
                </option>
              </select>
              <small class="text-muted d-block mt-1">
                Define de onde a IA buscará os equipamentos, Loja, CRM ou ambos.
              </small>
            </div>

            <!-- Cobrança por Tempo de Chat -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Cobrança por Tempo de Chat</label>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Intervalo entre cobranças (segundos)</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="form.chargeChatTime"
                    min="0"
                    step="1"
                    placeholder="Ex.: 60"
                  />
                  <small class="text-muted">Tempo mínimo entre uma cobrança e outra.</small>
                </div>
                <div class="form-group col-md-6">
                  <label>Tentativas consecutivas de cobrança</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="form.chargeChatRetrys"
                    min="0"
                    step="1"
                    placeholder="Ex.: 2"
                  />
                  <small class="text-muted">Quantas vezes cobrar em sequência antes de parar.</small>
                </div>
              </div>
            </div>

            <!-- Proteção -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Comportamento de Proteção</label>
              <select class="form-control" v-model="form.sendTypeProtection">
                <option value="NON_BUILT_IN_PROTECTION">Não informar proteção</option>
                <option value="BUILT_IN_WITH_PRICE">Proteção embutida no preço</option>
                <option value="BUILT_IN_SEPARATE">Proteção separada</option>
              </select>
            </div>

            <!-- Botão Salvar -->
            <div class="form-group mt-4 text-right">
              <button
                v-if="selectedTrainingId"
                class="btn btn-success btn-sm mr-2"
                @click="atualizarTreinamento"
              >
                <i class="fa fa-save mr-1"></i> Atualizar Treinamento
              </button>

              <button
                v-else
                class="btn btn-success btn-sm mr-2"
                @click="salvarTreinamento"
              >
                <i class="fa fa-save mr-1"></i> Salvar Treinamento
              </button>

              <button
                v-if="selectedTrainingId"
                class="btn btn-danger btn-sm"
                data-toggle="modal"
                data-target="#modalConfirmarDelecao"
              >
                <i class="fa fa-trash mr-1"></i> Deletar Treinamento
              </button>
            </div>
          </div>

          <!-- Modal Configurar Finalização de Locação -->
          <div v-if="mostrarModalFinalizarLocacao" class="custom-modal-overlay">
            <div class="custom-modal window.theme custom-modal-finalizar-locacao" style="max-width: 1000px;">
              <div class="custom-modal-header">
                <h5 class="m-0">Configurar Finalização de Locação</h5>
                <button class="btn btn-sm btn-danger" @click="fecharModalFinalizarLocacao">&times;</button>
              </div>

              <!-- Tabs de Navegação -->
              <div class="custom-modal-tabs">
                <button
                  class="tab-button"
                  :class="{ active: abaAtivaFinalizarLocacao === 'documentos' }"
                  @click="abaAtivaFinalizarLocacao = 'documentos'"
                >
                  <i class="fa fa-file mr-2"></i> Documentos
                </button>
                <button
                  class="tab-button"
                  :class="{ active: abaAtivaFinalizarLocacao === 'validacoes' }"
                  @click="abaAtivaFinalizarLocacao = 'validacoes'"
                >
                  <i class="fa fa-check-circle mr-2"></i> Validações
                </button>
                <button
                  class="tab-button"
                  :class="{ active: abaAtivaFinalizarLocacao === 'acoes' }"
                  @click="abaAtivaFinalizarLocacao = 'acoes'"
                >
                  <i class="fa fa-cog mr-2"></i> Ações Automáticas
                </button>
              </div>

              <div class="custom-modal-body">
              <!-- Página: Documentos Obrigatórios -->
              <div v-show="abaAtivaFinalizarLocacao === 'documentos'" class="tab-content">
                <h6 class="mb-4">Documentos Obrigatórios</h6>
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="exigir_cnh"
                      v-model="form.finalizarLocacaoConfig.exigir_cnh"
                    />
                    <label class="custom-control-label" for="exigir_cnh">
                      Exigir CNH (Carteira Nacional de Habilitação)
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    A IA processará automaticamente imagens de CNH enviadas pelo cliente usando OCR.
                  </small>
                  <div v-if="form.finalizarLocacaoConfig.exigir_cnh" class="mt-2">
                    <label for="periodicidade_cnh" class="small font-weight-bold">Periodicidade de exigência:</label>
                    <select
                      id="periodicidade_cnh"
                      class="form-control form-control-sm"
                      v-model="form.finalizarLocacaoConfig.periodicidade_cnh"
                    >
                      <option v-for="opcao in opcoesPeriodicidade" :key="opcao.value" :value="opcao.value">
                        {{ opcao.label }}
                      </option>
                    </select>
                    <small class="text-muted d-block mt-1">
                      Se o cliente já tiver CNH válida dentro do período, não será solicitada novamente.
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="exigir_comprovante_residencia"
                      v-model="form.finalizarLocacaoConfig.exigir_comprovante_residencia"
                    />
                    <label class="custom-control-label" for="exigir_comprovante_residencia">
                      Exigir Comprovante de Residência
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    A IA processará automaticamente comprovantes (luz, água, telefone, etc.) e validará o endereço.
                  </small>
                  <div v-if="form.finalizarLocacaoConfig.exigir_comprovante_residencia" class="mt-2">
                    <label for="periodicidade_comprovante" class="small font-weight-bold">Periodicidade de exigência:</label>
                    <select
                      id="periodicidade_comprovante"
                      class="form-control form-control-sm"
                      v-model="form.finalizarLocacaoConfig.periodicidade_comprovante"
                    >
                      <option v-for="opcao in opcoesPeriodicidade" :key="opcao.value" :value="opcao.value">
                        {{ opcao.label }}
                      </option>
                    </select>
                    <small class="text-muted d-block mt-1">
                      Se o cliente já tiver comprovante válido dentro do período, não será solicitado novamente.
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="exigir_reconhecimento_facial"
                      v-model="form.finalizarLocacaoConfig.exigir_reconhecimento_facial"
                    />
                    <label class="custom-control-label" for="exigir_reconhecimento_facial">
                      Exigir reconhecimento facial
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    Gera um link para o cliente realizar reconhecimento facial antes de finalizar a locação. Após concluir, a IA informará que a face está em análise.
                  </small>
                </div>
              </div>

              <!-- Página: Validações Automáticas -->
              <div v-show="abaAtivaFinalizarLocacao === 'validacoes'" class="tab-content">
                <h6 class="mb-4">Validações Automáticas</h6>
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="fazer_consulta_serasa"
                      v-model="form.finalizarLocacaoConfig.fazer_consulta_serasa"
                    />
                    <label class="custom-control-label" for="fazer_consulta_serasa">
                      Fazer consulta no Serasa/Eloca Score
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    Realiza consulta de score de crédito automaticamente após receber os documentos.
                  </small>
                </div>

                <div class="form-group" v-if="form.finalizarLocacaoConfig.fazer_consulta_serasa">
                  <label>Score mínimo exigido</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="form.finalizarLocacaoConfig.score_minimo_aprovacao"
                    min="1"
                    max="1000"
                    placeholder="Ex: 600"
                  />
                  <small class="text-muted d-block mt-1">
                    Score mínimo que o cliente deve ter para aprovação da documentação (1 a 1000).
                  </small>
                </div>

                <div class="form-group" v-if="form.finalizarLocacaoConfig.fazer_consulta_serasa">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="nao_aprovar_pendencias"
                      v-model="form.finalizarLocacaoConfig.nao_aprovar_pendencias"
                    />
                    <label class="custom-control-label" for="nao_aprovar_pendencias">
                      Não aprovar quando houver pendência jurídica ou registro de dívida
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    Bloqueia aprovação automática se houver registros de débitos ou pendências judiciais.
                  </small>
                </div>

                <div class="form-group" v-if="form.finalizarLocacaoConfig.fazer_consulta_serasa">
                  <label>Limite de consultas para redflag</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="form.finalizarLocacaoConfig.limite_consultas_redflag"
                    min="1"
                    step="1"
                    placeholder="Ex: 30"
                  />
                  <small class="text-muted d-block mt-1">
                    Alerta quando o cliente tiver sido consultado muitas vezes. Padrão: 30 consultas.
                  </small>
                </div>

                <div class="form-group" v-if="form.finalizarLocacaoConfig.fazer_consulta_serasa">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="aprovacao_automatica"
                      v-model="form.finalizarLocacaoConfig.aprovacao_automatica"
                    />
                    <label class="custom-control-label" for="aprovacao_automatica">
                      Aprovar automaticamente se score for adequado
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    Aprova automaticamente se atender todas as validações configuradas acima.
                  </small>
                </div>
              </div>

              <!-- Página: Ações Automáticas -->
              <div v-show="abaAtivaFinalizarLocacao === 'acoes'" class="tab-content">
                <h6 class="mb-4">Ações Automáticas</h6>
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="gerar_orcamento_automatico"
                      v-model="form.finalizarLocacaoConfig.gerar_orcamento_automatico"
                    />
                    <label class="custom-control-label" for="gerar_orcamento_automatico">
                      Gerar orçamento automaticamente
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    Cria o orçamento/proposta automaticamente com base nos produtos mencionados na conversa.
                  </small>
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="criar_cliente_auto"
                      v-model="form.finalizarLocacaoConfig.criar_cliente_auto"
                    />
                    <label class="custom-control-label" for="criar_cliente_auto">
                      Criar cliente automaticamente se não existir
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    Cria registro de cliente automaticamente com dados extraídos da conversa.
                  </small>
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="buscar_ccl"
                      v-model="form.finalizarLocacaoConfig.buscar_ccl"
                    />
                    <label class="custom-control-label" for="buscar_ccl">
                      Buscar cotações no CCL automaticamente
                    </label>
                  </div>
                  <small class="text-muted d-block mt-1">
                    Envia dados automaticamente para o CCL para obter cotações.
                  </small>
                </div>
              </div>
              </div>

              <div class="custom-modal-footer">
                <button class="btn btn-secondary btn-sm mr-2" @click="fecharModalFinalizarLocacao">
                  Cancelar
                </button>
                <button class="btn btn-primary btn-sm" @click="salvarConfigFinalizarLocacao">
                  Salvar Configuração
                </button>
              </div>
            </div>
          </div>

          <!-- Modal Contrato para assinatura (IA) -->
          <div v-if="mostrarModalContratoAssinatura" class="custom-modal-overlay">
            <div class="custom-modal window.theme" style="max-width: 640px;">
              <div class="custom-modal-header">
                <h5 class="m-0">Configurar envio de contrato para assinatura</h5>
                <button class="btn btn-sm btn-danger" type="button" @click="fecharModalContratoAssinatura">&times;</button>
              </div>
              <div class="custom-modal-body">
                <p class="text-muted small">
                  O link será enviado pelo WhatsApp do atendimento em curso. Se o canal exigir template HSM com variável de link, informe o ID do template aprovado.
                </p>
                <div class="form-group">
                  <label class="font-weight-bold">Origem do documento</label>
                  <div>
                    <label class="mr-3">
                      <input type="radio" v-model="form.contratoAssinaturaModo" value="modelo" />
                      Modelo da loja
                    </label>
                    <label>
                      <input type="radio" v-model="form.contratoAssinaturaModo" value="anexar" />
                      Anexar novo
                    </label>
                  </div>
                </div>
                <div v-if="form.contratoAssinaturaModo === 'modelo'" class="form-group">
                  <label>Modelo de contrato</label>
                  <select v-model="form.contratoAssinaturaModeloId" class="form-control">
                    <option value="">Selecione…</option>
                    <option v-for="m in modelosContratoDisponiveis" :key="m.id" :value="String(m.id)">{{ m.nome }}</option>
                  </select>
                </div>
                <div v-else class="form-group">
                  <label>Arquivo (PDF, DOC ou DOCX)</label>
                  <input ref="inputContratoAssinatura" type="file" class="form-control-file" accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
                  <small v-if="form.contratoAssinaturaArquivoNome" class="text-muted d-block mt-1">
                    Atual: {{ form.contratoAssinaturaArquivoNome }}
                  </small>
                </div>
                <div class="form-group">
                  <label>ID template HSM (opcional)</label>
                  <input v-model="form.contratoAssinaturaTemplateId" type="text" class="form-control" placeholder="Somente se o canal exigir template" />
                </div>
              </div>
              <div class="custom-modal-footer">
                <button class="btn btn-secondary btn-sm mr-2" type="button" @click="fecharModalContratoAssinatura">Cancelar</button>
                <button class="btn btn-primary btn-sm" type="button" @click="confirmarModalContratoAssinatura">Salvar</button>
              </div>
            </div>
          </div>

          <!-- Modal Redirecionar Outros Assuntos -->
          <div v-if="mostrarModalRedirecionamento" class="custom-modal-overlay">
            <div class="custom-modal window.theme">
              <div class="modal-header-custom">
                <div class="d-flex align-items-center">
                  <i class="fa fa-cog mr-2 text-primary" style="font-size: 1.5rem;"></i>
                  <h5 class="m-0">Configurar Redirecionamento de Outros Assuntos</h5>
                </div>
                <button class="btn btn-sm btn-close-modal" @click="mostrarModalRedirecionamento = false">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <div class="modal-body-custom">
                <!-- Formulário de Novo Redirecionamento -->
                <div class="config-section">
                  <div class="section-header">
                    <i class="fa fa-plus-circle mr-2 text-success"></i>
                    <label class="section-title">Adicionar Novo Redirecionamento</label>
                  </div>
                  <div class="section-content">
                    <div class="form-group">
                      <label class="form-label-custom">
                        <i class="fa fa-sitemap mr-1"></i>Pipeline
                        <span class="text-danger">*</span>
                      </label>
                      <select class="form-control form-control-custom" v-model="novoRedirecionamento.pipelineId" @change="onPipelineChangeLoadFases('redirect')">
                        <option value="" disabled>Selecione um pipeline</option>
                        <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label class="form-label-custom">
                        <i class="fa fa-tasks mr-1"></i>Fase
                        <span class="text-danger">*</span>
                      </label>
                      <select class="form-control form-control-custom" v-model="novoRedirecionamento.faseId" :disabled="fases.redirect.length === 0">
                        <option value="" disabled>Selecione uma fase</option>
                        <option v-for="f in fases.redirect" :key="f.id" :value="f.id">{{ f.nome }}</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <Check
                        v-model="novoRedirecionamento.atribuir_por_balanceamento"
                        description="Usa a mesma regra do Bot para este destino."
                        @change="onToggleBalanceamentoRedirecionamento"
                      >
                        Atribuir por balanceamento de carga (igual Bot)
                      </Check>
                    </div>

                    <div v-if="!novoRedirecionamento.atribuir_por_balanceamento" class="form-group">
                      <label class="form-label-custom">
                        <i class="fa fa-user mr-1"></i>Atendente (opcional)
                      </label>
                      <select class="form-control form-control-custom" v-model="novoRedirecionamento.atendenteId" @change="novoRedirecionamento.userId = novoRedirecionamento.atendenteId">
                        <option value="">Selecione um atendente</option>
                        <option v-for="u in usuarios" :key="u.id" :value="u.id">{{ u.name }} ({{ u.email }})</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label class="form-label-custom">
                        <i class="fa fa-align-left mr-1"></i>Descrição
                        <span class="text-danger">*</span>
                      </label>
                      <input 
                        class="form-control form-control-custom" 
                        v-model="novoRedirecionamento.descricao" 
                        placeholder="Breve explicação sobre este redirecionamento..." 
                      />
                    </div>

                    <div v-if="tagsTreinamento.length" class="form-group">
                      <label class="form-label-custom">
                        <i class="fa fa-tags mr-1"></i>Tags na oportunidade (opcional)
                      </label>
                      <input
                        v-if="tagsTreinamento.length > 6"
                        type="search"
                        class="form-control form-control-sm ia-tag-search mb-2"
                        v-model.trim="tagPickerSearchRedirect"
                        placeholder="Filtrar tags..."
                        autocomplete="off"
                      />
                      <div class="ia-tag-picker ia-tag-picker--modal">
                        <div
                          v-for="t in tagsFiltradasRedirect"
                          :key="'nr-' + t.id"
                          class="custom-control custom-checkbox ia-tag-picker__item"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'ia-novo-redir-' + t.id"
                            :checked="isNovoRedirecionamentoTagSelected(t.id)"
                            @change="toggleNovoRedirecionamentoTag(t.id)"
                          />
                          <label class="custom-control-label ia-tag-picker__label" :for="'ia-novo-redir-' + t.id">
                            <span class="ia-tag-dot" :style="{ backgroundColor: t.cor || '#6c757d' }" />
                            {{ t.nome }}
                          </label>
                        </div>
                        <p v-if="!tagsFiltradasRedirect.length" class="text-muted small mb-0 px-1">Nenhuma tag com esse filtro.</p>
                      </div>
                      <small class="text-muted d-block mt-1">Aplicadas quando este redirecionamento for executado com sucesso.</small>
                    </div>

                    <div class="text-right mt-3">
                      <button class="btn btn-primary btn-sm" @click="adicionarRedirecionamento">
                        <i class="fa fa-plus mr-1"></i>Adicionar
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Lista de Redirecionamentos -->
                <div v-if="form.redirecionamentos.length > 0" class="config-section">
                  <div class="section-header">
                    <i class="fa fa-list mr-2 text-info"></i>
                    <label class="section-title">Redirecionamentos Adicionados</label>
                    <span class="badge badge-primary ml-2">{{ form.redirecionamentos.length }}</span>
                  </div>
                  <div class="section-content">
                    <div class="redirecionamentos-list-container">
                      <div 
                        v-for="(r, idx) in form.redirecionamentos" 
                        :key="idx" 
                        class="redirecionamento-item"
                      >
                        <div class="redirecionamento-content">
                          <div class="redirecionamento-info">
                            <div class="redirecionamento-field">
                              <i class="fa fa-sitemap mr-2 text-primary"></i>
                              <strong>Pipeline:</strong> {{ nomePipeline(r.pipelineId) }}
                            </div>
                            <div class="redirecionamento-field">
                              <i class="fa fa-tasks mr-2 text-info"></i>
                              <strong>Fase:</strong> {{ nomeFase('redirect', r.faseId, r.pipelineId) }}
                            </div>
                            <div class="redirecionamento-field">
                              <i class="fa fa-user mr-2 text-success"></i>
                              <strong>Atribuição:</strong>
                              <span
                                v-if="r.atribuir_por_balanceamento"
                                class="badge badge-info ml-1"
                              >Balanceamento</span>
                              <span v-else-if="r.userId || r.atendenteId">
                                {{ nomeAtendente(r.userId ?? r.atendenteId) }}
                              </span>
                              <span v-else class="text-muted">Sem atendente fixo</span>
                            </div>
                            <div class="redirecionamento-field">
                              <i class="fa fa-align-left mr-2 text-secondary"></i>
                              <strong>Descrição:</strong> 
                              <span class="text-muted">{{ r.descricao }}</span>
                            </div>
                            <div v-if="tagsTreinamento.length" class="redirecionamento-field w-100 mt-2">
                              <label class="small d-block mb-1"><strong>Tags ao redirecionar</strong></label>
                              <small class="text-muted d-block mb-1">Somente visualização. Para alterar, remova o redirecionamento e adicione novamente.</small>
                              <div class="ia-tag-picker ia-tag-picker--inline ia-tag-picker--disabled">
                                <div
                                  v-for="t in tagsTreinamento"
                                  :key="'r-' + idx + '-' + t.id"
                                  class="custom-control custom-checkbox ia-tag-picker__item"
                                >
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    :id="'ia-redir-row-' + idx + '-' + t.id"
                                    :checked="isRedirecionamentoRowTagSelected(idx, t.id)"
                                    disabled
                                    tabindex="-1"
                                  />
                                  <label class="custom-control-label ia-tag-picker__label ia-tag-picker__label--disabled" :for="'ia-redir-row-' + idx + '-' + t.id">
                                    <span class="ia-tag-dot" :style="{ backgroundColor: t.cor || '#6c757d' }" />
                                    {{ t.nome }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button class="btn btn-sm btn-outline-danger btn-remove" @click="removerRedirecionamento(idx)">
                            <i class="fa fa-trash mr-1"></i>Remover
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer-custom">
                <button class="btn btn-secondary btn-sm" @click="mostrarModalRedirecionamento = false">
                  <i class="fa fa-times mr-1"></i>Fechar
                </button>
              </div>
            </div>
          </div>

          <!-- Modal opções Buscar Equipamento -->
          <div v-if="mostrarModalBuscaEquipamento" class="custom-modal-overlay">
            <div class="custom-modal window.theme" style="max-width: 560px;">
              <div class="modal-header-custom">
                <div class="d-flex align-items-center">
                  <i class="fa fa-cog mr-2 text-primary" style="font-size: 1.5rem;"></i>
                  <h5 class="m-0">Configurar Busca de Equipamento</h5>
                </div>
                <button type="button" class="btn btn-sm btn-close-modal" @click="mostrarModalBuscaEquipamento = false">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <div class="modal-body-custom">
                <p class="text-muted small mb-3">
                  Quando a tool estiver ativa, estes dados entram no contexto enviado à IA logo após a busca (mensagem seguinte ao cliente).
                </p>
                <div class="form-group mb-2">
                  <Check
                    v-model="form.buscarEquipamentoIncluirDescricao"
                    description="Inclui resumo e descrição do produto no JSON para a IA usar na mensagem ao cliente."
                  >
                    Incluir descrição do equipamento
                  </Check>
                </div>
                <div class="form-group mb-2">
                  <Check
                    v-model="form.buscarEquipamentoIncluirAcessorios"
                    description="Inclui acessórios vinculados (nome, obrigatoriedade, valores) para a IA mencionar quando fizer sentido."
                  >
                    Incluir acessórios vinculados
                  </Check>
                </div>
                <div class="form-group mb-2">
                  <Check
                    v-model="form.buscarEquipamentoIncluirLinkEcommerce"
                    description="Inclui o link da página do produto no ecommerce para a IA poder enviar ao cliente após a busca, sem precisar chamar a tool de link online."
                  >
                    Incluir link do ecommerce
                  </Check>
                </div>
                <hr>
                <div class="form-group mb-2">
                  <label class="form-label-custom">
                    <i class="fa fa-filter mr-1"></i>Limitar busca por categorias
                  </label>
                  <p class="text-muted small mb-2">
                    Sem categorias marcadas, a IA continua vendo todos os produtos permitidos pela configuração de Exibição dos Equipamentos.
                  </p>
                  <div v-if="loadingCategoriasProdutos" class="text-muted small">Carregando categorias...</div>
                  <div v-else-if="!categoriasProdutos.length" class="text-muted small">Cadastre categorias ativas na loja para limitar a busca.</div>
                  <div v-else>
                    <select
                      class="form-control form-control-sm mb-2"
                      v-model="form.buscarEquipamentoCategoriaMatchMode"
                      :disabled="!form.buscarEquipamentoCategoriaIds.length"
                    >
                      <option
                        v-for="opt in categoriaMatchOptions"
                        :key="opt.value"
                        :value="opt.value"
                      >
                        {{ opt.label }}
                      </option>
                    </select>

                    <input
                      v-if="categoriasProdutos.length > 6"
                      type="search"
                      class="form-control form-control-sm ia-tag-search mb-2"
                      v-model.trim="categoriaPickerSearchBuscaEquipamento"
                      placeholder="Filtrar categorias por nome..."
                      autocomplete="off"
                    />

                    <div class="ia-tag-picker ia-tag-picker--modal">
                      <div
                        v-for="categoria in categoriasProdutosFiltradas"
                        :key="'categoria-busca-' + categoria.id"
                        class="custom-control custom-checkbox ia-tag-picker__item"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="'ia-categoria-busca-' + categoria.id"
                          :checked="isCategoriaBuscaEquipamentoSelected(categoria.id)"
                          @change="toggleCategoriaBuscaEquipamento(categoria.id)"
                        />
                        <label class="custom-control-label ia-tag-picker__label" :for="'ia-categoria-busca-' + categoria.id">
                          {{ categoria.nome }}
                        </label>
                      </div>
                      <p v-if="!categoriasProdutosFiltradas.length" class="text-muted small mb-0 px-1">Nenhuma categoria com esse filtro.</p>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <Check
                    v-model="form.buscarEquipamentoAnalisarCustoBeneficio"
                    description="Compara faixas quando o cliente informar quantos dias precisa e sugere economia (ex.: 5 diárias vs. pacote semanal) na resposta da busca."
                  >
                    Sugerir melhor período quando houver economia
                  </Check>
                </div>
              </div>

              <div class="modal-footer-custom">
                <button type="button" class="btn btn-primary btn-sm" @click="mostrarModalBuscaEquipamento = false">
                  <i class="fa fa-check mr-1"></i>Ok
                </button>
              </div>
            </div>
          </div>

          <!-- Modal Configuração Cal.com -->
          <div v-if="mostrarModalCalcom" class="custom-modal-overlay">
            <div class="custom-modal window.theme calcom-modal">
              <div class="modal-header-custom">
                <div class="d-flex align-items-center">
                  <i class="fa fa-cog mr-2 text-primary" style="font-size: 1.5rem;"></i>
                  <h5 class="m-0">Configurar Integração Cal.com</h5>
                </div>
                <button class="btn btn-sm btn-close-modal" @click="fecharModalCalcom">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <div class="modal-body-custom">
                <!-- Token -->
                <div class="config-section">
                  <div class="section-header">
                    <i class="fa fa-key mr-2 text-warning"></i>
                    <label class="section-title">
                      Token de Autenticação
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="section-content">
                    <div class="input-group-token">
                      <div class="input-wrapper">
                        <i class="fa fa-lock input-icon"></i>
                        <input
                          type="password"
                          class="form-control input-token"
                          v-model="calcomToken"
                          placeholder="Cole o token do Cal.com aqui"
                          :disabled="calcomValidandoToken"
                        />
                        <button
                          class="btn btn-primary btn-validate-token"
                          type="button"
                          @click="validarTokenCalcom"
                          :disabled="!calcomToken || calcomToken.trim() === '' || calcomValidandoToken"
                        >
                          <span v-if="calcomValidandoToken" class="spinner-border spinner-border-sm mr-1"></span>
                          <i v-else class="fa fa-check-circle mr-1"></i>
                          {{ calcomValidandoToken ? 'Validando...' : 'Validar' }}
                        </button>
                      </div>
                      <div class="help-text">
                        <i class="fa fa-info-circle mr-1"></i>
                        O token pode ser encontrado em: <strong>Settings > Security > API Keys</strong> no Cal.com
                      </div>
                      <div v-if="calcomTokenValido" class="alert alert-success-custom mt-2 mb-0">
                        <i class="fa fa-check-circle mr-2"></i>
                        <strong>Token válido!</strong> Você pode continuar com a configuração.
                      </div>
                      <div v-if="calcomTokenInvalido" class="alert alert-danger-custom mt-2 mb-0">
                        <i class="fa fa-times-circle mr-2"></i>
                        <strong>Token inválido.</strong> Verifique e tente novamente.
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Eventos (só aparece se token válido) -->
                <div v-if="calcomTokenValido" class="config-section">
                  <div class="section-header">
                    <i class="fa fa-calendar mr-2 text-primary"></i>
                    <label class="section-title">Eventos Disponíveis</label>
                    <span v-if="calcomEventosSelecionados.length > 0" class="badge badge-primary ml-2">
                      {{ calcomEventosSelecionados.length }} selecionado(s)
                    </span>
                  </div>
                  <div class="section-content">
                    <div v-if="calcomCarregandoEventos" class="loading-container">
                      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                      <span class="ml-2">Carregando eventos...</span>
                    </div>
                    <div v-else-if="calcomEventosDisponiveis.length === 0" class="alert alert-warning-custom">
                      <i class="fa fa-exclamation-triangle mr-2"></i>
                      Nenhum evento encontrado. Verifique se você tem eventos criados no Cal.com.
                    </div>
                    <div v-else class="eventos-list-container">
                      <div
                        v-for="evento in calcomEventosDisponiveis"
                        :key="evento.id"
                        class="evento-card"
                        :class="{ 'evento-selecionado': calcomEventosSelecionados.includes(String(evento.id)) }"
                        @click="toggleEventoSelecionado(evento.id)"
                      >
                        <div class="evento-checkbox-wrapper" @click.stop>
                          <input
                            class="evento-checkbox"
                            type="checkbox"
                            :value="String(evento.id)"
                            :id="'evento-' + evento.id"
                            :checked="calcomEventosSelecionados.includes(String(evento.id))"
                            @change="toggleEventoSelecionado(evento.id)"
                          />
                          <label class="evento-checkbox-label" :for="'evento-' + evento.id"></label>
                        </div>
                        <div class="evento-content">
                          <div class="evento-header">
                            <h6 class="evento-title">
                              <i class="fa fa-calendar mr-2"></i>
                              <span v-if="evento.title">{{ evento.title }}</span>
                              <span v-else-if="evento.slug">{{ evento.slug }}</span>
                              <span v-else class="text-muted">Sem título</span>
                            </h6>
                          </div>
                          <p v-if="evento.description" class="evento-description">
                            {{ evento.description }}
                          </p>
                          <div class="evento-badges">
                            <span class="badge badge-time">
                              <i class="fa fa-eye mr-1"></i>{{ evento.length }} min
                            </span>
                            <span v-if="evento.locations && evento.locations.length > 0" class="badge badge-location">
                              <i class="fa fa-map-marker mr-1"></i>
                              {{ evento.locations[0].type === 'integrations:google:meet' ? 'Google Meet' : evento.locations[0].type === 'inPerson' ? 'Presencial' : evento.locations[0].type }}
                            </span>
                            <span v-if="evento.requiresConfirmation" class="badge badge-warning-badge">
                              <i class="fa fa-check-circle mr-1"></i>Requer confirmação
                            </span>
                          </div>
                          <div v-if="evento.metadata && evento.metadata.multipleDuration" class="evento-durations">
                            <i class="fa fa-info-circle mr-1"></i>
                            <small>Durações: {{ evento.metadata.multipleDuration.join(', ') }} min</small>
                          </div>
                          <button
                            class="btn btn-sm btn-detalhes"
                            @click.stop="verDetalhesEvento(evento)"
                          >
                            <i class="fa fa-info-circle mr-1"></i>Ver Detalhes
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="help-text mt-2">
                      <i class="fa fa-info-circle mr-1"></i>
                      Selecione os eventos que a IA poderá usar para agendamentos. Clique no card para selecionar.
                    </div>
                  </div>
                </div>

                <!-- Permissões (só aparece se token válido) -->
                <div v-if="calcomTokenValido" class="config-section">
                  <div class="section-header">
                    <i class="fa fa-cog mr-2 text-info"></i>
                    <label class="section-title">Permissões da IA</label>
                  </div>
                  <div class="section-content">
                    <div class="permissions-list">
                      <div class="permission-item">
                        <div class="permission-content">
                          <div class="permission-info">
                            <div class="permission-icon-wrapper icon-success">
                              <i class="fa fa-calendar"></i>
                            </div>
                            <div class="permission-text">
                              <h6 class="permission-title">Agendar Reuniões</h6>
                              <small class="permission-description">Permite que a IA crie novos agendamentos com os eventos selecionados</small>
                            </div>
                          </div>
                          <label class="switch">
                            <input type="checkbox" v-model="calcomPodeAgendar" />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      
                      <div class="permission-item">
                        <div class="permission-content">
                          <div class="permission-info">
                            <div class="permission-icon-wrapper icon-danger">
                              <i class="fa fa-times"></i>
                            </div>
                            <div class="permission-text">
                              <h6 class="permission-title">Cancelar Reuniões</h6>
                              <small class="permission-description">Permite que a IA cancele agendamentos existentes</small>
                            </div>
                          </div>
                          <label class="switch">
                            <input type="checkbox" v-model="calcomPodeCancelar" />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      
                      <div class="permission-item">
                        <div class="permission-content">
                          <div class="permission-info">
                            <div class="permission-icon-wrapper icon-info">
                              <i class="fa fa-gavel" aria-hidden="true"></i>
                            </div>
                            <div class="permission-text">
                              <h6 class="permission-title">Sugerir Horários</h6>
                              <small class="permission-description">Permite que a IA sugira horários disponíveis para agendamento</small>
                            </div>
                          </div>
                          <label class="switch">
                            <input type="checkbox" v-model="calcomSugerirHorarios" />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      
                      <div class="permission-item">
                        <div class="permission-content">
                          <div class="permission-info">
                            <div class="permission-icon-wrapper icon-warning">
                              <i class="fa fa-users"></i>
                            </div>
                            <div class="permission-text">
                              <h6 class="permission-title">Permitir Convidados</h6>
                              <small class="permission-description">Permite adicionar convidados aos agendamentos criados pela IA</small>
                            </div>
                          </div>
                          <label class="switch">
                            <input type="checkbox" v-model="calcomPermitirConvidados" />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>

                      <div class="permission-item">
                        <div class="permission-content">
                          <div class="permission-info">
                            <div class="permission-icon-wrapper icon-info">
                              <i class="fa fa-random"></i>
                            </div>
                            <div class="permission-text">
                              <h6 class="permission-title">Distribuir atendentes em rodízio</h6>
                              <small class="permission-description">Quando houver mais de um evento selecionado, a IA agenda sem escolher o evento: o sistema alterna entre eles. Um evento só não muda.</small>
                            </div>
                          </div>
                          <label class="switch">
                            <input type="checkbox" v-model="calcomRoundRobin" />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="(calcomPodeAgendar || calcomPodeCancelar || calcomSugerirHorarios) && calcomEventosSelecionados.length === 0"
                      class="alert alert-warning-custom mt-3 mb-0"
                    >
                      <i class="fa fa-exclamation-triangle mr-2"></i>
                      É necessário selecionar pelo menos um evento quando alguma permissão estiver ativa.
                    </div>
                  </div>
                </div>

                <!-- Configurações de Transferência (só aparece se token válido) -->
                <div v-if="calcomTokenValido" class="config-section">
                  <div class="section-header">
                    <i class="fa fa-book mr-2 text-primary"></i>
                    <label class="section-title">Transferências de Oportunidades</label>
                  </div>
                  <div class="section-content">
                    <!-- Transferência ao Marcar Agenda -->
                    <div class="form-group">
                      <label style="font-weight: 600; font-size: 1.1rem;">
                        <i class="fa fa-calendar-check mr-1"></i>Transferência ao Marcar Agenda
                      </label>
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label>Pipeline</label>
                          <select class="form-control" v-model="calcomPipelineMarcarAgenda" @change="onPipelineChangeLoadFases('calcomMarcar')">
                            <option value="" disabled>Selecione</option>
                            <option :value="null">– Nenhum –</option>
                            <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-6">
                          <label>Fase</label>
                          <select
                            class="form-control"
                            v-model="calcomFaseMarcarAgenda"
                            :disabled="fases.calcomMarcar.length === 0"
                          >
                            <option value="" disabled>Selecione</option>
                            <option :value="null">– Nenhum –</option>
                            <option v-for="f in fases.calcomMarcar" :key="f.id" :value="f.id">{{ f.nome }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Atendente</label>
                        <select class="form-control" v-model="calcomAtendenteMarcarAgenda">
                          <option value="" disabled>Selecione um atendente</option>
                          <option :value="null">– Nenhum atendente –</option>
                          <option v-for="u in usuarios" :key="u.id" :value="u.id">
                            {{ u.name }} ({{ u.email }})
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Transferência ao Cancelar Agenda -->
                    <div class="form-group">
                      <label style="font-weight: 600; font-size: 1.1rem;">
                        <i class="fa fa-calendar-times mr-1"></i>Transferência ao Cancelar Agenda
                      </label>
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label>Pipeline</label>
                          <select class="form-control" v-model="calcomPipelineCancelarAgenda" @change="onPipelineChangeLoadFases('calcomCancelar')">
                            <option value="" disabled>Selecione</option>
                            <option :value="null">– Nenhum –</option>
                            <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-6">
                          <label>Fase</label>
                          <select
                            class="form-control"
                            v-model="calcomFaseCancelarAgenda"
                            :disabled="fases.calcomCancelar.length === 0"
                          >
                            <option value="" disabled>Selecione</option>
                            <option :value="null">– Nenhum –</option>
                            <option v-for="f in fases.calcomCancelar" :key="f.id" :value="f.id">{{ f.nome }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Atendente</label>
                        <select class="form-control" v-model="calcomAtendenteCancelarAgenda">
                          <option value="" disabled>Selecione um atendente</option>
                          <option :value="null">– Nenhum atendente –</option>
                          <option v-for="u in usuarios" :key="u.id" :value="u.id">
                            {{ u.name }} ({{ u.email }})
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Transferência ao Remarcar Agenda -->
                    <div class="form-group">
                      <label style="font-weight: 600; font-size: 1.1rem;">
                        <i class="fa fa-calendar-alt mr-1"></i>Transferência ao Remarcar Agenda
                      </label>
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label>Pipeline</label>
                          <select class="form-control" v-model="calcomPipelineRemarcarAgenda" @change="onPipelineChangeLoadFases('calcomRemarcar')">
                            <option value="" disabled>Selecione</option>
                            <option :value="null">– Nenhum –</option>
                            <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                          </select>
                        </div>
                        <div class="form-group col-md-6">
                          <label>Fase</label>
                          <select
                            class="form-control"
                            v-model="calcomFaseRemarcarAgenda"
                            :disabled="fases.calcomRemarcar.length === 0"
                          >
                            <option value="" disabled>Selecione</option>
                            <option :value="null">– Nenhum –</option>
                            <option v-for="f in fases.calcomRemarcar" :key="f.id" :value="f.id">{{ f.nome }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Atendente</label>
                        <select class="form-control" v-model="calcomAtendenteRemarcarAgenda">
                          <option value="" disabled>Selecione um atendente</option>
                          <option :value="null">– Nenhum atendente –</option>
                          <option v-for="u in usuarios" :key="u.id" :value="u.id">
                            {{ u.name }} ({{ u.email }})
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Template de Lembrança -->
                    <div class="form-group mt-4">
                      <label style="font-weight: 600; font-size: 1.1rem;">
                        <i class="fa fa-bell mr-1"></i>Template de Lembrança (10 minutos antes)
                      </label>
                      <div class="help-text mb-2">
                        <i class="fa fa-info-circle mr-1"></i>
                        Template que será usado para enviar lembrança de agendamento via WhatsApp 10 minutos antes da reunião.
                      </div>
                      <select class="form-control" v-model="calcomTemplateLembrete">
                        <option value="" disabled>Selecione um template</option>
                        <option :value="null">– Nenhum template –</option>
                        <option v-for="t in templatesTarefas" :key="t.id" :value="t.id">
                          {{ t.nome }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Botões -->
                <div class="modal-footer-custom">
                  <button class="btn btn-secondary btn-sm" @click="fecharModalCalcom">
                    <i class="fa fa-times mr-1"></i>Cancelar
                  </button>
                  <button
                    class="btn btn-primary btn-sm"
                    @click="salvarConfiguracaoCalcom"
                    :disabled="!calcomPodeSalvar || calcomSalvando"
                  >
                    <span v-if="calcomSalvando" class="spinner-border spinner-border-sm mr-1"></span>
                    <i v-else class="fa fa-save mr-1"></i>
                    Salvar Configuração
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Detalhes do Evento -->
          <div v-if="mostrarModalDetalhesEvento && eventoSelecionadoDetalhes" class="custom-modal-overlay" style="z-index: 1060;">
            <div class="custom-modal window.theme evento-detalhes-modal">
              <div class="modal-header-custom">
                <div class="d-flex align-items-center">
                  <i class="fa fa-info-circle mr-2 text-primary" style="font-size: 1.5rem;"></i>
                  <h5 class="m-0">Detalhes do Evento</h5>
                </div>
                <button class="btn btn-sm btn-close-modal" @click="mostrarModalDetalhesEvento = false">
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <div v-if="eventoSelecionadoDetalhes" class="modal-body-custom">
                <!-- Título do Evento -->
                <div class="detalhe-section-header">
                  <h4 class="evento-titulo-principal">
                    <span v-if="eventoSelecionadoDetalhes.title">{{ eventoSelecionadoDetalhes.title }}</span>
                    <span v-else-if="eventoSelecionadoDetalhes.slug">{{ eventoSelecionadoDetalhes.slug }}</span>
                    <span v-else class="text-muted">Sem título</span>
                  </h4>
                </div>

                <!-- Descrição -->
                <div class="detalhe-item" v-if="eventoSelecionadoDetalhes.description">
                  <div class="detalhe-label">
                    <i class="fa fa-align-left mr-2"></i>
                    <strong>Descrição</strong>
                  </div>
                  <div class="detalhe-value">
                    <p class="detalhe-text">{{ eventoSelecionadoDetalhes.description }}</p>
                  </div>
                </div>

                <!-- Informações Principais -->
                <div class="detalhe-grid">
                  <div class="detalhe-item">
                    <div class="detalhe-label">
                      <i class="fa fa-calendar mr-2 text-info"></i>
                      <strong>Duração</strong>
                    </div>
                    <div class="detalhe-value">
                      <span class="detalhe-badge badge-time">{{ eventoSelecionadoDetalhes.length }} minutos</span>
                    </div>
                  </div>

                  <div class="detalhe-item" v-if="eventoSelecionadoDetalhes.metadata && eventoSelecionadoDetalhes.metadata.multipleDuration">
                    <div class="detalhe-label">
                      <i class="fa fa-list mr-2 text-info"></i>
                      <strong>Durações Disponíveis</strong>
                    </div>
                    <div class="detalhe-value">
                      <span class="detalhe-badge badge-time">{{ eventoSelecionadoDetalhes.metadata.multipleDuration.join(', ') }} min</span>
                    </div>
                  </div>

                  <div class="detalhe-item" v-if="eventoSelecionadoDetalhes.minimumBookingNotice">
                    <div class="detalhe-label">
                      <i class="fa fa-bell mr-2 text-warning"></i>
                      <strong>Aviso Mínimo</strong>
                    </div>
                    <div class="detalhe-value">
                      <span class="detalhe-badge">{{ eventoSelecionadoDetalhes.minimumBookingNotice }} minutos</span>
                    </div>
                  </div>
                </div>

                <!-- Localização -->
                <div class="detalhe-item" v-if="eventoSelecionadoDetalhes.locations && eventoSelecionadoDetalhes.locations.length > 0">
                  <div class="detalhe-label">
                    <i class="fa fa-map-marker mr-2 text-danger"></i>
                    <strong>Localização</strong>
                  </div>
                  <div class="detalhe-value">
                    <div class="locations-list">
                      <span 
                        v-for="(location, idx) in eventoSelecionadoDetalhes.locations" 
                        :key="idx" 
                        class="detalhe-badge badge-location"
                      >
                        <i class="fa fa-map-marker mr-1"></i>
                        {{ location.type === 'integrations:google:meet' ? 'Google Meet' : location.type === 'inPerson' ? 'Presencial' : location.type }}
                        <span v-if="location.address" class="ml-2">{{ location.address }}</span>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Limites de Agendamento -->
                <div class="detalhe-item" v-if="eventoSelecionadoDetalhes.bookingLimits">
                  <div class="detalhe-label">
                    <i class="fa fa-ban mr-2 text-primary"></i>
                    <strong>Limites de Agendamento</strong>
                  </div>
                  <div class="detalhe-value">
                    <div class="limits-list">
                      <span 
                        v-for="(limit, key) in eventoSelecionadoDetalhes.bookingLimits" 
                        :key="key" 
                        class="detalhe-badge badge-info"
                      >
                        {{ key }}: {{ limit }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Configurações -->
                <div class="detalhe-item">
                  <div class="detalhe-label">
                    <i class="fa fa-cog mr-2 text-secondary"></i>
                    <strong>Configurações</strong>
                  </div>
                  <div class="detalhe-value">
                    <div class="config-badges">
                      <span v-if="eventoSelecionadoDetalhes.requiresConfirmation" class="detalhe-badge badge-warning-badge">
                        <i class="fa fa-check-circle mr-1"></i>Requer Confirmação
                      </span>
                      <span v-if="eventoSelecionadoDetalhes.disableGuests" class="detalhe-badge badge-secondary">
                        <i class="fa fa-user-times mr-1"></i>Convidados Desabilitados
                      </span>
                      <span v-if="eventoSelecionadoDetalhes.disableCancelling" class="detalhe-badge badge-secondary">
                        <i class="fa fa-ban mr-1"></i>Cancelamento Desabilitado
                      </span>
                      <span v-if="eventoSelecionadoDetalhes.disableRescheduling" class="detalhe-badge badge-secondary">
                        <i class="fa fa-undo mr-1"></i>Remarcação Desabilitada
                      </span>
                      <span v-if="!eventoSelecionadoDetalhes.requiresConfirmation && !eventoSelecionadoDetalhes.disableGuests && !eventoSelecionadoDetalhes.disableCancelling && !eventoSelecionadoDetalhes.disableRescheduling" class="text-muted">
                        Nenhuma configuração especial
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer-custom">
                <button class="btn btn-primary btn-sm" @click="mostrarModalDetalhesEvento = false">
                  <i class="fa fa-check mr-1"></i>Fechar
                </button>
              </div>
            </div>
          </div>

          <!-- Modal de confirmação — remover documento da base de conhecimento -->
          <div
            class="modal fade"
            id="modalConfirmarRemoverConhecimento"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modalLabelRemoverConhecimento"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header bg-danger text-white">
                  <h5 class="modal-title" id="modalLabelRemoverConhecimento">Remover documento</h5>
                  <button
                    type="button"
                    class="close text-white"
                    aria-label="Fechar"
                    @click="fecharModalRemoverConhecimento"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <p class="mb-2">
                    Tem certeza que deseja remover este arquivo da base de conhecimento?
                  </p>
                  <p
                    v-if="documentoConhecimentoParaRemover"
                    class="mb-0 text-muted small"
                  >
                    <strong>{{ documentoConhecimentoParaRemover.nome_original }}</strong>
                    <span v-if="documentoConhecimentoParaRemover.chunks_count">
                      · {{ documentoConhecimentoParaRemover.chunks_count }} trecho(s) indexado(s)
                    </span>
                  </p>
                  <p class="mb-0 mt-2 small text-danger">
                    O arquivo será excluído do armazenamento e os vetores associados no banco de conhecimento.
                  </p>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    :disabled="removendoDocumentoConhecimento"
                    @click="fecharModalRemoverConhecimento"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    :disabled="removendoDocumentoConhecimento"
                    @click="confirmarRemoverDocumentoConhecimento"
                  >
                    <i class="fa" :class="removendoDocumentoConhecimento ? 'fa-spinner fa-spin' : 'fa-trash'"></i>
                    {{ removendoDocumentoConhecimento ? ' Removendo...' : ' Remover' }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal: tarefas automáticas por ferramenta -->
          <div
            v-if="mostrarModalToolTasks"
            class="custom-modal-overlay"
            @click.self="fecharModalToolTasks"
          >
            <div class="custom-modal window.theme custom-modal-tool-tasks">
              <div class="modal-header-custom">
                <div>
                  <h5 class="modal-title mb-1">Tarefas automáticas: {{ toolTaskToolLabel(toolTasksToolKey) }}</h5>
                  <small class="text-muted">
                    Configure uma ou mais tarefas para criar quando essa ferramenta for executada com sucesso.
                  </small>
                </div>
                <button type="button" class="close" @click="fecharModalToolTasks">
                  <span>&times;</span>
                </button>
              </div>

              <div class="modal-body-custom">
                <div class="alert alert-info py-2">
                  <div class="d-flex justify-content-between align-items-start">
                    <span>
                      A criação acontece quando essa ferramenta for executada com sucesso e houver uma regra válida. Se nenhuma regra resolver um atendente, a tarefa não será criada.
                    </span>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-info ml-2"
                      @click="mostrarToolTaskPlaceholders = !mostrarToolTaskPlaceholders"
                    >
                      <i class="fa fa-info-circle mr-1"></i>
                      Placeholders
                    </button>
                  </div>
                  <div v-if="mostrarToolTaskPlaceholders" class="tool-task-placeholders mt-3">
                    <div
                      v-for="item in toolTaskPlaceholders"
                      :key="item.token"
                      class="tool-task-placeholder-item"
                    >
                      <code>{{ item.token }}</code>
                      <span>{{ item.description }}</span>
                    </div>
                  </div>
                </div>

                <div v-if="!toolTaskRules(toolTasksToolKey).length" class="text-muted text-center py-4">
                  Nenhuma tarefa configurada para esta ferramenta.
                </div>

                <div
                  v-for="(task, index) in toolTaskRules(toolTasksToolKey)"
                  :key="task.id || index"
                  class="tool-task-rule-card"
                >
                  <div class="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <strong>Tarefa {{ index + 1 }}</strong>
                      <span v-if="task.type" class="badge badge-light border ml-2">{{ toolTaskTypeLabel(task.type) }}</span>
                    </div>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      @click="removerToolTask(toolTasksToolKey, index)"
                    >
                      Remover
                    </button>
                  </div>

                  <div class="mb-3">
                    <Check
                      v-model="task.enabled"
                      :description="task.enabled
                        ? 'Esta regra poderá criar tarefa quando a ferramenta executar.'
                        : 'Esta regra ficará salva, mas não criará tarefa.'"
                    >
                      Tarefa ativa
                    </Check>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label>Tipo</label>
                      <select class="form-control" v-model="task.type">
                        <option v-for="tipo in toolTaskTypes" :key="tipo.id" :value="tipo.id">{{ tipo.value }}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-8">
                      <label>Título</label>
                      <input
                        type="text"
                        maxlength="100"
                        class="form-control"
                        v-model.trim="task.title"
                        placeholder="Ex: Retornar contato após orçamento"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Descrição</label>
                    <textarea
                      class="form-control"
                      rows="2"
                      maxlength="4200"
                      v-model.trim="task.description"
                      :placeholder="'Use placeholders como {{cliente_nome}}, {{oportunidade_nome}}, {{tool_name}}.'"
                    ></textarea>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>
                        Atendente responsável
                        <i
                          class="fa fa-info-circle text-info ml-1"
                          title="Define como o sistema vai escolher quem receberá a tarefa criada pela execução desta ferramenta. Pode ser um usuário escolhido manualmente ou o atendente já configurado na própria tool."
                        ></i>
                      </label>
                      <select class="form-control" v-model="task.responsible.mode">
                        <option value="explicit_user">Escolher atendente</option>
                        <option v-if="toolTaskHasFallback(toolTasksToolKey)" value="tool_transfer_fallback">
                          {{ toolTaskFallbackSelectLabel(toolTasksToolKey) }}
                        </option>
                      </select>
                      <small class="form-text text-muted">
                        Escolha se a tarefa vai para um usuário específico ou para o atendente padrão configurado nesta ferramenta.
                      </small>
                    </div>
                    <div class="form-group col-md-6" v-if="task.responsible.mode === 'explicit_user'">
                      <label>
                        Usuário
                        <i
                          class="fa fa-info-circle text-info ml-1"
                          title="Usuário do sistema que será atribuído como responsável pela tarefa. Ele verá a tarefa na oportunidade e nas listagens de tarefas."
                        ></i>
                      </label>
                      <select class="form-control" v-model="task.responsible.user_id">
                        <option value="">Selecione um atendente</option>
                        <option v-for="u in usuarios" :key="u.id" :value="String(u.id)">{{ u.name }}</option>
                      </select>
                      <small class="form-text text-muted">
                        Este é o usuário que receberá a tarefa quando ela for criada automaticamente.
                      </small>
                    </div>
                    <div class="form-group col-md-6" v-else>
                      <label>Fallback configurado</label>
                      <div
                        class="alert py-2 mb-0"
                        :class="toolTaskFallbackConfigured(toolTasksToolKey) ? 'alert-success' : 'alert-warning'"
                      >
                        {{ toolTaskFallbackStatus(toolTasksToolKey) }}
                      </div>
                    </div>
                  </div>

                  <div v-if="task.type === 'whatsapp'" class="form-row">
                    <div class="form-group col-md-8">
                      <label>Template de WhatsApp</label>
                      <select class="form-control" v-model="task.template_id">
                        <option value="">Selecione um template de tarefa</option>
                        <option v-for="t in templatesTarefas" :key="t.id" :value="String(t.id)">
                          {{ t.nome || t.value }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-4 d-flex align-items-end">
                      <Check
                        v-model="task.dispatch_immediately"
                        description="Se o prazo já estiver vencido no momento da criação, dispara o job de WhatsApp imediatamente."
                      >
                        Disparar se vencer agora
                      </Check>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label>Prazo</label>
                      <select class="form-control" v-model="task.deadline.mode">
                        <option value="offset">Após a execução</option>
                        <option value="fixed_time">Próximo horário fixo</option>
                        <option value="opportunity_date">Previsão da oportunidade</option>
                        <option value="from_tool">Data retornada pela tool</option>
                      </select>
                    </div>
                    <template v-if="task.deadline.mode === 'offset'">
                      <div class="form-group col-md-4">
                        <label>Quantidade</label>
                        <input type="number" min="0" max="365" class="form-control" v-model.number="task.deadline.value" />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Unidade</label>
                        <select class="form-control" v-model="task.deadline.unit">
                          <option value="minutes">Minutos</option>
                          <option value="hours">Horas</option>
                          <option value="days">Dias</option>
                        </select>
                      </div>
                    </template>
                    <template v-else-if="task.deadline.mode === 'fixed_time'">
                      <div class="form-group col-md-4">
                        <label>Horário</label>
                        <input type="time" class="form-control" v-model="task.deadline.time" />
                      </div>
                      <div class="form-group col-md-4 d-flex align-items-end">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'tool-task-business-' + task.id"
                            v-model="task.deadline.next_business_day"
                          />
                          <label class="custom-control-label" :for="'tool-task-business-' + task.id">Próximo dia útil</label>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="task.deadline.mode === 'opportunity_date'">
                      <div class="form-group col-md-4">
                        <label>Horário</label>
                        <input type="time" class="form-control" v-model="task.deadline.time" />
                      </div>
                    </template>
                    <template v-else-if="task.deadline.mode === 'from_tool'">
                      <div class="form-group col-md-4">
                        <label>Campo da tool</label>
                        <input type="text" class="form-control" v-model.trim="task.deadline.field" placeholder="data_inicio" />
                      </div>
                      <div class="form-group col-md-2">
                        <label>Antes</label>
                        <input type="number" min="0" max="365" class="form-control" v-model.number="task.deadline.offset_before.value" />
                      </div>
                      <div class="form-group col-md-2">
                        <label>Unidade</label>
                        <select class="form-control" v-model="task.deadline.offset_before.unit">
                          <option value="minutes">Min</option>
                          <option value="hours">Horas</option>
                          <option value="days">Dias</option>
                        </select>
                      </div>
                    </template>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Evitar duplicidade</label>
                      <select class="form-control" v-model="task.dedupe">
                        <option value="none">Não verificar duplicidade</option>
                        <option value="once_per_opportunity">Uma vez por oportunidade</option>
                        <option value="once_per_tool_per_day">Uma vez por dia nesta oportunidade</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer-custom">
                <button type="button" class="btn btn-outline-primary btn-sm" @click="adicionarToolTask(toolTasksToolKey)">
                  Adicionar tarefa
                </button>
                <button type="button" class="btn btn-secondary btn-sm" @click="fecharModalToolTasks">
                  Fechar
                </button>
              </div>
            </div>
          </div>

          <!-- Modal de confirmação de deleção -->
          <div
            class="modal fade"
            id="modalConfirmarDelecao"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modalLabelDeletar"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header bg-danger text-white">
                  <h5 class="modal-title text-white" id="modalLabelDeletar">Confirmar Deleção</h5>
                  <button
                    type="button"
                    class="close text-white"
                    data-dismiss="modal"
                    aria-label="Fechar"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  Tem certeza que deseja <strong>deletar permanentemente</strong> este treinamento?
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
                    Cancelar
                  </button>
                  <button type="button" class="btn btn-danger btn-sm" @click="confirmarDelecao">
                    <i class="fa fa-trash mr-1"></i> Confirmar Deleção
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <playground-ia
      ref="playground"
      :treinamento-id="selectedTrainingId"
      :treinamento-nome="form.nome"
    />
  </div>
</template>

<script>
import api from '@/api'
import Check from '../ui/Check.vue';
import {
  arquivoConhecimentoKey,
  criarEstadoUploadConhecimento,
  definirArquivosConhecimento,
  onArrastarArquivosConhecimento,
  onSelecionarArquivosConhecimento,
  onSoltarArquivosConhecimento,
  removerArquivoConhecimentoSelecionado,
  textoResumoArquivosConhecimento
} from './treinamentoKnowledgeUpload';

/** Chaves do formulário Vue → nome da tool em executeToolAndLog (backend). */
const VUE_TOOL_TO_BACKEND_TOOL = {
  buscar_equipamento: 'busca_equipamentos',
  busca_data_dia: 'busca_data_dia',
  calcular_entrega: 'calcular_entrega',
  enviar_foto_equipamento: 'enviar_foto_equipamento',
  finalizar_locacao: 'finalizar_locacao',
  pegar_link_online: 'pegar_link_online',
  locacao_andaime: 'locacao_andaime',
  gerar_orcamento: 'gerar_orcamento',
  buscar_endereco_por_cep: 'buscar_endereco_por_cep',
  nome_e_cumprimentos: 'nome_e_cumprimentos',
  transferir_para_humano: 'transferir_para_humano',
  buscar_horarios: 'buscar_horarios',
  marcar_reuniao: 'marcar_reuniao',
  cancelar_reuniao: 'cancelar_reuniao'
};

const TOOL_TASK_TYPES = [
  { id: 'ligar', value: 'Ligar' },
  { id: 'email', value: 'Email' },
  { id: 'reuniao', value: 'Reunião' },
  { id: 'whatsapp', value: 'WhatsApp' },
  { id: 'visita', value: 'Visita' }
];

const TOOL_TASK_FALLBACK_LABELS = {
  finalizar_locacao: 'atendente ao finalizar locação',
  transferir_para_humano: 'atendente da transferência para humano',
  gerar_orcamento: 'atendente ao gerar orçamento',
  marcar_reuniao: 'atendente para marcar agenda',
  cancelar_reuniao: 'atendente para cancelar/remarcar agenda'
};

const TOOL_TASK_PLACEHOLDERS = [
  { token: '{{cliente_nome}}', description: 'Nome do cliente vinculado à oportunidade.' },
  { token: '{{oportunidade_nome}}', description: 'Nome da oportunidade.' },
  { token: '{{tool_name}}', description: 'Nome técnico da ferramenta executada pela IA.' },
  { token: '{{local_entrega}}', description: 'Local de entrega informado na tool de cálculo de entrega.' },
  { token: '{{equipamentos}}', description: 'Lista de equipamentos informados ou retornados pela tool.' },
  { token: '{{data_reuniao}}', description: 'Data/hora retornada por tools de agendamento, quando disponível.' }
];

export default {
  components: {
    Check
  },
  beforeUnmount() {
    this.pararPollingConhecimento && this.pararPollingConhecimento();
  },
  beforeDestroy() {
    this.pararPollingConhecimento && this.pararPollingConhecimento();
  },
  mounted() {
    document.getElementById('overlayer-loading')?.classList.add('show-overlayer');

    document.body.setAttribute('data-theme', window.theme || 'light');

    Promise.all([
      this.getOpenAIModels(),
      this.getPipelinesAtendente(),
      this.getUsuarios(),
      this.getTreinamentos(),
      this.getModelosOrcamento(),
      this.getModelosContrato(),
      this.getTemplatesTarefas(),
      this.carregarTagsTreinamento(),
      this.carregarCategoriasProdutos()
    ]).finally(() => {
      document.getElementById('overlayer-loading')?.classList.remove('show-overlayer');
    });
  },
  data() {
    return {
      displayOptions: [
        { id: 0, label: 'Exibir na Loja e no CRM (AMBOS)' },
        { id: 1, label: 'Exibir somente na Loja' },
        { id: 2, label: 'Exibir somente no CRM' },
      ],
      categoriaMatchOptions: [
        { value: 'any', label: 'Produtos que tenham qualquer categoria selecionada' },
        { value: 'all', label: 'Produtos que tenham todas as categorias selecionadas' },
        { value: 'exact', label: 'Produtos que tenham exatamente estas categorias' }
      ],
      opcoesPeriodicidade: [
        { value: 'sempre', label: 'Sempre' },
        { value: '3_meses', label: 'A cada 3 meses' },
        { value: '6_meses', label: 'A cada 6 meses' },
        { value: '12_meses', label: 'A cada 12 meses' }
      ],
      todasFases: {},
      modoEdicao: false,
      usuarios: [],
      toolTaskTypes: TOOL_TASK_TYPES,
      toolTaskPlaceholders: TOOL_TASK_PLACEHOLDERS,
      pipelinesAtendente: [],
      fases: {
        endLease: [],
        generateBudget: [],
        offline: [],
        human: [],
        redirect: [],
        calcomMarcar: [],
        calcomCancelar: [],
        calcomRemarcar: []
      },
      selectedTrainingId: '',
      treinamentoFormSnapshot: '',
      modelosDisponiveis: [],
      modelosOrcamentoDisponiveis: [],
      modelosContratoDisponiveis: [],
      mostrarModalContratoAssinatura: false,
      arquivoContratoAssinaturaPendente: null,
      temperaturas: [
        { valor: 0.1, descricao: 'Muito determinística' },
        { valor: 0.2, descricao: 'Determinística' },
        { valor: 0.3, descricao: 'Pouco criativa' },
        { valor: 0.4, descricao: 'Levemente criativa' },
        { valor: 0.5, descricao: 'Balanceada' },
        { valor: 0.6, descricao: 'Moderadamente criativa' },
        { valor: 0.7, descricao: 'Criativa' },
        { valor: 0.8, descricao: 'Muito criativa' },
        { valor: 0.9, descricao: 'Altamente criativa' },
        { valor: 1.0, descricao: 'Máxima criatividade' }
      ],
      toolsDisponiveis: {
        buscar_equipamento: {
          nome: 'Buscar Equipamento',
          descricao: 'Buscar equipamento desejado pelo cliente nos produtos da Loja.'
        },
        busca_data_dia: {
          nome: 'Busca Data/Dia',
          descricao: 'Identifica e interpreta datas mencionadas pelo cliente durante a conversa.'
        },
        finalizar_locacao: {
          nome: 'Finalizar Locação',
          descricao: 'Permite que a IA conclua automaticamente uma locação quando possível.'
        },
        gerar_orcamento: {
          nome: 'Gerar Orçamento',
          descricao: 'Cria automaticamente um orçamento quando o cliente confirma interesse no equipamento.'
        },
        transferir_para_humano: {
          nome: 'Transferir para Humano',
          descricao: 'Encaminha o atendimento para um operador humano quando solicitado ou necessário.'
        },
        calcular_entrega: {
          nome: 'Calcular Entrega',
          descricao: 'Calcula frete e condições para entrega dos equipamentos.'
        },
        pegar_link_online: {
          nome: 'Pegar Link Online',
          descricao: 'Gera e envia um link para atendimento online ou acompanhamento da locação.'
        },
        redirecionar_outros_assuntos: {
          nome: 'Redirecionar Outros Assuntos',
          descricao: 'Redireciona temas fora do escopo da IA para os setores adequados.'
        },
        integracao_agenda: {
          nome: 'Integração de Agenda (Cal.com)',
          descricao: 'Ativa a integração com Cal.com para agendamento de reuniões. Permite que a IA agende, cancele e sugira horários de reuniões.'
        },
        enviar_foto_equipamento: {
          nome: 'Enviar Foto do Equipamento',
          descricao: 'Envia ao cliente a imagem do equipamento cotado ou sugerido.'
        },
        locacao_andaime: {
          nome: 'Locação de Andaime',
          descricao: 'Aplica regras específicas para locação de andaimes, como metragem e tipos.'
        },
        buscar_endereco_por_cep: {
          nome: 'Buscar Endereço por CEP',
          descricao: 'Busca o endereço completo (rua, bairro, cidade) baseado no CEP informado pelo cliente.'
        },
        nome_e_cumprimentos: {
          nome: 'Nome e Cumprimentos',
          descricao: 'Confirma como o cliente quer ser chamado e usa esse nome nos cumprimentos da conversa.'
        },
        enviar_contrato_assinatura: {
          nome: 'Enviar Contrato para Assinatura',
          descricao: 'Gera o contrato (modelo ou arquivo anexado no treinamento) e envia o link de assinatura por WhatsApp da conversa.'
        }
      },
      treinamentosExistentes: [],
      mostrarModalRedirecionamento: false,
      mostrarModalBuscaEquipamento: false,
      mostrarModalFinalizarLocacao: false,
      abaAtivaFinalizarLocacao: 'documentos',
      novoRedirecionamento: {
        pipelineId: '',
        faseId: '',
        descricao: '',
        atendenteId: '',
        userId: '',
        tag_ids: [],
        atribuir_por_balanceamento: false,
      },
      mostrarHorarioFuncionamento: false,
      diasAtivos: ['segunda', 'terca', 'quarta', 'quinta', 'sexta'],
      // Cal.com
      mostrarModalCalcom: false,
      calcomToken: '',
      calcomTokenValido: false,
      calcomTokenInvalido: false,
      calcomValidandoToken: false,
      calcomEventosDisponiveis: [],
      calcomCarregandoEventos: false,
      calcomEventosSelecionados: [],
      calcomPodeAgendar: false,
      calcomPodeCancelar: false,
      calcomSugerirHorarios: false,
      calcomPermitirConvidados: false,
      calcomRoundRobin: false,
      calcomSalvando: false,
      mostrarModalDetalhesEvento: false,
      eventoSelecionadoDetalhes: null,
      estatisticasAgendamentos: null,
      carregandoEstatisticas: false,
      // Configurações de transferência para agendamentos
      calcomPipelineMarcarAgenda: '',
      calcomFaseMarcarAgenda: '',
      calcomAtendenteMarcarAgenda: '',
      calcomPipelineCancelarAgenda: '',
      calcomFaseCancelarAgenda: '',
      calcomAtendenteCancelarAgenda: '',
      calcomPipelineRemarcarAgenda: '',
      calcomFaseRemarcarAgenda: '',
      calcomAtendenteRemarcarAgenda: '',
      calcomTemplateLembrete: null,
      templatesTarefas: [],
      tagsTreinamento: [],
      loadingTagsTreinamento: false,
      categoriasProdutos: [],
      loadingCategoriasProdutos: false,
      tagPickerSearchElis: '',
      tagPickerSearchRedirect: '',
      // Base de conhecimento (RAG)
      conhecimentoDocumentos: [],
      conhecimentoCarregando: false,
      conhecimentoUploading: false,
      documentoConhecimentoParaRemover: null,
      removendoDocumentoConhecimento: false,
      ...criarEstadoUploadConhecimento(),
      conhecimentoUrlInput: '',
      conhecimentoUrlImportando: false,
      pollingConhecimentoTimer: null,
      mostrarModalToolTasks: false,
      toolTasksToolKey: '',
      mostrarToolTaskPlaceholders: false,
      categoriaPickerSearchBuscaEquipamento: '',
      httpToolEditorOpen: false,
      httpToolEditingIndex: null,
      httpToolSlugTouched: false,
      httpToolPreviewLoading: false,
      httpToolPreviewArgumentsJson: '{}',
      httpToolPreviewOportunidadeId: '',
      httpToolPreviewResult: null,
      httpToolDraft: null,
      httpToolSystemVariables: [],
      httpToolSystemVariablesLoading: false,
      httpToolSystemVariablesExpanded: false,
      httpToolSystemVariablesSearch: '',
      httpToolSystemVariablesActiveGroup: 'loja',
      httpToolFocusedField: null,
      httpToolPlaceholders: {
        queryParams: '[{"key":"loja","value":"((loja_id))"}]',
        queryParamValue: 'Valor. Ex: ((loja_id)) ou [[termo]]',
        body: '{"loja_id":"((loja_id))","termo":"[[termo]]"}'
      },
      form: {
        nome: '',
        redirecionamentos: [],
        tools: [],
        httpTools: [],
        localizacao: '',
        horarioFuncionamento: {
          segunda: { inicio: '', fim: '' },
          terca: { inicio: '', fim: '' },
          quarta: { inicio: '', fim: '' },
          quinta: { inicio: '', fim: '' },
          sexta: { inicio: '', fim: '' },
          sabado: { inicio: '', fim: '' },
          domingo: { inicio: '', fim: '' }
        },
        training: '',
        model: 'gpt-4.1-mini-2025-04-14',
        temperature: 0.2,
        maxTokensResposta: 400,
        dividirRespostaSmart: true,
        phaseWhenToEndLease: '',
        chargesCount: 2,
        offlinePhase: '',
        attendantWhenOffline: '',
        attendantWhenEndLease: '',
        attendantWhenGenerateBudget: '',
        wantsAttendant: '',
        attendantBalanceamentoFinalizarLocacao: false,
        attendantBalanceamentoGerarOrcamento: false,
        attendantBalanceamentoOffline: false,
        attendantBalanceamentoConsultor: false,
        phaseWhenWantsAttendant: '',
        phaseWhenGenerateBudget: '',
        pipelineWhenToEndLease: '',
        pipelineWhenOffline: '',
        pipelineWhenWantsAttendant: '',
        pipelineWhenGenerateBudget: '',
        nichoId: '',
        templateId: '',
        sendEcommerceLink: false,
        sendProductPrice: true,
        sendImageInListing: false,
        sendAllProductImages: false,
        buscarEquipamentoIncluirDescricao: false,
        buscarEquipamentoIncluirAcessorios: false,
        buscarEquipamentoIncluirLinkEcommerce: false,
        buscarEquipamentoCategoriaIds: [],
        buscarEquipamentoCategoriaMatchMode: 'any',
        buscarEquipamentoAnalisarCustoBeneficio: false,
        sendTypeProtection: 'NON_BUILT_IN_PROTECTION',
        sendDocumentBudgetConversation: false,
        modeloOrcamentoEnvioConversaId: '',
        displayExibition: 0,
        chargeChatTime: 0,
        chargeChatRetrys: 1,
        calcomIntegracaoAtiva: false,
        toolTasksEnabled: false,
        toolTags: {},
        toolTasks: {},
        finalizarLocacaoConfig: {
          exigir_cnh: false,
          periodicidade_cnh: 'sempre',
          exigir_comprovante_residencia: false,
          periodicidade_comprovante: 'sempre',
          exigir_reconhecimento_facial: false,
          fazer_consulta_serasa: false,
          aprovacao_automatica: false,
          score_minimo_aprovacao: 600,
          nao_aprovar_pendencias: false,
          limite_consultas_redflag: 30,
          gerar_orcamento_automatico: false,
          criar_cliente_auto: false,
          buscar_ccl: false
        },
        contratoAssinaturaModo: 'modelo',
        contratoAssinaturaModeloId: '',
        contratoAssinaturaArquivoS3: '',
        contratoAssinaturaArquivoNome: '',
        contratoAssinaturaTemplateId: '',
        conhecimentoVetorialAtivo: false,
        conhecimentoVetorialTopK: 8
      }
    }
  },
  computed: {
    isSuper() {
      return window.super == 1;
    },
    nomeAttendenteFinal() {
      const found = this.usuarios.find(u => u.id === this.form.attendantWhenEndLease);
      return found ? found.name : '';
    },
    redirecionamentoAtivo() {
      return this.form.tools.includes('redirecionar_outros_assuntos');
    },
    finalizarLocacaoAtivo() {
      return this.form.tools.includes('finalizar_locacao');
    },
    contratoAssinaturaAtivo() {
      return this.form.tools.includes('enviar_contrato_assinatura');
    },
    calcomPodeSalvar() {
      return this.calcomTokenValido && 
             this.calcomEventosSelecionados.length > 0 &&
             (this.calcomPodeAgendar || this.calcomPodeCancelar || this.calcomSugerirHorarios);
    },
    httpToolPreviewRequest() {
      return this.httpToolPreviewResult &&
        this.httpToolPreviewResult.preview &&
        this.httpToolPreviewResult.preview.request
        ? this.httpToolPreviewResult.preview.request
        : null;
    },
    httpToolPreviewFilteredResponse() {
      return this.httpToolPreviewResult &&
        this.httpToolPreviewResult.preview &&
        this.httpToolPreviewResult.preview.response
        ? this.httpToolPreviewResult.preview.response.filtered
        : null;
    },
    httpToolPreviewRawResponse() {
      return this.httpToolPreviewResult &&
        this.httpToolPreviewResult.preview &&
        this.httpToolPreviewResult.preview.response
        ? this.httpToolPreviewResult.preview.response.body
        : null;
    },
    httpToolPreviewSuggestedPaths() {
      return this.extractHttpToolPreviewPaths(this.httpToolPreviewRawResponse).slice(0, 60);
    },
    httpToolPreviewAiOutput() {
      return this.httpToolPreviewResult &&
        this.httpToolPreviewResult.preview &&
        this.httpToolPreviewResult.preview.response
        ? this.httpToolPreviewResult.preview.response.ai_output
        : ((this.httpToolPreviewResult && this.httpToolPreviewResult.message) || '');
    },
    httpToolConfiguredAiOutput() {
      if (!this.httpToolPreviewRawResponse) {
        return 'Execute o preview para visualizar exatamente o que será enviado para a IA.';
      }

      return this.renderHttpToolAiOutputFromPreview(this.httpToolPreviewRawResponse);
    },
    httpToolVariableReferences() {
      const refs = this.extractHttpToolVariableReferencesFromDraft();
      const registered = new Set(
        (this.httpToolDraft?.variables || [])
          .map(v => this.normalizarHttpToolVariableName(v?.name || ''))
          .filter(Boolean)
      );

      return refs.map(name => ({
        name,
        exists: registered.has(name)
      }));
    },
    httpToolSystemVariableKeys() {
      const keys = [];
      (this.httpToolSystemVariables || []).forEach((group) => {
        (group.variables || []).forEach((variable) => {
          if (variable?.key) {
            keys.push(variable.key);
          }
        });
      });

      return keys;
    },
    httpToolSystemVariableReferences() {
      const allowed = new Set(this.httpToolSystemVariableKeys);

      return this.extractHttpToolSystemVariableReferencesFromDraft().map(key => ({
        key,
        valid: allowed.size === 0 || allowed.has(key),
      }));
    },
    httpToolSystemVariablesFilteredFlat() {
      const query = (this.httpToolSystemVariablesSearch || '').trim().toLowerCase();
      if (!query) {
        return [];
      }

      const results = [];
      (this.httpToolSystemVariables || []).forEach((group) => {
        (group.variables || []).forEach((variable) => {
          const key = String(variable?.key || '');
          const label = String(variable?.label || '');
          const haystack = `${key} ${label}`.toLowerCase();
          if (haystack.includes(query)) {
            results.push({
              ...variable,
              groupLabel: group.label,
            });
          }
        });
      });

      return results;
    },
    httpToolSystemVariablesDisplayed() {
      if (this.httpToolSystemVariablesSearch) {
        return this.httpToolSystemVariablesFilteredFlat;
      }

      const group = (this.httpToolSystemVariables || []).find(
        item => item.id === this.httpToolSystemVariablesActiveGroup
      ) || (this.httpToolSystemVariables || [])[0];

      return group?.variables || [];
    },
    toolKeysForTagConfig() {
      const skip = new Set(['redirecionar_outros_assuntos', 'integracao_agenda']);
      return Object.keys(this.toolsDisponiveis).filter(
        k => !skip.has(k) && VUE_TOOL_TO_BACKEND_TOOL[k]
      );
    },
    toolKeysForTaskConfig() {
      const skip = new Set(['redirecionar_outros_assuntos', 'integracao_agenda']);
      const keys = Object.keys(this.toolsDisponiveis).filter(
        k => !skip.has(k) && VUE_TOOL_TO_BACKEND_TOOL[k] && this.form.tools.includes(k)
      );
      if (this.form.calcomIntegracaoAtiva) {
        if (this.calcomSugerirHorarios) keys.push('buscar_horarios');
        if (this.calcomPodeAgendar) keys.push('marcar_reuniao');
        if (this.calcomPodeCancelar) keys.push('cancelar_reuniao');
      }
      return keys;
    },
    tagsFiltradasElis() {
      const q = (this.tagPickerSearchElis || '').trim().toLowerCase();
      if (!q) {
        return this.tagsTreinamento;
      }
      return this.tagsTreinamento.filter(t => (t.nome || '').toLowerCase().includes(q));
    },
    tagsFiltradasRedirect() {
      const q = (this.tagPickerSearchRedirect || '').trim().toLowerCase();
      if (!q) {
        return this.tagsTreinamento;
      }
      return this.tagsTreinamento.filter(t => (t.nome || '').toLowerCase().includes(q));
    },
    temDocumentoProcessando() {
      return this.conhecimentoDocumentos.some(d => d.status === 'pending' || d.status === 'processing');
    },
    resumoConhecimento() {
      const total = this.conhecimentoDocumentos.length;
      let prontos = 0;
      let chunks = 0;
      for (const d of this.conhecimentoDocumentos) {
        if (d.status === 'ready') prontos++;
        chunks += Number(d.chunks_count || 0);
      }
      return { total, prontos, chunks };
    },
    formTemAlteracoesPendentes() {
      if (!this.treinamentoFormSnapshot) {
        return true;
      }

      return this.treinamentoFormSnapshot !== this.capturarSnapshotForm();
    },
    podeAbrirPlayground() {
      const id = this.selectedTrainingId;

      return !!id
        && id !== '__novo__'
        && this.modoEdicao
        && !this.formTemAlteracoesPendentes;
    },
    tituloBotaoPlayground() {
      if (!this.selectedTrainingId || this.selectedTrainingId === '__novo__') {
        return 'Selecione e salve um treinamento para testar no Playground';
      }

      if (this.formTemAlteracoesPendentes) {
        return 'Salve as alterações do treinamento antes de abrir o Playground';
      }

      return 'Testar este treinamento em chat interno';
    },
    categoriasProdutosFiltradas() {
      const q = (this.categoriaPickerSearchBuscaEquipamento || '').trim().toLowerCase();
      if (!q) {
        return this.categoriasProdutos;
      }
      return this.categoriasProdutos.filter(c => (c.nome || '').toLowerCase().includes(q));
    }
  },
  watch: {
    selectedTrainingId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$refs.playground?.fechar?.();
      }

      if (newVal) {
        this.carregarTreinamentoExistente(newVal);
      }
    },
    'form.tools': {
      handler(val) {
        if (!Array.isArray(val) || !val.includes('buscar_equipamento')) {
          this.form.buscarEquipamentoIncluirDescricao = false;
          this.form.buscarEquipamentoIncluirAcessorios = false;
          this.form.buscarEquipamentoIncluirLinkEcommerce = false;
          this.form.buscarEquipamentoCategoriaIds = [];
          this.form.buscarEquipamentoCategoriaMatchMode = 'any';
          this.categoriaPickerSearchBuscaEquipamento = '';
          this.form.buscarEquipamentoAnalisarCustoBeneficio = false;
          this.mostrarModalBuscaEquipamento = false;
        }
        if (this.mostrarModalToolTasks && this.toolTasksToolKey && !this.toolKeysForTaskConfig.includes(this.toolTasksToolKey)) {
          this.fecharModalToolTasks();
        }
      },
      deep: true,
    },
  },
  methods: {
    capturarSnapshotForm() {
      return JSON.stringify(this.form);
    },
    atualizarSnapshotForm() {
      this.treinamentoFormSnapshot = this.capturarSnapshotForm();
    },
    abrirPlayground() {
      if (!this.podeAbrirPlayground) {
        window.showToastDanger?.('body', this.tituloBotaoPlayground);
        return;
      }

      document.getElementById('overlayer-loading')?.classList.remove('show-overlayer');
      this.$refs.playground?.abrir?.();
    },
    resetForm() {
      this.form = {
        nome: '',
        redirecionamentos: [],
        tools: [],
        httpTools: [],
        localizacao: '',
        horarioFuncionamento: {
          segunda: { inicio: '', fim: '' },
          terca: { inicio: '', fim: '' },
          quarta: { inicio: '', fim: '' },
          quinta: { inicio: '', fim: '' },
          sexta: { inicio: '', fim: '' },
          sabado: { inicio: '', fim: '' },
          domingo: { inicio: '', fim: '' }
        },
        training: '',
        model: 'gpt-4.1-mini-2025-04-14',
        temperature: 0.2,
        maxTokensResposta: 400,
        dividirRespostaSmart: true,
        phaseWhenToEndLease: '',
        chargesCount: 2,
        offlinePhase: '',
        attendantWhenOffline: '',
        attendantWhenEndLease: '',
        attendantWhenGenerateBudget: '',
        wantsAttendant: '',
        attendantBalanceamentoFinalizarLocacao: false,
        attendantBalanceamentoGerarOrcamento: false,
        attendantBalanceamentoOffline: false,
        attendantBalanceamentoConsultor: false,
        phaseWhenWantsAttendant: '',
        phaseWhenGenerateBudget: '',
        pipelineWhenToEndLease: '',
        pipelineWhenOffline: '',
        pipelineWhenWantsAttendant: '',
        pipelineWhenGenerateBudget: '',
        nichoId: '',
        templateId: '',
        sendEcommerceLink: false,
        sendProductPrice: true,
        sendImageInListing: false,
        sendAllProductImages: false,
        buscarEquipamentoIncluirDescricao: false,
        buscarEquipamentoIncluirAcessorios: false,
        buscarEquipamentoIncluirLinkEcommerce: false,
        buscarEquipamentoCategoriaIds: [],
        buscarEquipamentoCategoriaMatchMode: 'any',
        buscarEquipamentoAnalisarCustoBeneficio: false,
        sendTypeProtection: 'NON_BUILT_IN_PROTECTION',
        sendDocumentBudgetConversation: false,
        modeloOrcamentoEnvioConversaId: '',
        displayExibition: 0,
        chargeChatTime: 0,
        chargeChatRetrys: 1,
        calcomIntegracaoAtiva: false,
        toolTasksEnabled: false,
        toolTags: {},
        toolTasks: {},
        finalizarLocacaoConfig: {
          exigir_cnh: false,
          periodicidade_cnh: 'sempre',
          exigir_comprovante_residencia: false,
          periodicidade_comprovante: 'sempre',
          fazer_consulta_serasa: false,
          aprovacao_automatica: false,
          score_minimo_aprovacao: 600,
          nao_aprovar_pendencias: false,
          limite_consultas_redflag: 30,
          gerar_orcamento_automatico: false,
          criar_cliente_auto: false,
          buscar_ccl: false
        },
        contratoAssinaturaModo: 'modelo',
        contratoAssinaturaModeloId: '',
        contratoAssinaturaArquivoS3: '',
        contratoAssinaturaArquivoNome: '',
        contratoAssinaturaTemplateId: '',
        conhecimentoVetorialAtivo: false,
        conhecimentoVetorialTopK: 8
      };

      this.conhecimentoDocumentos = [];
      this.arquivosConhecimentoSelecionados = [];
      this.pararPollingConhecimento();

      this.mostrarModalRedirecionamento = false;
      this.mostrarModalBuscaEquipamento = false;
      this.mostrarModalFinalizarLocacao = false;
      this.mostrarModalContratoAssinatura = false;
      this.mostrarModalToolTasks = false;
      this.toolTasksToolKey = '';
      this.mostrarToolTaskPlaceholders = false;
      this.fecharHttpToolEditor();
      this.arquivoContratoAssinaturaPendente = null;
      this.resetCalcom();
      this.tagPickerSearchElis = '';
      this.tagPickerSearchRedirect = '';
      this.novoRedirecionamento = { pipelineId: '', faseId: '', descricao: '', atendenteId: '', userId: '', tag_ids: [], atribuir_por_balanceamento: false };

      this.fases = {
        endLease: [],
        offline: [],
        human: [],
        redirect: []
      };
    },
    async carregarFasesRedirecionamentos() {
      const promessas = [];

      for (const r of this.form.redirecionamentos) {
        const pipelineId = r.pipelineId;
        if (pipelineId && !this.todasFases[pipelineId]) {
          promessas.push(
            api.get(`/painel/oportunidades-pipelines/listar-fases/${pipelineId}`)
              .then(response => {
                const fasesFormatadas = Array.isArray(response.data.fases)
                  ? response.data.fases.map(f => ({ id: f.id, nome: f.value }))
                  : [];
                this.todasFases[pipelineId] = fasesFormatadas;
              })
              .catch(error => {
                console.warn(`Erro ao carregar fases para pipeline ${pipelineId}`, error);
              })
          );
        }
      }

      await Promise.all(promessas);
    },
    async atualizarTreinamento() {
      const loader = document.getElementById('overlayer-loading');
      loader?.classList.add('show-overlayer');

      try {
        const id = this.selectedTrainingId;
        if (!id) throw new Error('Treinamento não selecionado.');

        const msgToolTasks = this.validarToolTasksParaSalvar();
        if (msgToolTasks) {
          window.showToastDanger?.('body', msgToolTasks);
          return;
        }

        const msgContrato = this.validarContratoAssinaturaParaSalvar();
        if (msgContrato) {
          window.showToastDanger?.('body', msgContrato);
          return;
        }
        if (!this.commitHttpToolDraftIfOpen()) {
          return;
        }
        await this.syncUploadContratoAssinaturaPendente(id);

        const payload = {
          nome: this.form.nome,
          xml: this.form.training,
          modelo: this.form.model,
          temperatura: this.form.temperature,
          max_tokens_resposta: Number(this.form.maxTokensResposta),
          dividir_resposta_smart: Boolean(this.form.dividirRespostaSmart),
          loja_id: window.lojaId,
          user_id: window.userId,
          buscar_equipamento: this.form.tools.includes('buscar_equipamento'),
          buscar_equipamento_incluir_descricao:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoIncluirDescricao,
          buscar_equipamento_incluir_acessorios:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoIncluirAcessorios,
          buscar_equipamento_incluir_link_ecommerce:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoIncluirLinkEcommerce,
          buscar_equipamento_categoria_ids: this.form.tools.includes('buscar_equipamento')
            ? this.form.buscarEquipamentoCategoriaIds.map(id => Number(id))
            : [],
          buscar_equipamento_categoria_match_mode:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoCategoriaIds.length
              ? this.form.buscarEquipamentoCategoriaMatchMode
              : 'any',
          buscar_equipamento_analisar_custo_beneficio:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoAnalisarCustoBeneficio,
          transferir_para_humano: this.form.tools.includes('transferir_para_humano'),
          buscar_data: this.form.tools.includes('busca_data_dia'),
          calculo_de_frete: this.form.tools.includes('calcular_entrega'),
          enviar_foto_equipamento: this.form.tools.includes('enviar_foto_equipamento'),
          finalizar_locacao: this.form.tools.includes('finalizar_locacao'),
          pegar_link_online: this.form.tools.includes('pegar_link_online'),
          locacao_andaime: this.form.tools.includes('locacao_andaime'),
          gerar_orcamento: this.form.tools.includes('gerar_orcamento'),
          enviar_documento_orcamento_conversa: this.form.sendDocumentBudgetConversation,
          modelo_orcamento_envio_conversa_id: this.form.modeloOrcamentoEnvioConversaId
            ? Number(this.form.modeloOrcamentoEnvioConversaId)
            : null,
          buscar_endereco_por_cep: this.form.tools.includes('buscar_endereco_por_cep'),
          nome_e_cumprimentos: this.form.tools.includes('nome_e_cumprimentos'),
          redirecionar_outros_assuntos: this.form.redirecionamentos,
          finalizar_locacao_info: {
            pipelineId: this.form.pipelineWhenToEndLease || null,
            faseId: this.form.phaseWhenToEndLease || null
          },
          gerar_orcamento_info: {
            pipelineId: this.form.pipelineWhenGenerateBudget || null,
            faseId: this.form.phaseWhenGenerateBudget || null
          },
          cliente_offline_info: {
            pipelineId: this.form.pipelineWhenOffline || null,
            faseId: this.form.offlinePhase || null
          },
          transferir_para_humano_info: {
            pipelineId: this.form.pipelineWhenWantsAttendant || null,
            faseId: this.form.phaseWhenWantsAttendant || null
          },
          atendente_finalizar_locacao: this.form.attendantBalanceamentoFinalizarLocacao ? null : (this.form.attendantWhenEndLease || null),
          atendente_gerar_orcamento: this.form.attendantBalanceamentoGerarOrcamento ? null : (this.form.attendantWhenGenerateBudget || null),
          atendente_cliente_offline: this.form.attendantBalanceamentoOffline ? null : (this.form.attendantWhenOffline || null),
          atendente_transferir_para_humano: this.form.attendantBalanceamentoConsultor ? null : (this.form.wantsAttendant || null),
          atendente_balanceamento_config: this.buildAtendenteBalanceamentoConfig(),
          enviar_preco_produto: this.form.sendProductPrice,
          enviar_imagem_na_listagem: this.form.sendImageInListing,
          enviar_todas_imagens_produto: this.form.sendAllProductImages,
          protecao: this.mapProtecao(this.form.sendTypeProtection),
          display_exibition: Number(this.form.displayExibition),
          charge_chat_time: Number(this.form.chargeChatTime),
          charge_chat_retrys: Number(this.form.chargeChatRetrys),
          finalizar_locacao_config: this.form.finalizarLocacaoConfig,
          calcom_integracao_ativa: this.form.calcomIntegracaoAtiva,
          calcom_round_robin: this.calcomRoundRobin,
          calcom_marcar_agenda_info: {
            pipelineId: this.calcomPipelineMarcarAgenda || null,
            faseId: this.calcomFaseMarcarAgenda || null
          },
          calcom_atendente_marcar_agenda: this.calcomAtendenteMarcarAgenda || null,
          calcom_cancelar_agenda_info: {
            pipelineId: this.calcomPipelineCancelarAgenda || null,
            faseId: this.calcomFaseCancelarAgenda || null
          },
          calcom_atendente_cancelar_agenda: this.calcomAtendenteCancelarAgenda || null,
          calcom_remarcar_agenda_info: {
            pipelineId: this.calcomPipelineRemarcarAgenda || null,
            faseId: this.calcomFaseRemarcarAgenda || null
          },
          calcom_atendente_remarcar_agenda: this.calcomAtendenteRemarcarAgenda || null,
          calcom_template_lembrete_id: this.calcomTemplateLembrete || null,
          tool_tags_config: this.buildToolTagsConfigPayload(),
          conhecimento_vetorial_ativo: !!this.form.conhecimentoVetorialAtivo,
          conhecimento_vetorial_top_k: Math.min(50, Math.max(1, Number(this.form.conhecimentoVetorialTopK) || 8)),
          tool_tasks_config: this.buildToolTasksConfigPayload(),
          http_tools_config: this.buildHttpToolsConfigPayload(),
          ...this.montarPayloadContratoAssinatura()
          };

        const response = await api.patch(`/painel/ia/treinamento/${id}`, payload);
        
        // Se integração Cal.com está ativa, salvar configuração também
        if (this.form.calcomIntegracaoAtiva && this.calcomToken && this.calcomToken !== '***') {
          try {
            await this.salvarConfiguracaoCalcomSilencioso();
          } catch (e) {
            // Se falhar ao salvar configuração Cal.com, continua salvando o treinamento
            console.warn('Erro ao salvar configuração Cal.com:', e);
          }
        }
        
        const treinamentoAtualizado = response.data?.treinamento;

        const idx = this.treinamentosExistentes.findIndex(t => t.id === id);
        if (idx !== -1) {
          this.treinamentosExistentes.splice(idx, 1, treinamentoAtualizado);
        } else {
          this.treinamentosExistentes.push(treinamentoAtualizado);
        }

        this.selectedTrainingId = treinamentoAtualizado.id;

        if (Array.isArray(treinamentoAtualizado?.http_tools_config)) {
          this.form.httpTools = treinamentoAtualizado.http_tools_config.map(tool => this.normalizeHttpToolForForm(tool));
        }

        // Recarregar estatísticas se integração Cal.com estiver ativa
        if (this.form.calcomIntegracaoAtiva) {
          await this.carregarEstatisticasAgendamentos();
        }

        window.showToastSuccess?.('body', 'Treinamento atualizado com sucesso!');
        this.atualizarSnapshotForm();
      } catch (e) {
        const mensagem =
          e?.response?.data?.message ||
          e?.response?.data?.errors?.[Object.keys(e.response.data.errors)[0]]?.[0] ||
          'Erro ao atualizar treinamento.';

        window.showToastDanger?.('body', mensagem);
      } finally {
        loader?.classList.remove('show-overlayer');
      }
    },
    async confirmarDelecao() {
      const loader = document.getElementById('overlayer-loading');
      loader?.classList.add('show-overlayer');

      try {
        const id = this.selectedTrainingId;
        if (!id) {
          window.showToastDanger?.('body', 'Nenhum treinamento selecionado.');
          return;
        }

        await api.delete(`/painel/ia/treinamento/${id}`);

        window.showToastSuccess?.('body', 'Treinamento deletado com sucesso!');
        
        // Remove o treinamento da lista local em vez de recarregar tudo
        const idx = this.treinamentosExistentes.findIndex(t => t.id === id);
        if (idx !== -1) {
          this.treinamentosExistentes.splice(idx, 1);
        }
        
        this.selectedTrainingId = '';
        this.resetForm();
      } catch (e) {
        const mensagem =
          e?.response?.data?.message ||
          e?.response?.data?.errors?.[Object.keys(e.response?.data?.errors || {})[0]]?.[0] ||
          'Erro ao deletar treinamento.';

        window.showToastDanger?.('body', mensagem);
      } finally {
        loader?.classList.remove('show-overlayer');
        $('#modalConfirmarDelecao').modal('hide');
      }
    },
    reverseProtecao(valor) {
      switch (valor) {
        case 1: return 'BUILT_IN_WITH_PRICE';
        case 2: return 'BUILT_IN_SEPARATE';
        default: return 'NON_BUILT_IN_PROTECTION';
      }
    },
    async carregarTreinamentoExistente(id) {
      if (id === '__novo__') {
        this.selectedTrainingId = '';
        this.resetForm();
        return;
      }

      const loader = document.getElementById('overlayer-loading');
      loader?.classList.add('show-overlayer');

      try {
        const response = await api.get(`/painel/ia/treinamento/${id}`);
        const data = response.data;

        this.form.nome = data.nome || '';
        this.form.training = data.xml || '';
        this.form.model = data.modelo || '';
        this.form.temperature = parseFloat(data.temperatura) || 0.2;
        this.form.maxTokensResposta = Number.isFinite(Number(data.max_tokens_resposta))
          ? Math.max(100, Number(data.max_tokens_resposta))
          : 400;
        this.form.dividirRespostaSmart =
          data.dividir_resposta_smart === undefined || data.dividir_resposta_smart === null
            ? true
            : Boolean(data.dividir_resposta_smart);

        this.form.tools = [
          ...(data.buscar_equipamento ? ['buscar_equipamento'] : []),
          ...(data.transferir_para_humano ? ['transferir_para_humano'] : []),
          ...(data.buscar_data ? ['busca_data_dia'] : []),
          ...(data.calculo_de_frete ? ['calcular_entrega'] : []),
          ...(data.enviar_foto_equipamento ? ['enviar_foto_equipamento'] : []),
          ...(data.finalizar_locacao ? ['finalizar_locacao'] : []),
          ...(data.pegar_link_online ? ['pegar_link_online'] : []),
          ...(data.locacao_andaime ? ['locacao_andaime'] : []),
          ...(data.gerar_orcamento ? ['gerar_orcamento'] : []),
          ...(data.buscar_endereco_por_cep ? ['buscar_endereco_por_cep'] : []),
          ...(data.nome_e_cumprimentos ? ['nome_e_cumprimentos'] : []),
          ...(data.enviar_contrato_assinatura ? ['enviar_contrato_assinatura'] : []),
          ...(Array.isArray(data.redirecionar_outros_assuntos) && data.redirecionar_outros_assuntos.length > 0 ? ['redirecionar_outros_assuntos'] : [])
        ];

        this.form.pipelineWhenToEndLease = data.finalizar_locacao_info?.pipelineId || '';
        this.form.phaseWhenToEndLease = data.finalizar_locacao_info?.faseId || '';

        this.form.pipelineWhenGenerateBudget = data.gerar_orcamento_info?.pipelineId || '';
        this.form.phaseWhenGenerateBudget = data.gerar_orcamento_info?.faseId || '';

        this.form.pipelineWhenOffline = data.cliente_offline_info?.pipelineId || '';
        this.form.offlinePhase = data.cliente_offline_info?.faseId || '';

        this.form.pipelineWhenWantsAttendant = data.transferir_para_humano_info?.pipelineId || '';
        this.form.phaseWhenWantsAttendant = data.transferir_para_humano_info?.faseId || '';

        // Carregar configuração de finalização de locação
        if (data.finalizar_locacao_config) {
          this.form.finalizarLocacaoConfig = {
            exigir_cnh: data.finalizar_locacao_config.exigir_cnh ?? false,
            periodicidade_cnh: data.finalizar_locacao_config.periodicidade_cnh ?? 'sempre',
            exigir_comprovante_residencia: data.finalizar_locacao_config.exigir_comprovante_residencia ?? false,
            periodicidade_comprovante: data.finalizar_locacao_config.periodicidade_comprovante ?? 'sempre',
            exigir_reconhecimento_facial: data.finalizar_locacao_config.exigir_reconhecimento_facial ?? false,
            fazer_consulta_serasa: data.finalizar_locacao_config.fazer_consulta_serasa ?? false,
            aprovacao_automatica: data.finalizar_locacao_config.aprovacao_automatica ?? false,
            score_minimo_aprovacao: data.finalizar_locacao_config.score_minimo_aprovacao ?? 600,
            nao_aprovar_pendencias: data.finalizar_locacao_config.nao_aprovar_pendencias ?? false,
            limite_consultas_redflag: data.finalizar_locacao_config.limite_consultas_redflag ?? 30,
            gerar_orcamento_automatico: data.finalizar_locacao_config.gerar_orcamento_automatico ?? false,
            criar_cliente_auto: data.finalizar_locacao_config.criar_cliente_auto ?? false,
            buscar_ccl: data.finalizar_locacao_config.buscar_ccl ?? false
          };
        } else {
          // Resetar para valores padrão se não existir configuração
          this.form.finalizarLocacaoConfig = {
            exigir_cnh: false,
            periodicidade_cnh: 'sempre',
            exigir_comprovante_residencia: false,
            periodicidade_comprovante: 'sempre',
            exigir_reconhecimento_facial: false,
            fazer_consulta_serasa: false,
            aprovacao_automatica: false,
            score_minimo_aprovacao: 600,
            nao_aprovar_pendencias: false,
            limite_consultas_redflag: 30,
            gerar_orcamento_automatico: false,
            criar_cliente_auto: false,
            buscar_ccl: false
          };
        }

        const cfgContrato = data.enviar_contrato_assinatura_config;
        if (cfgContrato && typeof cfgContrato === 'object') {
          this.form.contratoAssinaturaModo = cfgContrato.modo === 'anexar' ? 'anexar' : 'modelo';
          this.form.contratoAssinaturaModeloId =
            cfgContrato.modelo_contrato_id != null && cfgContrato.modelo_contrato_id !== ''
              ? String(cfgContrato.modelo_contrato_id)
              : '';
          this.form.contratoAssinaturaArquivoS3 = cfgContrato.arquivo_s3 || '';
          this.form.contratoAssinaturaArquivoNome = cfgContrato.arquivo_nome_original || '';
          this.form.contratoAssinaturaTemplateId =
            cfgContrato.config_hyperflow_template_id != null && cfgContrato.config_hyperflow_template_id !== ''
              ? String(cfgContrato.config_hyperflow_template_id)
              : '';
        } else {
          this.form.contratoAssinaturaModo = 'modelo';
          this.form.contratoAssinaturaModeloId = '';
          this.form.contratoAssinaturaArquivoS3 = '';
          this.form.contratoAssinaturaArquivoNome = '';
          this.form.contratoAssinaturaTemplateId = '';
        }
        this.arquivoContratoAssinaturaPendente = null;

        this.form.attendantWhenEndLease = data.atendente_finalizar_locacao || '';
        this.form.attendantWhenGenerateBudget = data.atendente_gerar_orcamento || '';
        this.form.attendantWhenOffline = data.atendente_cliente_offline || '';
        this.form.wantsAttendant = data.atendente_transferir_para_humano || '';

        const balanceamentoConfig = data.atendente_balanceamento_config || {};
        this.form.attendantBalanceamentoFinalizarLocacao = !!balanceamentoConfig.finalizar_locacao;
        this.form.attendantBalanceamentoGerarOrcamento = !!balanceamentoConfig.gerar_orcamento;
        this.form.attendantBalanceamentoOffline = !!balanceamentoConfig.cliente_offline;
        this.form.attendantBalanceamentoConsultor = !!balanceamentoConfig.transferir_para_humano;

        this.form.sendProductPrice = data.enviar_preco_produto || false;
        this.form.sendImageInListing = data.enviar_imagem_na_listagem || false;
        this.form.sendAllProductImages = data.enviar_todas_imagens_produto || false;
        this.form.buscarEquipamentoIncluirDescricao = !!data.buscar_equipamento_incluir_descricao;
        this.form.buscarEquipamentoIncluirAcessorios = !!data.buscar_equipamento_incluir_acessorios;
        this.form.buscarEquipamentoIncluirLinkEcommerce = !!data.buscar_equipamento_incluir_link_ecommerce;
        this.form.buscarEquipamentoCategoriaIds = Array.isArray(data.buscar_equipamento_categoria_ids)
          ? data.buscar_equipamento_categoria_ids.map(id => Number(id)).filter(id => Number.isFinite(id))
          : [];
        this.form.buscarEquipamentoCategoriaMatchMode = ['any', 'all', 'exact'].includes(data.buscar_equipamento_categoria_match_mode)
          ? data.buscar_equipamento_categoria_match_mode
          : 'any';
        this.form.buscarEquipamentoAnalisarCustoBeneficio = !!data.buscar_equipamento_analisar_custo_beneficio;
        this.form.sendDocumentBudgetConversation = data.enviar_documento_orcamento_conversa || false;
        this.form.modeloOrcamentoEnvioConversaId =
          data.modelo_orcamento_envio_conversa_id != null
            ? String(data.modelo_orcamento_envio_conversa_id)
            : '';
        this.form.sendTypeProtection = this.reverseProtecao(data.protecao);

        this.form.redirecionamentos = Array.isArray(data.redirecionar_outros_assuntos)
          ? data.redirecionar_outros_assuntos.map(item => {
            const usuario = item.userId ?? item.atendenteId ?? item.user_id ?? '';
            const usuarioString = usuario === null ? '' : String(usuario);

            return {
              pipelineId: item.pipelineId ?? '',
              faseId: item.faseId ?? '',
              descricao: item.descricao ?? '',
              atendenteId: usuarioString,
              userId: usuarioString,
              tag_ids: Array.isArray(item.tag_ids) ? item.tag_ids.map(id => Number(id)) : [],
              atribuir_por_balanceamento: !!item.atribuir_por_balanceamento,
            };
          })
          : [];

        this.form.toolTags = this.fromBackendToolTagsConfig(data.tool_tags_config);
        this.form.toolTasksEnabled = Boolean(data.tool_tasks_config?.__enabled);
        this.form.toolTasks = this.fromBackendToolTasksConfig(data.tool_tasks_config);
        this.form.httpTools = Array.isArray(data.http_tools_config)
          ? data.http_tools_config.map(tool => this.normalizeHttpToolForForm(tool))
          : [];

        this.form.displayExibition = Number(data.display_exibition ?? 0);
        this.form.chargeChatTime   = Number(data.charge_chat_time ?? 0);
        this.form.chargeChatRetrys = Number(data.charge_chat_retrys ?? 1);
        
        // Cal.com
        this.form.calcomIntegracaoAtiva = data.calcom_integracao_ativa || false;
        if (this.form.calcomIntegracaoAtiva) {
          await this.carregarConfiguracaoCalcom();
          await this.carregarEstatisticasAgendamentos();
        } else {
          this.estatisticasAgendamentos = null;
        }

        // Base de conhecimento
        this.form.conhecimentoVetorialAtivo = !!data.conhecimento_vetorial_ativo;
        this.form.conhecimentoVetorialTopK = Number.isFinite(Number(data.conhecimento_vetorial_top_k))
          ? Math.min(50, Math.max(1, Number(data.conhecimento_vetorial_top_k)))
          : 8;
        await this.carregarDocumentosConhecimento();
        
        // Carregar todas as fases em paralelo para melhor performance
        const promises = [
          this.loadFases('endLease'),
          this.loadFases('generateBudget'),
          this.loadFases('offline'),
          this.loadFases('human')
        ];

        if (this.form.redirecionamentos.length > 0) {
          promises.push(this.carregarFasesRedirecionamentos());
        }

        await Promise.all(promises);

        this.modoEdicao = true;
        this.atualizarSnapshotForm();
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao carregar dados do treinamento.');
      } finally {
        loader?.classList.remove('show-overlayer');
      }
    },
    async getTreinamentos() {
      try {
        if (!window.lojaId) {
          this.treinamentosExistentes = [];
        } else {
          const response = await api.get('/painel/ia/treinamentos', {
            params: { lojaId: window.lojaId }
          });
  
          this.treinamentosExistentes = response.data || [];
        }
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao carregar treinamentos.');
      }
    },
    async getModelosOrcamento() {
      try {
        if (!window.lojaId) {
          this.modelosOrcamentoDisponiveis = [];

          return;
        }
        const response = await api.get('/painel/ia/modelos-orcamento', {
          params: { lojaId: window.lojaId }
        });
        this.modelosOrcamentoDisponiveis = response.data || [];
      } catch (e) {
        this.modelosOrcamentoDisponiveis = [];
        window.showToastDanger?.('body', 'Erro ao carregar modelos de orçamento.');
      }
    },
    async getModelosContrato() {
      try {
        if (!window.lojaId) {
          this.modelosContratoDisponiveis = [];

          return;
        }
        const response = await api.get('/painel/ia/modelos-contrato', {
          params: { lojaId: window.lojaId }
        });
        this.modelosContratoDisponiveis = response.data || [];
      } catch (e) {
        this.modelosContratoDisponiveis = [];
      }
    },
    async abrirModalContratoAssinatura() {
      await this.getModelosContrato();
      this.mostrarModalContratoAssinatura = true;
    },
    fecharModalContratoAssinatura() {
      this.mostrarModalContratoAssinatura = false;
    },
    async confirmarModalContratoAssinatura() {
      if (this.form.contratoAssinaturaModo === 'modelo') {
        if (!this.form.contratoAssinaturaModeloId) {
          window.showToastDanger?.('body', 'Selecione um modelo de contrato.');

          return;
        }
        this.fecharModalContratoAssinatura();
        window.showToastSuccess?.('body', 'Modo modelo definido. Salve o treinamento para gravar.');

        return;
      }
      const input = this.$refs.inputContratoAssinatura;
      const file = input && input.files && input.files[0] ? input.files[0] : null;
      if (!file) {
        if (!this.form.contratoAssinaturaArquivoS3) {
          window.showToastDanger?.('body', 'Selecione um arquivo ou salve o treinamento após enviar um anexo.');

          return;
        }
        this.fecharModalContratoAssinatura();

        return;
      }
      if (!this.selectedTrainingId) {
        this.arquivoContratoAssinaturaPendente = file;
        this.fecharModalContratoAssinatura();
        window.showToastSuccess?.('body', 'Arquivo será enviado ao criar o treinamento. Salve o treinamento em seguida.');

        return;
      }
      try {
        const fd = new FormData();
        fd.append('arquivo', file);
        const res = await api.post(
          `/painel/ia/treinamento/${this.selectedTrainingId}/contrato-assinatura-anexo`,
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        const t = res.data?.treinamento;
        if (t && t.enviar_contrato_assinatura_config) {
          const c = t.enviar_contrato_assinatura_config;
          this.form.contratoAssinaturaArquivoS3 = c.arquivo_s3 || '';
          this.form.contratoAssinaturaArquivoNome = c.arquivo_nome_original || '';
          this.form.contratoAssinaturaModo = 'anexar';
        }
        this.arquivoContratoAssinaturaPendente = null;
        this.fecharModalContratoAssinatura();
        window.showToastSuccess?.('body', 'Arquivo enviado. Salve o treinamento para concluir.');
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao enviar o arquivo.');
      }
    },
    montarPayloadContratoAssinatura() {
      if (!this.form.tools.includes('enviar_contrato_assinatura')) {
        return {
          enviar_contrato_assinatura: false,
          enviar_contrato_assinatura_config: null
        };
      }
      const modo = this.form.contratoAssinaturaModo === 'anexar' ? 'anexar' : 'modelo';
      const cfg = { modo };
      if (modo === 'modelo') {
        cfg.modelo_contrato_id = this.form.contratoAssinaturaModeloId
          ? Number(this.form.contratoAssinaturaModeloId)
          : null;
      } else {
        cfg.arquivo_s3 = this.form.contratoAssinaturaArquivoS3 || null;
        if (this.form.contratoAssinaturaArquivoNome) {
          cfg.arquivo_nome_original = this.form.contratoAssinaturaArquivoNome;
        }
      }
      const tid = String(this.form.contratoAssinaturaTemplateId || '').trim();
      if (tid !== '') {
        cfg.config_hyperflow_template_id = Number(tid);
      }
      return {
        enviar_contrato_assinatura: true,
        enviar_contrato_assinatura_config: cfg
      };
    },
    validarContratoAssinaturaParaSalvar() {
      if (!this.form.tools.includes('enviar_contrato_assinatura')) {
        return null;
      }
      if (this.form.contratoAssinaturaModo === 'modelo') {
        if (!this.form.contratoAssinaturaModeloId) {
          return 'Com “Enviar contrato para assinatura” ativo, selecione um modelo de contrato ou use o modo anexar.';
        }
        return null;
      }
      if (!this.form.contratoAssinaturaArquivoS3 && !this.arquivoContratoAssinaturaPendente) {
        return 'Envie um arquivo de contrato na configuração da ferramenta (modo anexar).';
      }
      return null;
    },
    async syncUploadContratoAssinaturaPendente(treinamentoId) {
      if (!this.arquivoContratoAssinaturaPendente || !treinamentoId) {
        return;
      }
      const fd = new FormData();
      fd.append('arquivo', this.arquivoContratoAssinaturaPendente);
      const res = await api.post(
        `/painel/ia/treinamento/${treinamentoId}/contrato-assinatura-anexo`,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      const t = res.data?.treinamento;
      if (t && t.enviar_contrato_assinatura_config) {
        const c = t.enviar_contrato_assinatura_config;
        this.form.contratoAssinaturaArquivoS3 = c.arquivo_s3 || '';
        this.form.contratoAssinaturaArquivoNome = c.arquivo_nome_original || '';
        this.form.contratoAssinaturaModo = 'anexar';
      }
      this.arquivoContratoAssinaturaPendente = null;
    },
    async salvarTreinamento() {
      const loader = document.getElementById('overlayer-loading');
      loader?.classList.add('show-overlayer');

      try {
        const msgContrato = this.validarContratoAssinaturaParaSalvar();
        if (msgContrato) {
          window.showToastDanger?.('body', msgContrato);
          return;
        }
        if (!this.commitHttpToolDraftIfOpen()) {
          return;
        }
        const enviarAnexoDepoisDoCreate =
          this.form.tools.includes('enviar_contrato_assinatura') &&
          this.form.contratoAssinaturaModo === 'anexar' &&
          !!this.arquivoContratoAssinaturaPendente;
        const contratoPayload =
          enviarAnexoDepoisDoCreate && !this.selectedTrainingId
            ? { enviar_contrato_assinatura: false, enviar_contrato_assinatura_config: null }
            : this.montarPayloadContratoAssinatura();

        const msgToolTasks = this.validarToolTasksParaSalvar();
        if (msgToolTasks) {
          window.showToastDanger?.('body', msgToolTasks);
          return;
        }

        const payload = {
          nome: this.form.nome,
          xml: this.form.training,
          modelo: this.form.model,
          temperatura: this.form.temperature,
          max_tokens_resposta: Number(this.form.maxTokensResposta),
          dividir_resposta_smart: Boolean(this.form.dividirRespostaSmart),
          loja_id: window.lojaId,
          user_id: window.userId,

          // ferramentas
          buscar_equipamento: this.form.tools.includes('buscar_equipamento'),
          buscar_equipamento_incluir_descricao:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoIncluirDescricao,
          buscar_equipamento_incluir_acessorios:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoIncluirAcessorios,
          buscar_equipamento_incluir_link_ecommerce:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoIncluirLinkEcommerce,
          buscar_equipamento_categoria_ids: this.form.tools.includes('buscar_equipamento')
            ? this.form.buscarEquipamentoCategoriaIds.map(id => Number(id))
            : [],
          buscar_equipamento_categoria_match_mode:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoCategoriaIds.length
              ? this.form.buscarEquipamentoCategoriaMatchMode
              : 'any',
          buscar_equipamento_analisar_custo_beneficio:
            this.form.tools.includes('buscar_equipamento') && this.form.buscarEquipamentoAnalisarCustoBeneficio,
          transferir_para_humano: this.form.tools.includes('transferir_para_humano'),
          buscar_data: this.form.tools.includes('busca_data_dia'),
          calculo_de_frete: this.form.tools.includes('calcular_entrega'),
          enviar_foto_equipamento: this.form.tools.includes('enviar_foto_equipamento'),
          finalizar_locacao: this.form.tools.includes('finalizar_locacao'),
          pegar_link_online: this.form.tools.includes('pegar_link_online'),
          locacao_andaime: this.form.tools.includes('locacao_andaime'),
          gerar_orcamento: this.form.tools.includes('gerar_orcamento'),
          enviar_documento_orcamento_conversa: this.form.sendDocumentBudgetConversation,
          modelo_orcamento_envio_conversa_id: this.form.modeloOrcamentoEnvioConversaId
            ? Number(this.form.modeloOrcamentoEnvioConversaId)
            : null,
          buscar_endereco_por_cep: this.form.tools.includes('buscar_endereco_por_cep'),
          nome_e_cumprimentos: this.form.tools.includes('nome_e_cumprimentos'),

          // fases com pipeline
          finalizar_locacao_info: {
            pipelineId: this.form.pipelineWhenToEndLease || null,
            faseId: this.form.phaseWhenToEndLease || null,
          },
          gerar_orcamento_info: {
            pipelineId: this.form.pipelineWhenGenerateBudget || null,
            faseId: this.form.phaseWhenGenerateBudget || null,
          },
          cliente_offline_info: {
            pipelineId: this.form.pipelineWhenOffline || null,
            faseId: this.form.offlinePhase || null,
          },
          transferir_para_humano_info: {
            pipelineId: this.form.pipelineWhenWantsAttendant || null,
            faseId: this.form.phaseWhenWantsAttendant || null,
          },

          // atendentes
          atendente_finalizar_locacao: this.form.attendantBalanceamentoFinalizarLocacao ? null : (this.form.attendantWhenEndLease || null),
          atendente_gerar_orcamento: this.form.attendantBalanceamentoGerarOrcamento ? null : (this.form.attendantWhenGenerateBudget || null),
          atendente_transferir_para_humano: this.form.attendantBalanceamentoConsultor ? null : (this.form.wantsAttendant || null),
          atendente_cliente_offline: this.form.attendantBalanceamentoOffline ? null : (this.form.attendantWhenOffline || null),
          atendente_balanceamento_config: this.buildAtendenteBalanceamentoConfig(),

          // ações extra
          enviar_preco_produto: this.form.sendProductPrice,
          enviar_imagem_na_listagem: this.form.sendImageInListing,
          enviar_todas_imagens_produto: this.form.sendAllProductImages,

          // redirecionamento
          redirecionar_outros_assuntos: this.form.redirecionamentos,

          // proteção
          protecao: this.mapProtecao(this.form.sendTypeProtection),
          
          // display de equipamentos
          display_exibition: Number(this.form.displayExibition),
            charge_chat_time: Number(this.form.chargeChatTime),
            charge_chat_retrys: Number(this.form.chargeChatRetrys),
          finalizar_locacao_config: this.form.finalizarLocacaoConfig,
            calcom_integracao_ativa: this.form.calcomIntegracaoAtiva,
            calcom_round_robin: this.calcomRoundRobin,
            calcom_marcar_agenda_info: {
              pipelineId: this.calcomPipelineMarcarAgenda || null,
              faseId: this.calcomFaseMarcarAgenda || null
            },
            calcom_atendente_marcar_agenda: this.calcomAtendenteMarcarAgenda || null,
            calcom_cancelar_agenda_info: {
              pipelineId: this.calcomPipelineCancelarAgenda || null,
              faseId: this.calcomFaseCancelarAgenda || null
            },
            calcom_atendente_cancelar_agenda: this.calcomAtendenteCancelarAgenda || null,
            calcom_remarcar_agenda_info: {
              pipelineId: this.calcomPipelineRemarcarAgenda || null,
              faseId: this.calcomFaseRemarcarAgenda || null
            },
            calcom_atendente_remarcar_agenda: this.calcomAtendenteRemarcarAgenda || null,
            calcom_template_lembrete_id: this.calcomTemplateLembrete || null,
            tool_tags_config: this.buildToolTagsConfigPayload(),
            conhecimento_vetorial_ativo: !!this.form.conhecimentoVetorialAtivo,
            conhecimento_vetorial_top_k: Math.min(50, Math.max(1, Number(this.form.conhecimentoVetorialTopK) || 8)),
            tool_tasks_config: this.buildToolTasksConfigPayload(),
            http_tools_config: this.buildHttpToolsConfigPayload(),
          ...contratoPayload
          };

          const response = await api.post('/painel/ia/treinamento', payload);
          
          // Se integração Cal.com está ativa e tem token, salvar configuração após criar treinamento
          if (this.form.calcomIntegracaoAtiva && this.calcomToken && response.data?.treinamento?.id) {
            this.selectedTrainingId = response.data.treinamento.id;
            try {
              await this.salvarConfiguracaoCalcomSilencioso();
            } catch (e) {
              console.warn('Erro ao salvar configuração Cal.com:', e);
            }
          }
        const novoTreinamento = response.data?.treinamento;

        if (!novoTreinamento || !novoTreinamento.id) {
          throw new Error('Treinamento criado, mas sem ID retornado.');
        }

        let treinamentoParaLista = novoTreinamento;
        if (enviarAnexoDepoisDoCreate) {
          await this.syncUploadContratoAssinaturaPendente(novoTreinamento.id);
          const patchContrato = await api.patch(`/painel/ia/treinamento/${novoTreinamento.id}`, {
            loja_id: window.lojaId,
            user_id: window.userId,
            ...this.montarPayloadContratoAssinatura()
          });
          if (patchContrato.data?.treinamento) {
            treinamentoParaLista = patchContrato.data.treinamento;
          }
        }

        this.treinamentosExistentes.push(treinamentoParaLista);
        this.selectedTrainingId = treinamentoParaLista.id;

        if (Array.isArray(treinamentoParaLista?.http_tools_config)) {
          this.form.httpTools = treinamentoParaLista.http_tools_config.map(tool => this.normalizeHttpToolForForm(tool));
        }

        // Não precisa recarregar, já temos os dados do treinamento criado
        window.showToastSuccess?.('body', 'Treinamento criado com sucesso!');
        this.modoEdicao = true;
        this.atualizarSnapshotForm();
      } catch (e) {
        const mensagem =
          e?.response?.data?.message ||
          e?.response?.data?.errors?.[Object.keys(e.response?.data?.errors || {})[0]]?.[0] ||
          'Erro ao salvar treinamento.';
        window.showToastDanger?.('body', mensagem);
      } finally {
        loader?.classList.remove('show-overlayer');
      }
    },
    mapProtecao(tipo) {
      switch (tipo) {
        case 'BUILT_IN_WITH_PRICE': return 1;
        case 'BUILT_IN_SEPARATE': return 2;
        default: return 0;
      }
    },
    defaultHttpTool() {
      return {
        enabled: true,
        name: '',
        slug: '',
        description: '',
        method: 'GET',
        url: '',
        auth: { type: 'none', value: '', value_configured: false, key: '', in: 'header', username: '', password: '', password_configured: false },
        headers: [],
        query_params: [],
        variables: [],
        response_paths: [],
        bodyJson: '{}',
      };
    },
    normalizeHttpToolForForm(tool) {
      return {
        enabled: tool.enabled !== false,
        name: tool.name || '',
        slug: tool.slug || this.gerarSlugHttpTool(tool.name || ''),
        description: tool.description || '',
        method: tool.method || 'GET',
        url: tool.url || '',
        auth: {
          type: tool.auth?.type || 'none',
          value: '',
          value_configured: Boolean(tool.auth?.value_configured),
          key: tool.auth?.key || '',
          in: tool.auth?.in || 'header',
          username: tool.auth?.username || '',
          password: '',
          password_configured: Boolean(tool.auth?.password_configured),
        },
        headers: Array.isArray(tool.headers) ? tool.headers : [],
        query_params: Array.isArray(tool.query_params) ? tool.query_params : [],
        variables: this.normalizeHttpToolVariables(
          Array.isArray(tool.variables) && tool.variables.length
            ? tool.variables
            : this.variablesFromParametersSchema(tool.parameters_schema || {})
        ),
        response_paths: this.responseMappingToRows(tool.response_mapping || {}),
        body: tool.body || {},
        parameters_schema: tool.parameters_schema || {
          type: 'object',
          properties: {},
          required: [],
          additionalProperties: false
        },
        response_mapping: tool.response_mapping || {}
      };
    },
    httpToolToDraft(tool) {
      const normalized = this.normalizeHttpToolForForm(tool);
      return {
        ...normalized,
        headers: this.normalizeHttpToolKeyValueList(normalized.headers),
        query_params: this.normalizeHttpToolKeyValueList(normalized.query_params),
        variables: this.normalizeHttpToolVariables(normalized.variables),
        response_paths: this.normalizeHttpToolResponsePathList(normalized.response_paths),
        bodyJson: this.formatJson(normalized.body),
      };
    },
    abrirNovaHttpTool() {
      this.httpToolDraft = this.defaultHttpTool();
      this.httpToolEditingIndex = null;
      this.httpToolSlugTouched = false;
      this.httpToolPreviewResult = null;
      this.httpToolPreviewArgumentsJson = '{}';
      this.httpToolPreviewOportunidadeId = '';
      this.httpToolSystemVariablesSearch = '';
      this.httpToolSystemVariablesActiveGroup = 'loja';
      this.httpToolSystemVariablesExpanded = false;
      this.httpToolEditorOpen = true;
      this.carregarHttpToolSystemVariables();
    },
    editarHttpTool(index) {
      this.httpToolDraft = this.httpToolToDraft(this.form.httpTools[index]);
      this.httpToolEditingIndex = index;
      this.httpToolSlugTouched = true;
      this.httpToolPreviewResult = null;
      this.httpToolPreviewArgumentsJson = '{}';
      this.httpToolPreviewOportunidadeId = '';
      this.httpToolSystemVariablesSearch = '';
      this.httpToolSystemVariablesActiveGroup = 'loja';
      this.httpToolSystemVariablesExpanded = false;
      this.httpToolEditorOpen = true;
      this.carregarHttpToolSystemVariables();
    },
    removerHttpTool(index) {
      this.form.httpTools.splice(index, 1);
      if (this.httpToolEditingIndex === index) {
        this.fecharHttpToolEditor();
      }
    },
    fecharHttpToolEditor() {
      this.httpToolEditorOpen = false;
      this.httpToolEditingIndex = null;
      this.httpToolSlugTouched = false;
      this.httpToolPreviewLoading = false;
      this.httpToolPreviewResult = null;
      this.httpToolDraft = null;
      this.httpToolFocusedField = null;
    },
    async carregarHttpToolSystemVariables() {
      if (this.httpToolSystemVariables.length) {
        return;
      }

      this.httpToolSystemVariablesLoading = true;
      try {
        const response = await api.get('/painel/ia/treinamento/http-tool/system-variables');
        this.httpToolSystemVariables = response.data?.groups || [];
      } catch (e) {
        this.httpToolSystemVariables = [];
      } finally {
        this.httpToolSystemVariablesLoading = false;
      }
    },
    registrarHttpToolCampoFocado(type, index = null) {
      this.httpToolFocusedField = { type, index };
    },
    inserirHttpToolSystemVariable(key) {
      const snippet = `((${key}))`;
      const field = this.httpToolFocusedField;

      if (field && this.httpToolDraft) {
        if (field.type === 'url') {
          this.httpToolDraft.url = `${this.httpToolDraft.url || ''}${snippet}`;
          window.showToastSuccess?.('body', `Inserido em URL: ${snippet}`);

          return;
        }

        if (field.type === 'body') {
          this.httpToolDraft.bodyJson = `${this.httpToolDraft.bodyJson || ''}${snippet}`;
          window.showToastSuccess?.('body', `Inserido no body: ${snippet}`);

          return;
        }

        if (field.type === 'header' && this.httpToolDraft.headers[field.index]) {
          const header = this.httpToolDraft.headers[field.index];
          header.value = `${header.value || ''}${snippet}`;
          window.showToastSuccess?.('body', `Inserido no header: ${snippet}`);

          return;
        }

        if (field.type === 'query' && this.httpToolDraft.query_params[field.index]) {
          const param = this.httpToolDraft.query_params[field.index];
          param.value = `${param.value || ''}${snippet}`;
          window.showToastSuccess?.('body', `Inserido na query: ${snippet}`);

          return;
        }
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(snippet).then(() => {
          window.showToastSuccess?.('body', `Copiado: ${snippet}`);
        }).catch(() => {
          window.showToastInfo?.('body', snippet);
        });

        return;
      }

      window.showToastInfo?.('body', snippet);
    },
    gerarSlugHttpTool(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9_-]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 64);
    },
    onHttpToolNameInput() {
      if (!this.httpToolSlugTouched && this.httpToolDraft) {
        this.httpToolDraft.slug = this.gerarSlugHttpTool(this.httpToolDraft.name);
      }
    },
    parseHttpToolJson(value, fallback, fieldName) {
      const text = String(value || '').trim();
      if (!text) {
        return fallback;
      }
      try {
        return JSON.parse(text);
      } catch (e) {
        throw new Error(`${fieldName} contém JSON inválido.`);
      }
    },
    gerarHttpToolSchemaDosArgumentosPreview() {
      try {
        const args = this.parseHttpToolJson(this.httpToolPreviewArgumentsJson, {}, 'Argumentos para preview');
        if (!args || typeof args !== 'object' || Array.isArray(args)) {
          throw new Error('Os argumentos para preview devem ser um objeto JSON.');
        }

        const properties = {};
        Object.entries(args).forEach(([key, value]) => {
          properties[key] = {
            type: this.inferJsonSchemaType(value)
          };
        });

        this.httpToolDraft.parametersSchemaJson = this.formatJson({
          type: 'object',
          properties,
          required: Object.keys(properties),
          additionalProperties: false
        });

        window.showToastSuccess?.('body', 'Entradas da IA geradas a partir dos argumentos do preview.');
      } catch (e) {
        window.showToastDanger?.('body', e.message || 'Erro ao gerar entradas da IA.');
      }
    },
    inferJsonSchemaType(value) {
      if (Array.isArray(value)) {
        return 'array';
      }
      if (value === null) {
        return 'string';
      }
      if (typeof value === 'boolean') {
        return 'boolean';
      }
      if (typeof value === 'number') {
        return 'number';
      }
      if (typeof value === 'object') {
        return 'object';
      }

      return 'string';
    },
    normalizarHttpToolVariableName(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9_]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 64);
    },
    normalizeHttpToolVariables(variables) {
      if (!Array.isArray(variables)) {
        return [];
      }

      return variables
        .map(variable => ({
          name: this.normalizarHttpToolVariableName(variable?.name || ''),
          type: ['string', 'number', 'integer', 'boolean', 'array', 'object'].includes(variable?.type)
            ? variable.type
            : 'string',
          required: variable?.required !== false,
          description: variable?.description || ''
        }))
        .filter(variable => variable.name);
    },
    variablesFromParametersSchema(schema) {
      if (!schema || typeof schema !== 'object' || !schema.properties) {
        return [];
      }

      const required = Array.isArray(schema.required) ? schema.required : [];

      return Object.entries(schema.properties).map(([name, config]) => ({
        name,
        type: config?.type || 'string',
        required: required.includes(name),
        description: config?.description || ''
      }));
    },
    adicionarHttpToolVariable() {
      if (!this.httpToolDraft) {
        return;
      }

      if (!Array.isArray(this.httpToolDraft.variables)) {
        this.$set(this.httpToolDraft, 'variables', []);
      }

      this.httpToolDraft.variables.push({
        name: '',
        type: 'string',
        required: true,
        description: ''
      });
    },
    removerHttpToolVariable(index) {
      if (!this.httpToolDraft || !Array.isArray(this.httpToolDraft.variables)) {
        return;
      }

      this.httpToolDraft.variables.splice(index, 1);
    },
    buildHttpToolParametersSchemaFromVariables(variables = null) {
      const normalized = variables !== null
        ? this.normalizeHttpToolVariables(variables)
        : this.normalizeHttpToolVariables(this.httpToolDraft?.variables || []);
      const properties = {};
      const required = [];

      normalized.forEach((variable) => {
        properties[variable.name] = {
          type: variable.type,
          ...(variable.description ? { description: variable.description } : {})
        };

        if (variable.required) {
          required.push(variable.name);
        }
      });

      return {
        type: 'object',
        properties,
        required,
        additionalProperties: false
      };
    },
    extractHttpToolVariableReferencesForDraft(draft) {
      if (!draft) {
        return [];
      }

      const values = [
        draft.url,
        draft.bodyJson,
        ...this.normalizeHttpToolKeyValueList(draft.headers).flatMap(item => [item.key, item.value]),
        ...this.normalizeHttpToolKeyValueList(draft.query_params).flatMap(item => [item.key, item.value])
      ];

      const refs = new Set();
      values.forEach((value) => {
        String(value || '').replace(/\[\[\s*([^\]]+)\s*\]\]/g, (match, name) => {
          const normalized = this.normalizarHttpToolVariableName(name);
          if (normalized) {
            refs.add(normalized);
          }

          return match;
        });
      });

      return Array.from(refs).sort();
    },
    extractHttpToolVariableReferencesFromDraft() {
      return this.extractHttpToolVariableReferencesForDraft(this.httpToolDraft);
    },
    extractHttpToolSystemVariableReferencesForDraft(draft) {
      if (!draft) {
        return [];
      }

      const values = [
        draft.url,
        draft.bodyJson,
        ...this.normalizeHttpToolKeyValueList(draft.headers).flatMap(item => [item.key, item.value]),
        ...this.normalizeHttpToolKeyValueList(draft.query_params).flatMap(item => [item.key, item.value]),
      ];

      const refs = new Set();
      values.forEach((value) => {
        String(value || '').replace(/\(\(\s*([^)]+)\s*\)\)/g, (match, key) => {
          const normalized = String(key || '').trim();
          if (normalized) {
            refs.add(normalized);
          }

          return match;
        });
      });

      return Array.from(refs).sort();
    },
    extractHttpToolSystemVariableReferencesFromDraft() {
      return this.extractHttpToolSystemVariableReferencesForDraft(this.httpToolDraft);
    },
    validateHttpToolSystemVariables(draft) {
      const refs = this.extractHttpToolSystemVariableReferencesForDraft(draft);
      if (!refs.length || !this.httpToolSystemVariableKeys.length) {
        return;
      }

      const allowed = new Set(this.httpToolSystemVariableKeys);
      const unknown = refs.filter(key => !allowed.has(key));
      if (unknown.length) {
        throw new Error(
          `Variáveis de sistema desconhecidas: ${unknown.map(key => `((${key}))`).join(', ')}`
        );
      }
    },
    validateHttpToolVariables(draft) {
      if (!draft || !Array.isArray(draft.variables)) {
        return;
      }

      const hasEmptyName = draft.variables.some(
        variable => !this.normalizarHttpToolVariableName(variable?.name || '')
      );
      if (hasEmptyName) {
        throw new Error('Preencha o nome de todas as variáveis ou remova as linhas vazias.');
      }

      const registered = new Set(this.normalizeHttpToolVariables(draft.variables).map(variable => variable.name));
      const missing = this.extractHttpToolVariableReferencesForDraft(draft).filter(name => !registered.has(name));
      if (missing.length) {
        throw new Error(
          `Cadastre as variáveis usadas na request antes de salvar: ${missing.map(name => `[[${name}]]`).join(', ')}`
        );
      }
    },
    validateHttpToolAuth(tool) {
      if (!tool || tool.enabled === false) {
        return;
      }

      const auth = tool.auth || {};
      const type = auth.type || 'none';
      const toolName = tool.name || tool.slug || 'HTTP';
      const hasValue = Boolean(String(auth.value || '').trim());
      const hasPassword = Boolean(String(auth.password || '').trim());
      const valueConfigured = Boolean(auth.value_configured);
      const passwordConfigured = Boolean(auth.password_configured);

      if (type === 'bearer' && !hasValue && !valueConfigured) {
        throw new Error(
          `Informe o token Bearer da tool "${toolName}" e salve o treinamento. Sem isso, o preview pode funcionar, mas a IA receberá erro 401.`
        );
      }

      if (type === 'api_key') {
        if (!String(auth.key || '').trim()) {
          throw new Error(`Informe o nome da chave de API da tool "${toolName}".`);
        }
        if (!hasValue && !valueConfigured) {
          throw new Error(
            `Informe o valor da API key da tool "${toolName}" e salve o treinamento. Sem isso, a IA receberá erro 401.`
          );
        }
      }

      if (type === 'basic' && !String(auth.username || '').trim() && !hasPassword && !passwordConfigured) {
        throw new Error(
          `Informe usuário e senha da tool "${toolName}" e salve o treinamento.`
        );
      }
    },
    normalizeHttpToolKeyValueList(items) {
      if (!Array.isArray(items)) {
        return [];
      }

      return items.map((item) => ({
        key: item && item.key != null ? String(item.key) : '',
        value: item && item.value != null ? String(item.value) : ''
      }));
    },
    sanitizeHttpToolKeyValueList(items) {
      return this.normalizeHttpToolKeyValueList(items)
        .map(item => ({
          key: item.key.trim(),
          value: item.value
        }))
        .filter(item => item.key !== '');
    },
    adicionarHttpToolKeyValue(field) {
      if (!this.httpToolDraft) {
        return;
      }

      if (!Array.isArray(this.httpToolDraft[field])) {
        this.$set(this.httpToolDraft, field, []);
      }

      this.httpToolDraft[field].push({ key: '', value: '' });
    },
    removerHttpToolKeyValue(field, index) {
      if (!this.httpToolDraft || !Array.isArray(this.httpToolDraft[field])) {
        return;
      }

      this.httpToolDraft[field].splice(index, 1);
    },
    responseMappingToRows(mapping) {
      if (!mapping || typeof mapping !== 'object') {
        return [];
      }

      const paths = mapping.paths || mapping.selected_paths || [];
      if (typeof paths === 'string') {
        return paths
          .split(',')
          .map(path => path.trim())
          .filter(Boolean)
          .map(path => ({ alias: path, path }));
      }

      if (!Array.isArray(paths)) {
        if (typeof mapping.path === 'string' && mapping.path) {
          return [{ alias: mapping.path, path: mapping.path }];
        }

        return [];
      }

      return paths
        .map((item) => {
          if (typeof item === 'string') {
            return { alias: item, path: item };
          }

          if (!item || typeof item !== 'object') {
            return null;
          }

          const path = item.path || '';
          const alias = item.alias || item.key || path;

          return { alias, path };
        })
        .filter(item => item && item.path);
    },
    normalizeHttpToolResponsePathList(items) {
      if (!Array.isArray(items)) {
        return [];
      }

      return items.map(item => ({
        alias: item && item.alias != null ? String(item.alias) : '',
        path: item && item.path != null ? String(item.path) : ''
      }));
    },
    sanitizeHttpToolResponsePathList(items) {
      return this.normalizeHttpToolResponsePathList(items)
        .map(item => ({
          alias: item.alias.trim() || item.path.trim(),
          path: item.path.trim()
        }))
        .filter(item => item.path !== '');
    },
    adicionarHttpToolResponsePath() {
      if (!this.httpToolDraft) {
        return;
      }

      if (!Array.isArray(this.httpToolDraft.response_paths)) {
        this.$set(this.httpToolDraft, 'response_paths', []);
      }

      this.httpToolDraft.response_paths.push({ alias: '', path: '' });
    },
    removerHttpToolResponsePath(index) {
      if (!this.httpToolDraft || !Array.isArray(this.httpToolDraft.response_paths)) {
        return;
      }

      this.httpToolDraft.response_paths.splice(index, 1);
    },
    adicionarHttpToolResponsePathFromSuggestion(suggestion) {
      if (!this.httpToolDraft || !suggestion || !suggestion.path) {
        return;
      }

      if (!Array.isArray(this.httpToolDraft.response_paths)) {
        this.$set(this.httpToolDraft, 'response_paths', []);
      }

      const exists = this.httpToolDraft.response_paths.some(item => item.path === suggestion.path);
      if (exists) {
        return;
      }

      this.httpToolDraft.response_paths.push({
        alias: suggestion.alias || this.aliasFromJsonPath(suggestion.path),
        path: suggestion.path
      });
    },
    extractHttpToolPreviewPaths(value) {
      const paths = [];
      const seen = new Set();

      const pushPath = (path, sample) => {
        if (!path || seen.has(path)) {
          return;
        }

        seen.add(path);
        paths.push({
          path,
          alias: this.aliasFromJsonPath(path),
          type: this.describeJsonValueType(sample)
        });
      };

      const visit = (current, basePath, depth = 0) => {
        if (depth > 5 || current === null || current === undefined) {
          if (basePath) {
            pushPath(basePath, current);
          }
          return;
        }

        if (Array.isArray(current)) {
          if (!current.length) {
            pushPath(basePath, current);
            return;
          }

          const arrayPath = basePath ? `${basePath}.*` : '*';
          const first = current[0];
          if (first && typeof first === 'object') {
            visit(first, arrayPath, depth + 1);
          } else {
            pushPath(arrayPath, first);
          }
          return;
        }

        if (typeof current === 'object') {
          const entries = Object.entries(current);
          if (!entries.length && basePath) {
            pushPath(basePath, current);
            return;
          }

          entries.forEach(([key, child]) => {
            const childPath = basePath ? `${basePath}.${key}` : key;
            if (child && typeof child === 'object') {
              if (Array.isArray(child)) {
                pushPath(childPath, child);
              }
              visit(child, childPath, depth + 1);
            } else {
              pushPath(childPath, child);
            }
          });
          return;
        }

        pushPath(basePath, current);
      };

      visit(value, '');

      return paths;
    },
    aliasFromJsonPath(path) {
      const wildcard = this.parseHttpToolWildcardPath(path);
      if (wildcard) {
        return this.aliasFromJsonPath(wildcard.field);
      }

      return String(path || '')
        .replace(/\.\*/g, '')
        .split('.')
        .filter(Boolean)
        .slice(-2)
        .join('_')
        .replace(/[^a-zA-Z0-9_]/g, '_')
        .toLowerCase();
    },
    describeJsonValueType(value) {
      if (Array.isArray(value)) {
        return 'lista';
      }
      if (value === null) {
        return 'nulo';
      }
      if (typeof value === 'object') {
        return 'objeto';
      }
      if (typeof value === 'number') {
        return 'número';
      }
      if (typeof value === 'boolean') {
        return 'booleano';
      }

      return 'texto';
    },
    limparHttpToolResponseMapping() {
      if (!this.httpToolDraft) {
        return;
      }

      this.httpToolDraft.response_paths = [];
    },
    buildHttpToolResponseMapping() {
      return this.buildHttpToolResponseMappingFromPaths(this.httpToolDraft?.response_paths || []);
    },
    buildHttpToolResponseMappingFromPaths(paths) {
      const sanitized = this.sanitizeHttpToolResponsePathList(paths);
      if (!sanitized.length) {
        return {};
      }

      return { paths: sanitized };
    },
    renderHttpToolAiOutputFromPreview(rawResponse) {
      const filtered = this.buildHttpToolFilteredPreviewResponse(rawResponse);

      return this.formatJson(filtered);
    },
    buildHttpToolFilteredPreviewResponse(rawResponse) {
      const paths = this.sanitizeHttpToolResponsePathList(this.httpToolDraft?.response_paths || []);
      if (!paths.length) {
        return rawResponse;
      }

      const output = {};
      const grouped = {};

      paths.forEach((item) => {
        const wildcard = this.parseHttpToolWildcardPath(item.path);
        if (wildcard) {
          if (!grouped[wildcard.collection]) {
            grouped[wildcard.collection] = [];
          }
          grouped[wildcard.collection].push({
            alias: this.aliasForHttpToolCollectionField(item.alias, wildcard.field, wildcard.collection),
            field: wildcard.field
          });

          return;
        }

        output[item.alias] = this.getHttpToolPreviewValue(rawResponse, item.path);
      });

      Object.entries(grouped).forEach(([collectionPath, fields]) => {
        const collection = this.getHttpToolPreviewValue(rawResponse, collectionPath);
        output[this.aliasFromJsonPath(collectionPath)] = Array.isArray(collection)
          ? collection.map(item => fields.reduce((row, field) => {
            row[field.alias] = this.getHttpToolPreviewValue(item, field.field);

            return row;
          }, {}))
          : [];
      });

      return output;
    },
    parseHttpToolWildcardPath(path) {
      const marker = '.*.';
      const value = String(path || '');
      const index = value.indexOf(marker);
      if (index === -1) {
        return null;
      }

      const collection = value.slice(0, index);
      const field = value.slice(index + marker.length);

      if (!collection || !field) {
        return null;
      }

      return { collection, field };
    },
    aliasForHttpToolCollectionField(alias, field, collectionPath) {
      const collectionAlias = this.aliasFromJsonPath(collectionPath);
      const value = String(alias || '').trim();
      if (value.startsWith(`${collectionAlias}_`)) {
        return value.slice(collectionAlias.length + 1);
      }

      return value || this.aliasFromJsonPath(field);
    },
    getHttpToolPreviewValue(source, path) {
      const segments = String(path || '').split('.').filter(Boolean);

      const read = (current, rest) => {
        if (!rest.length) {
          return current;
        }

        if (current === undefined || current === null) {
          return undefined;
        }

        const [segment, ...next] = rest;

        if (segment === '*') {
          const values = Array.isArray(current) ? current : Object.values(current);

          return values
            .map(item => read(item, next))
            .filter(value => value !== undefined);
        }

        if (Array.isArray(current)) {
          return current
            .map(item => read(item, rest))
            .filter(value => value !== undefined);
        }

        if (typeof current === 'object') {
          return read(current[segment], next);
        }

        return undefined;
      };

      return read(source, segments);
    },
    buildHttpToolFromDraft() {
      if (!this.httpToolDraft) {
        throw new Error('Nenhuma tool HTTP em edição.');
      }
      const draft = this.httpToolDraft;
      const slug = this.gerarSlugHttpTool(draft.slug || draft.name);
      if (!draft.name) {
        throw new Error('Informe o nome da tool HTTP.');
      }
      if (!slug) {
        throw new Error('Informe um slug válido para a tool HTTP.');
      }
      if (!draft.url) {
        throw new Error('Informe a URL da tool HTTP.');
      }
      const duplicate = this.form.httpTools.some((tool, index) => {
        return index !== this.httpToolEditingIndex && tool.slug === slug;
      });
      if (duplicate) {
        throw new Error(`Já existe uma tool HTTP com o slug ${slug}.`);
      }

      this.validateHttpToolVariables(draft);
      this.validateHttpToolSystemVariables(draft);
      this.validateHttpToolAuth({ ...draft, name: draft.name, slug });
      const variables = this.normalizeHttpToolVariables(draft.variables);

      return {
        enabled: draft.enabled !== false,
        name: draft.name,
        slug,
        description: draft.description || `Executa a requisição interna ${draft.name}.`,
        method: draft.method || 'GET',
        url: draft.url,
        auth: {
          ...(draft.auth || { type: 'none' }),
          value_configured: Boolean(draft.auth?.value_configured),
          password_configured: Boolean(draft.auth?.password_configured),
        },
        headers: this.sanitizeHttpToolKeyValueList(draft.headers),
        query_params: this.sanitizeHttpToolKeyValueList(draft.query_params),
        variables,
        body: this.parseHttpToolJson(draft.bodyJson, {}, 'Body'),
        parameters_schema: this.buildHttpToolParametersSchemaFromVariables(variables),
        response_mapping: this.buildHttpToolResponseMapping(),
        ai_output_template: ''
      };
    },
    httpToolToApiPayload(tool) {
      this.validateHttpToolAuth(tool);
      const variables = this.normalizeHttpToolVariables(
        Array.isArray(tool.variables) && tool.variables.length
          ? tool.variables
          : this.variablesFromParametersSchema(tool.parameters_schema || {})
      );
      const responseMapping = tool.response_mapping && Object.keys(tool.response_mapping).length
        ? tool.response_mapping
        : this.buildHttpToolResponseMappingFromPaths(tool.response_paths || []);
      const body = typeof tool.body === 'object' && tool.body !== null
        ? tool.body
        : this.parseHttpToolJson(tool.bodyJson, {}, 'Body');

      return {
        enabled: tool.enabled !== false,
        name: tool.name,
        slug: tool.slug || this.gerarSlugHttpTool(tool.name || ''),
        description: tool.description || `Executa a requisição interna ${tool.name || ''}.`,
        method: tool.method || 'GET',
        url: tool.url,
        auth: {
          type: tool.auth?.type || 'none',
          value: tool.auth?.value || '',
          value_configured: Boolean(tool.auth?.value_configured),
          key: tool.auth?.key || '',
          in: tool.auth?.in || 'header',
          username: tool.auth?.username || '',
          password: tool.auth?.password || '',
          password_configured: Boolean(tool.auth?.password_configured),
        },
        headers: this.sanitizeHttpToolKeyValueList(tool.headers),
        query_params: this.sanitizeHttpToolKeyValueList(tool.query_params),
        body,
        variables,
        parameters_schema: this.buildHttpToolParametersSchemaFromVariables(variables),
        response_mapping: responseMapping,
        ai_output_template: tool.ai_output_template || ''
      };
    },
    buildHttpToolsConfigPayload() {
      return (this.form.httpTools || []).map(tool => this.httpToolToApiPayload(tool));
    },
    commitHttpToolDraftIfOpen() {
      if (!this.httpToolEditorOpen || !this.httpToolDraft) {
        return true;
      }

      try {
        const tool = this.buildHttpToolFromDraft();
        if (this.httpToolEditingIndex === null) {
          this.form.httpTools.push(tool);
          this.httpToolEditingIndex = this.form.httpTools.length - 1;
        } else {
          this.form.httpTools.splice(this.httpToolEditingIndex, 1, tool);
        }

        return true;
      } catch (e) {
        window.showToastDanger?.('body', e.message || 'Erro ao salvar tool HTTP em edição.');
        return false;
      }
    },
    salvarHttpToolDraft() {
      try {
        const tool = this.buildHttpToolFromDraft();
        if (this.httpToolEditingIndex === null) {
          this.form.httpTools.push(tool);
        } else {
          this.form.httpTools.splice(this.httpToolEditingIndex, 1, tool);
        }
        this.fecharHttpToolEditor();
        window.showToastSuccess?.('body', 'Tool HTTP salva no formulário. Salve o treinamento para persistir.');
      } catch (e) {
        window.showToastDanger?.('body', e.message || 'Erro ao salvar tool HTTP.');
      }
    },
    async previewHttpTool() {
      this.httpToolPreviewLoading = true;
      this.httpToolPreviewResult = null;
      try {
        await this.carregarHttpToolSystemVariables();
        const tool = this.buildHttpToolFromDraft();
        const argumentsPreview = this.parseHttpToolJson(this.httpToolPreviewArgumentsJson, {}, 'Argumentos para preview');
        const oportunidadeId = parseInt(String(this.httpToolPreviewOportunidadeId || '').trim(), 10);
        const response = await api.post('/painel/ia/treinamento/http-tool/preview', {
          tool,
          arguments: argumentsPreview,
          loja_id: window.lojaId,
          ...(Number.isFinite(oportunidadeId) && oportunidadeId > 0 ? { oportunidade_id: oportunidadeId } : {}),
          ...(this.selectedTrainingId ? { treinamento_id: this.selectedTrainingId } : {}),
        });
        this.httpToolPreviewResult = response.data;
        if (
          response.data?.success &&
          this.httpToolDraft?.auth?.type &&
          this.httpToolDraft.auth.type !== 'none' &&
          String(this.httpToolDraft.auth.value || '').trim() &&
          !this.httpToolDraft.auth.value_configured
        ) {
          window.showToastWarning?.(
            'body',
            'Preview executado com o token informado agora. Salve o treinamento para a IA usar esta credencial nas conversas.'
          );
        }
      } catch (e) {
        const message =
          e?.response?.data?.message ||
          e?.response?.data?.errors?.[Object.keys(e.response?.data?.errors || {})[0]]?.[0] ||
          e.message ||
          'Erro ao executar preview da tool HTTP.';
        window.showToastDanger?.('body', message);
      } finally {
        this.httpToolPreviewLoading = false;
      }
    },
    formatJson(value) {
      if (value === undefined || value === null || value === '') {
        return '';
      }
      if (typeof value === 'string') {
        try {
          return JSON.stringify(JSON.parse(value), null, 2);
        } catch (e) {
          return value;
        }
      }
      return JSON.stringify(value, null, 2);
    },
    buildToolTagsConfigPayload() {
      const out = {};
      const tags = this.form.toolTags || {};
      for (const [vueKey, ids] of Object.entries(tags)) {
        const backend = VUE_TOOL_TO_BACKEND_TOOL[vueKey];
        if (backend && Array.isArray(ids) && ids.length) {
          out[backend] = ids.map(id => Number(id));
        }
      }
      return out;
    },
    // ===== Base de conhecimento (RAG) =====
    async carregarDocumentosConhecimento(silencioso = false) {
      if (!this.selectedTrainingId || this.selectedTrainingId === '__novo__') {
        this.conhecimentoDocumentos = [];
        return;
      }
      if (!silencioso) {
        this.conhecimentoCarregando = true;
      }
      try {
        const res = await api.get(
          `/painel/ia/treinamento/${this.selectedTrainingId}/conhecimento/documentos`
        );
        this.conhecimentoDocumentos = Array.isArray(res.data?.documentos) ? res.data.documentos : [];
        if (res.data?.conhecimento_vetorial_top_k) {
          this.form.conhecimentoVetorialTopK = Number(res.data.conhecimento_vetorial_top_k) || this.form.conhecimentoVetorialTopK;
        }
        if (this.temDocumentoProcessando) {
          this.iniciarPollingConhecimento();
        } else {
          this.pararPollingConhecimento();
        }
      } catch (e) {
        this.conhecimentoDocumentos = [];
      } finally {
        this.conhecimentoCarregando = false;
      }
    },
    onSelecionarArquivosConhecimento,
    onArrastarArquivosConhecimento,
    onSoltarArquivosConhecimento,
    definirArquivosConhecimento,
    removerArquivoConhecimentoSelecionado,
    arquivoConhecimentoKey,
    textoResumoArquivosConhecimento,
    limparArquivosSelecionados() {
      this.arquivosConhecimentoSelecionados = [];
      this.conhecimentoDragAtivo = false;
      if (this.$refs.inputKnowledgeFile) {
        this.$refs.inputKnowledgeFile.value = '';
      }
    },
    async enviarArquivosConhecimento() {
      if (!this.selectedTrainingId) {
        window.showToastDanger?.('body', 'Salve o treinamento antes de enviar arquivos.');
        return;
      }
      if (!this.arquivosConhecimentoSelecionados.length) {
        return;
      }
      this.conhecimentoUploading = true;
      const arquivos = [...this.arquivosConhecimentoSelecionados];
      let erros = 0;
      for (const arquivo of arquivos) {
        try {
          const fd = new FormData();
          fd.append('arquivo', arquivo);
          await api.post(
            `/painel/ia/treinamento/${this.selectedTrainingId}/conhecimento/documentos`,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
        } catch (e) {
          erros++;
          const msg = e?.response?.data?.errors?.arquivo?.[0]
            || e?.response?.data?.error
            || `Falha ao enviar ${arquivo.name}`;
          window.showToastDanger?.('body', msg);
        }
      }
      this.conhecimentoUploading = false;
      this.arquivosConhecimentoSelecionados = [];
      if (this.$refs.inputKnowledgeFile) {
        this.$refs.inputKnowledgeFile.value = '';
      }
      if (erros < arquivos.length) {
        window.showToastSuccess?.('body', 'Arquivos enviados. Processando indexação...');
      }
      await this.carregarDocumentosConhecimento(true);
    },
    async importarUrlConhecimento() {
      if (!this.selectedTrainingId) {
        window.showToastDanger?.('body', 'Salve o treinamento antes de importar uma URL.');
        return;
      }
      const url = String(this.conhecimentoUrlInput || '').trim();
      if (!url) {
        return;
      }
      if (!this.urlConhecimentoPareceValida(url)) {
        window.showToastDanger?.('body', 'Informe uma URL válida (ex.: https://www.seusite.com.br/pagina).');
        return;
      }
      this.conhecimentoUrlImportando = true;
      try {
        await api.post(
          `/painel/ia/treinamento/${this.selectedTrainingId}/conhecimento/url`,
          { url }
        );
        window.showToastSuccess?.('body', 'URL enfileirada. Buscando e indexando conteúdo...');
        this.conhecimentoUrlInput = '';
        await this.carregarDocumentosConhecimento(true);
      } catch (e) {
        const msg = e?.response?.data?.error
          || e?.response?.data?.errors?.url?.[0]
          || 'Falha ao importar URL.';
        window.showToastDanger?.('body', msg);
      } finally {
        this.conhecimentoUrlImportando = false;
      }
    },
    urlConhecimentoPareceValida(url) {
      try {
        const u = new URL(url.includes('://') ? url : `https://${url}`);
        return ['http:', 'https:'].includes(u.protocol) && u.hostname.length > 0;
      } catch {
        return false;
      }
    },
    async reindexarDocumentoConhecimento(doc) {
      if (!doc || !this.selectedTrainingId) return;
      try {
        await api.post(
          `/painel/ia/treinamento/${this.selectedTrainingId}/conhecimento/documentos/${doc.id}/reindex`
        );
        window.showToastSuccess?.('body', 'Reprocessamento enfileirado.');
        await this.carregarDocumentosConhecimento(true);
      } catch (e) {
        window.showToastDanger?.('body', e?.response?.data?.error || 'Erro ao reindexar.');
      }
    },
    abrirModalRemoverConhecimento(doc) {
      if (!doc || doc.status === 'processing') return;
      this.documentoConhecimentoParaRemover = doc;
      this.$nextTick(() => {
        $('#modalConfirmarRemoverConhecimento').modal('show');
      });
    },
    fecharModalRemoverConhecimento() {
      $('#modalConfirmarRemoverConhecimento').modal('hide');
      if (!this.removendoDocumentoConhecimento) {
        this.documentoConhecimentoParaRemover = null;
      }
    },
    async confirmarRemoverDocumentoConhecimento() {
      const doc = this.documentoConhecimentoParaRemover;
      if (!doc || !this.selectedTrainingId) return;

      this.removendoDocumentoConhecimento = true;
      try {
        await api.delete(
          `/painel/ia/treinamento/${this.selectedTrainingId}/conhecimento/documentos/${doc.id}`
        );
        window.showToastSuccess?.('body', 'Documento removido.');
        this.fecharModalRemoverConhecimento();
        const removidoId = doc.id;
        this.documentoConhecimentoParaRemover = null;
        this.conhecimentoDocumentos = this.conhecimentoDocumentos.filter(d => d.id !== removidoId);
        await this.carregarDocumentosConhecimento(true);
      } catch (e) {
        window.showToastDanger?.('body', e?.response?.data?.error || 'Erro ao remover.');
      } finally {
        this.removendoDocumentoConhecimento = false;
      }
    },
    iniciarPollingConhecimento() {
      this.pararPollingConhecimento();
      this.pollingConhecimentoTimer = setInterval(() => {
        if (!this.temDocumentoProcessando) {
          this.pararPollingConhecimento();
          return;
        }
        this.carregarDocumentosConhecimento(true);
      }, 5000);
    },
    pararPollingConhecimento() {
      if (this.pollingConhecimentoTimer) {
        clearInterval(this.pollingConhecimentoTimer);
        this.pollingConhecimentoTimer = null;
      }
    },
    statusLabel(status) {
      switch (status) {
        case 'pending': return 'Pendente';
        case 'processing': return 'Processando';
        case 'ready': return 'Pronto';
        case 'error': return 'Erro';
        default: return status || '-';
      }
    },
    statusBadgeClass(status) {
      switch (status) {
        case 'pending': return 'badge-secondary';
        case 'processing': return 'badge-info';
        case 'ready': return 'badge-success';
        case 'error': return 'badge-danger';
        default: return 'badge-light';
      }
    },
    statusIcon(status) {
      switch (status) {
        case 'pending': return 'far fa-clock';
        case 'processing': return 'fas fa-spinner fa-spin';
        case 'ready': return 'fas fa-check-circle';
        case 'error': return 'fas fa-exclamation-circle';
        default: return 'far fa-circle';
      }
    },
    iconeDocumentoConhecimento(doc) {
      if (doc && doc.source_type === 'url') {
        return 'fa fa-link text-primary';
      }
      return this.iconePorExtensao(doc?.nome_original);
    },
    tituloDocumentoConhecimento(doc) {
      if (doc && doc.source_type === 'url' && doc.source_url) {
        return doc.source_url;
      }
      return doc?.nome_original || '';
    },
    iconePorExtensao(nome) {
      const ext = String(nome || '').split('.').pop().toLowerCase();
      const map = {
        pdf: 'far fa-file-pdf text-danger',
        doc: 'far fa-file-word text-primary',
        docx: 'far fa-file-word text-primary',
        txt: 'far fa-file-alt text-secondary',
        md: 'far fa-file-alt text-secondary',
        log: 'far fa-file-alt text-secondary',
        csv: 'far fa-file-excel text-success',
        json: 'far fa-file-code text-warning',
        xml: 'far fa-file-code text-warning',
        html: 'far fa-file-code text-warning',
        htm: 'far fa-file-code text-warning'
      };
      return map[ext] || 'far fa-file text-muted';
    },
    formatarTamanho(bytes) {
      const n = Number(bytes) || 0;
      if (n < 1024) return `${n} B`;
      if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
      return `${(n / (1024 * 1024)).toFixed(2)} MB`;
    },
    formatarData(dataIso) {
      if (!dataIso) return '';
      const d = new Date(dataIso);
      if (isNaN(d.getTime())) return '';
      const dia = String(d.getDate()).padStart(2, '0');
      const mes = String(d.getMonth() + 1).padStart(2, '0');
      const ano = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');
      return `${dia}/${mes}/${ano} ${hh}:${mm}`;
    },
    truncar(texto, max) {
      const s = String(texto || '');
      if (s.length <= max) return s;
      return s.slice(0, max - 1) + '…';
    },
    fromBackendToolTagsConfig(cfg) {
      if (!cfg || typeof cfg !== 'object') {
        return {};
      }
      const rev = {};
      for (const [k, v] of Object.entries(VUE_TOOL_TO_BACKEND_TOOL)) {
        rev[v] = k;
      }
      const out = {};
      for (const [backendName, ids] of Object.entries(cfg)) {
        const vueKey = rev[backendName];
        if (vueKey && Array.isArray(ids)) {
          out[vueKey] = ids.map(id => Number(id));
        }
      }
      return out;
    },
    buildToolTasksConfigPayload() {
      const out = {
        __enabled: Boolean(this.form.toolTasksEnabled)
      };
      const tasks = this.form.toolTasks || {};
      for (const [vueKey, rules] of Object.entries(tasks)) {
        const backend = VUE_TOOL_TO_BACKEND_TOOL[vueKey];
        if (!backend || !Array.isArray(rules) || !rules.length) {
          continue;
        }

        const normalizedRules = rules.map(rule => this.normalizeToolTaskRule(vueKey, rule));
        if (normalizedRules.length) {
          out[backend] = normalizedRules;
        }
      }
      return out;
    },
    fromBackendToolTasksConfig(cfg) {
      if (!cfg || typeof cfg !== 'object') {
        return {};
      }
      const rev = {};
      for (const [k, v] of Object.entries(VUE_TOOL_TO_BACKEND_TOOL)) {
        rev[v] = k;
      }
      const out = {};
      for (const [backendName, rules] of Object.entries(cfg)) {
        if (backendName === '__enabled') {
          continue;
        }
        const vueKey = rev[backendName] || backendName;
        if (vueKey && Array.isArray(rules)) {
          out[vueKey] = rules.map(rule => this.normalizeToolTaskRule(vueKey, rule));
        }
      }
      return out;
    },
    normalizeToolTaskRule(toolKey, rule = {}) {
      const responsible = rule.responsible && typeof rule.responsible === 'object'
        ? rule.responsible
        : {};
      const fallbackMode = this.toolTaskHasFallback(toolKey) ? 'tool_transfer_fallback' : 'explicit_user';
      const mode = responsible.mode || fallbackMode;
      const deadline = rule.deadline && typeof rule.deadline === 'object'
        ? rule.deadline
        : {};
      const offsetBefore = deadline.offset_before && typeof deadline.offset_before === 'object'
        ? deadline.offset_before
        : {};

      return {
        id: rule.id || `task_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        enabled: rule.enabled !== false,
        type: rule.type || 'ligar',
        title: rule.title || '',
        description: rule.description || '',
        responsible: {
          mode,
          user_id: responsible.user_id != null ? String(responsible.user_id) : ''
        },
        deadline: {
          mode: deadline.mode || 'offset',
          value: Number(deadline.value ?? 30),
          unit: deadline.unit || 'minutes',
          time: deadline.time || '09:00',
          next_business_day: deadline.next_business_day !== false,
          field: deadline.field || 'data_inicio',
          offset_before: {
            value: Number(offsetBefore.value ?? 0),
            unit: offsetBefore.unit || 'minutes'
          }
        },
        template_id: rule.template_id != null ? String(rule.template_id) : '',
        dedupe: rule.dedupe || 'none',
        dispatch_immediately: Boolean(rule.dispatch_immediately)
      };
    },
    validarToolTasksParaSalvar() {
      if (!this.form.toolTasksEnabled) {
        return '';
      }
      const tasks = this.form.toolTasks || {};
      for (const [toolKey, rules] of Object.entries(tasks)) {
        if (!Array.isArray(rules)) {
          continue;
        }
        for (const rule of rules) {
          const task = this.normalizeToolTaskRule(toolKey, rule);
          if (!task.enabled) {
            continue;
          }
          const label = this.toolTaskToolLabel(toolKey);
          if (!task.title) {
            return `Informe o título da tarefa automática em ${label}.`;
          }
          if (task.responsible.mode === 'explicit_user' && !task.responsible.user_id) {
            return `Selecione o atendente da tarefa automática em ${label}.`;
          }
          if (task.responsible.mode === 'tool_transfer_fallback' && !this.toolTaskFallbackConfigured(toolKey)) {
            return `Configure o atendente de transferência ou selecione um usuário para a tarefa automática em ${label}.`;
          }
          if (task.responsible.mode !== 'explicit_user' && task.responsible.mode !== 'tool_transfer_fallback') {
            return `Responsável inválido na tarefa automática em ${label}.`;
          }
          if (!this.toolTaskHasFallback(toolKey) && task.responsible.mode !== 'explicit_user') {
            return `A ferramenta ${label} exige um atendente escolhido manualmente.`;
          }
          if (task.type === 'whatsapp' && !task.template_id) {
            return `Selecione o template de WhatsApp da tarefa automática em ${label}.`;
          }
        }
      }
      return '';
    },
    toolTaskRules(toolKey) {
      return this.form.toolTasks[toolKey] || [];
    },
    abrirModalToolTasks(toolKey) {
      const rules = (this.form.toolTasks[toolKey] || []).map(rule => this.normalizeToolTaskRule(toolKey, rule));
      this.$set(this.form.toolTasks, toolKey, rules);
      this.toolTasksToolKey = toolKey;
      this.mostrarModalToolTasks = true;
    },
    fecharModalToolTasks() {
      this.mostrarModalToolTasks = false;
      this.toolTasksToolKey = '';
      this.mostrarToolTaskPlaceholders = false;
    },
    adicionarToolTask(toolKey) {
      const current = [...(this.form.toolTasks[toolKey] || [])];
      current.push(this.normalizeToolTaskRule(toolKey, {
        enabled: true,
        type: 'ligar',
        title: '',
        description: '',
        responsible: {
          mode: this.toolTaskHasFallback(toolKey) ? 'tool_transfer_fallback' : 'explicit_user',
          user_id: ''
        },
        deadline: { mode: 'offset', value: 30, unit: 'minutes' },
        dedupe: 'none'
      }));
      this.$set(this.form.toolTasks, toolKey, current);
    },
    removerToolTask(toolKey, index) {
      const current = [...(this.form.toolTasks[toolKey] || [])];
      current.splice(index, 1);
      this.$set(this.form.toolTasks, toolKey, current);
    },
    toolTaskToolLabel(toolKey) {
      const labels = {
        buscar_horarios: 'Buscar horários (Cal.com)',
        marcar_reuniao: 'Marcar reunião (Cal.com)',
        cancelar_reuniao: 'Cancelar reunião (Cal.com)'
      };
      return this.toolsDisponiveis[toolKey]?.nome || labels[toolKey] || toolKey;
    },
    toolTaskTypeLabel(type) {
      return this.toolTaskTypes.find(t => t.id === type)?.value || type;
    },
    toolTaskSummary(toolKey) {
      const rules = this.toolTaskRules(toolKey);
      if (!rules.length) {
        return 'Nenhuma tarefa configurada';
      }
      const active = rules.filter(rule => rule.enabled !== false);
      const types = [...new Set(active.map(rule => this.toolTaskTypeLabel(rule.type)).filter(Boolean))];
      return `${active.length} ativa(s)${types.length ? ` - ${types.join(', ')}` : ''}`;
    },
    toolTaskHasFallback(toolKey) {
      return Object.prototype.hasOwnProperty.call(TOOL_TASK_FALLBACK_LABELS, toolKey);
    },
    toolTaskFallbackSelectLabel(toolKey) {
      return `Usar ${TOOL_TASK_FALLBACK_LABELS[toolKey] || 'atendente configurado'}`;
    },
    toolTaskFallbackConfigured(toolKey) {
      const values = {
        finalizar_locacao: this.form.attendantWhenEndLease,
        transferir_para_humano: this.form.wantsAttendant,
        gerar_orcamento: this.form.attendantWhenGenerateBudget,
        marcar_reuniao: this.calcomAtendenteMarcarAgenda,
        cancelar_reuniao: this.calcomAtendenteCancelarAgenda || this.calcomAtendenteRemarcarAgenda
      };
      return Boolean(values[toolKey]);
    },
    toolTaskFallbackStatus(toolKey) {
      if (!this.toolTaskHasFallback(toolKey)) {
        return 'Esta ferramenta exige seleção manual de atendente.';
      }
      return this.toolTaskFallbackConfigured(toolKey)
        ? `Usará ${TOOL_TASK_FALLBACK_LABELS[toolKey]}.`
        : `Configure ${TOOL_TASK_FALLBACK_LABELS[toolKey]} ou escolha um atendente manualmente.`;
    },
    toggleToolTag(toolKey, tagId) {
      const id = Number(tagId);
      const current = [...(this.form.toolTags[toolKey] || [])];
      const i = current.indexOf(id);
      if (i >= 0) {
        current.splice(i, 1);
      } else {
        current.push(id);
      }
      this.$set(this.form.toolTags, toolKey, current);
    },
    isToolTagSelected(toolKey, tagId) {
      return (this.form.toolTags[toolKey] || []).includes(Number(tagId));
    },
    toggleNovoRedirecionamentoTag(tagId) {
      const id = Number(tagId);
      const arr = [...(this.novoRedirecionamento.tag_ids || [])];
      const i = arr.indexOf(id);
      if (i >= 0) {
        arr.splice(i, 1);
      } else {
        arr.push(id);
      }
      this.novoRedirecionamento.tag_ids = arr;
    },
    isNovoRedirecionamentoTagSelected(tagId) {
      return (this.novoRedirecionamento.tag_ids || []).includes(Number(tagId));
    },
    isRedirecionamentoRowTagSelected(idx, tagId) {
      return (this.form.redirecionamentos[idx].tag_ids || []).includes(Number(tagId));
    },
    isCategoriaBuscaEquipamentoSelected(categoriaId) {
      return (this.form.buscarEquipamentoCategoriaIds || []).includes(Number(categoriaId));
    },
    toggleCategoriaBuscaEquipamento(categoriaId) {
      const id = Number(categoriaId);
      if (!Number.isFinite(id)) {
        return;
      }

      const current = Array.isArray(this.form.buscarEquipamentoCategoriaIds)
        ? [...this.form.buscarEquipamentoCategoriaIds]
        : [];
      const idx = current.indexOf(id);

      if (idx >= 0) {
        current.splice(idx, 1);
      } else {
        current.push(id);
      }

      this.form.buscarEquipamentoCategoriaIds = current;
      if (!current.length) {
        this.form.buscarEquipamentoCategoriaMatchMode = 'any';
      }
    },
    async carregarTagsTreinamento() {
      if (!window.lojaId) {
        this.tagsTreinamento = [];
        return;
      }
      this.loadingTagsTreinamento = true;
      try {
        const res = await api.get('/painel/ia/tags-treinamento', { params: { lojaId: window.lojaId } });
        this.tagsTreinamento = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.tagsTreinamento = [];
      } finally {
        this.loadingTagsTreinamento = false;
      }
    },
    async carregarCategoriasProdutos() {
      if (!window.lojaId) {
        this.categoriasProdutos = [];
        return;
      }

      this.loadingCategoriasProdutos = true;
      try {
        const res = await api.get('/painel/ia/categorias-produtos', { params: { lojaId: window.lojaId } });
        this.categoriasProdutos = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.categoriasProdutos = [];
      } finally {
        this.loadingCategoriasProdutos = false;
      }
    },
    checkRedirecionamentoSelecionado(key) {
      if (key === 'redirecionar_outros_assuntos' && this.form.tools.includes('redirecionar_outros_assuntos')) {
        this.mostrarModalRedirecionamento = true;
      }
    },
    checkFinalizarLocacaoSelecionado(key) {
      // Não abre modal automaticamente, apenas quando clicar no botão Configurar
    },
    fecharModalFinalizarLocacao() {
      this.mostrarModalFinalizarLocacao = false;
      this.abaAtivaFinalizarLocacao = 'documentos';
    },
    salvarConfigFinalizarLocacao() {
      this.mostrarModalFinalizarLocacao = false;
      this.abaAtivaFinalizarLocacao = 'documentos';
      window.showToastSuccess?.('body', 'Configuração de finalização de locação salva!');
    },
    buildAtendenteBalanceamentoConfig() {
      return {
        finalizar_locacao: !!this.form.attendantBalanceamentoFinalizarLocacao,
        gerar_orcamento: !!this.form.attendantBalanceamentoGerarOrcamento,
        cliente_offline: !!this.form.attendantBalanceamentoOffline,
        transferir_para_humano: !!this.form.attendantBalanceamentoConsultor,
      };
    },
    onToggleBalanceamentoAtendente(campoAtendente, ativo) {
      if (ativo) {
        this.form[campoAtendente] = '';
      }
    },
    onToggleBalanceamentoRedirecionamento() {
      if (this.novoRedirecionamento.atribuir_por_balanceamento) {
        this.novoRedirecionamento.atendenteId = '';
        this.novoRedirecionamento.userId = '';
      }
    },
    abrirModalRedirecionar(valor) {
      if (valor && !this.mostrarModalRedirecionamento) {
        this.mostrarModalRedirecionamento = true;
      }
    },
    adicionarRedirecionamento() {
      const {
        pipelineId,
        faseId,
        descricao,
        atendenteId,
        userId,
        tag_ids: tagIds,
        atribuir_por_balanceamento: atribuirPorBalanceamento,
      } = this.novoRedirecionamento;
      if (pipelineId && faseId && descricao.trim()) {
        const usuarioSelecionado = atribuirPorBalanceamento ? '' : (atendenteId || userId || '');
        this.form.redirecionamentos.push({
          pipelineId,
          faseId,
          descricao,
          atendenteId: usuarioSelecionado,
          userId: usuarioSelecionado,
          tag_ids: Array.isArray(tagIds) ? tagIds.map(id => Number(id)) : [],
          atribuir_por_balanceamento: !!atribuirPorBalanceamento,
        });
        this.novoRedirecionamento = {
          pipelineId: '',
          faseId: '',
          descricao: '',
          atendenteId: '',
          userId: '',
          tag_ids: [],
          atribuir_por_balanceamento: false,
        };
        this.fases.redirect = [];
      } else {
        alert('Preencha todos os campos para adicionar.');
      }
    },
    removerRedirecionamento(idx) {
      this.form.redirecionamentos.splice(idx, 1);
    },
    // Cal.com
    onCalcomIntegracaoChange() {
      if (this.form.calcomIntegracaoAtiva) {
        // Abre o modal automaticamente quando habilita
        this.mostrarModalCalcom = true;
        
        // Se já tem treinamento selecionado, carrega configuração
        if (this.selectedTrainingId) {
          this.carregarConfiguracaoCalcom();
        }
      } else {
        this.resetCalcom();
      }
    },
    async carregarConfiguracaoCalcom() {
      if (!this.selectedTrainingId) return;

      try {
        const response = await api.get(`/painel/ia/treinamento/${this.selectedTrainingId}/calcom/configuracao`);
        const config = response.data.configuracao;

        if (config.tem_token) {
          // Não expor token completo, usar placeholder
          this.calcomToken = '***';
          this.calcomTokenValido = config.token_valido;
          this.calcomTokenInvalido = !config.token_valido;
        } else {
          this.calcomToken = '';
          this.calcomTokenValido = false;
          this.calcomTokenInvalido = false;
        }

        this.calcomEventosSelecionados = config.calcom_eventos_vinculados || [];
        this.calcomPodeAgendar = config.calcom_pode_agendar || false;
        this.calcomPodeCancelar = config.calcom_pode_cancelar || false;
        this.calcomSugerirHorarios = config.calcom_sugerir_horarios || false;
        this.calcomPermitirConvidados = config.calcom_permitir_convidados || false;
        this.calcomRoundRobin = !!config.calcom_round_robin;
        
        // Carregar configurações de transferência
        this.calcomPipelineMarcarAgenda = config.calcom_marcar_agenda_info?.pipelineId || '';
        this.calcomFaseMarcarAgenda = config.calcom_marcar_agenda_info?.faseId || '';
        this.calcomAtendenteMarcarAgenda = config.calcom_atendente_marcar_agenda || '';
        
        this.calcomPipelineCancelarAgenda = config.calcom_cancelar_agenda_info?.pipelineId || '';
        this.calcomFaseCancelarAgenda = config.calcom_cancelar_agenda_info?.faseId || '';
        this.calcomAtendenteCancelarAgenda = config.calcom_atendente_cancelar_agenda || '';
        
        this.calcomPipelineRemarcarAgenda = config.calcom_remarcar_agenda_info?.pipelineId || '';
        this.calcomFaseRemarcarAgenda = config.calcom_remarcar_agenda_info?.faseId || '';
        this.calcomAtendenteRemarcarAgenda = config.calcom_atendente_remarcar_agenda || '';
        this.calcomTemplateLembrete = config.calcom_template_lembrete_id || null;
        
        // Carregar fases se houver pipeline selecionado
        if (this.calcomPipelineMarcarAgenda) {
          await this.loadFases('calcomMarcar');
        }
        if (this.calcomPipelineCancelarAgenda) {
          await this.loadFases('calcomCancelar');
        }
        if (this.calcomPipelineRemarcarAgenda) {
          await this.loadFases('calcomRemarcar');
        }

        // Se tem token válido, carregar eventos
        if (this.calcomTokenValido && this.calcomToken === '***') {
          // Tentar carregar eventos usando token do treinamento
          try {
            const treinamento = await api.get(`/painel/ia/treinamento/${this.selectedTrainingId}`);
            if (treinamento.data?.calcom_token) {
              await this.carregarEventosCalcomComToken(treinamento.data.calcom_token);
            }
          } catch (e) {
            console.error('Erro ao obter token do treinamento:', e);
          }
        }
      } catch (error) {
        console.error('Erro ao carregar configuração Cal.com:', error);
      }
    },
    async carregarEventosCalcomComToken(token) {
      this.calcomCarregandoEventos = true;

      try {
        // Se tem treinamento, usa o endpoint com ID, senão usa endpoint genérico
        const url = this.selectedTrainingId 
          ? `/painel/ia/treinamento/${this.selectedTrainingId}/calcom/eventos`
          : '/painel/ia/calcom/eventos';
        
        const response = await api.get(url, { params: { token: token } });

        this.calcomEventosDisponiveis = response.data.eventos || [];

        // Manter seleção atual se os eventos ainda existirem
        if (this.calcomEventosSelecionados.length > 0) {
          const eventosIds = this.calcomEventosDisponiveis.map(e => String(e.id));
          this.calcomEventosSelecionados = this.calcomEventosSelecionados.filter(id => eventosIds.includes(id));
        }
      } catch (error) {
        const mensagem = error?.response?.data?.error || 'Erro ao carregar eventos';
        console.error('Erro ao carregar eventos:', mensagem);
        window.showToastDanger?.('body', mensagem);
        this.calcomEventosDisponiveis = [];
      } finally {
        this.calcomCarregandoEventos = false;
      }
    },
    async validarTokenCalcom() {
      if (!this.calcomToken || this.calcomToken.trim() === '') {
        window.showToastDanger?.('body', 'Token é obrigatório');
        return;
      }

      this.calcomValidandoToken = true;
      this.calcomTokenValido = false;
      this.calcomTokenInvalido = false;

      try {
        // Se tem treinamento, usa o endpoint com ID, senão usa endpoint genérico
        const url = this.selectedTrainingId 
          ? `/painel/ia/treinamento/${this.selectedTrainingId}/calcom/validar-token`
          : '/painel/ia/calcom/validar-token';
        
        const response = await api.post(url, { token: this.calcomToken.trim() });

        this.calcomTokenValido = response.data.valido;
        this.calcomTokenInvalido = !response.data.valido;

        if (this.calcomTokenValido) {
          window.showToastSuccess?.('body', 'Token válido!');
          await this.carregarEventosCalcom();
        } else {
          window.showToastDanger?.('body', response.data.mensagem || 'Token inválido');
        }
      } catch (error) {
        this.calcomTokenInvalido = true;
        const mensagem = error?.response?.data?.mensagem || 'Erro ao validar token';
        window.showToastDanger?.('body', mensagem);
      } finally {
        this.calcomValidandoToken = false;
      }
    },
    async carregarEventosCalcom() {
      // Se token é placeholder ou vazio, tentar usar token do treinamento (se existir)
      if ((this.calcomToken === '***' || !this.calcomToken) && this.selectedTrainingId) {
        try {
          const treinamento = await api.get(`/painel/ia/treinamento/${this.selectedTrainingId}`);
          if (treinamento.data?.calcom_token) {
            await this.carregarEventosCalcomComToken(treinamento.data.calcom_token);
            return;
          }
        } catch (e) {
          console.error('Erro ao obter token do treinamento:', e);
        }
        window.showToastDanger?.('body', 'Token necessário para carregar eventos. Insira o token e valide.');
        return;
      }

      // Se não tem token, não pode carregar
      if (!this.calcomToken || this.calcomToken.trim() === '') {
        window.showToastDanger?.('body', 'Token necessário para carregar eventos. Insira o token e valide.');
        return;
      }

      await this.carregarEventosCalcomComToken(this.calcomToken);
    },
    async salvarConfiguracaoCalcom() {
      // Se não há treinamento selecionado (criando novo), apenas informar que será salvo quando criar o treinamento
      if (!this.selectedTrainingId) {
        // Validação
        if (!this.calcomTokenValido) {
          window.showToastDanger?.('body', 'Token inválido. Valide o token antes de continuar.');
          return;
        }

        const temPermissaoAtiva = this.calcomPodeAgendar || this.calcomPodeCancelar || this.calcomSugerirHorarios;
        if (temPermissaoAtiva && this.calcomEventosSelecionados.length === 0) {
          window.showToastDanger?.('body', 'Selecione pelo menos um evento quando alguma permissão estiver ativa.');
          return;
        }

        // Se está criando um novo treinamento, apenas informar que a configuração será salva quando criar
        window.showToastSuccess?.('body', 'Configuração do Cal.com preparada! Ela será salva automaticamente quando você criar o treinamento.');
        this.fecharModalCalcom();
        return;
      }

      // Validação
      if (!this.calcomTokenValido) {
        window.showToastDanger?.('body', 'Token inválido. Valide o token antes de salvar.');
        return;
      }

      const temPermissaoAtiva = this.calcomPodeAgendar || this.calcomPodeCancelar || this.calcomSugerirHorarios;
      if (temPermissaoAtiva && this.calcomEventosSelecionados.length === 0) {
        window.showToastDanger?.('body', 'Selecione pelo menos um evento quando alguma permissão estiver ativa.');
        return;
      }

      this.calcomSalvando = true;

      try {
        const payload = {
          calcom_token: this.calcomToken === '***' ? undefined : this.calcomToken, // Não enviar se for placeholder
          calcom_integracao_ativa: this.form.calcomIntegracaoAtiva,
          calcom_eventos_vinculados: this.calcomEventosSelecionados,
          calcom_pode_agendar: this.calcomPodeAgendar,
          calcom_pode_cancelar: this.calcomPodeCancelar,
          calcom_sugerir_horarios: this.calcomSugerirHorarios,
          calcom_permitir_convidados: this.calcomPermitirConvidados,
          calcom_round_robin: this.calcomRoundRobin,
          calcom_marcar_agenda_info: {
            pipelineId: this.calcomPipelineMarcarAgenda || null,
            faseId: this.calcomFaseMarcarAgenda || null
          },
          calcom_atendente_marcar_agenda: this.calcomAtendenteMarcarAgenda || null,
          calcom_cancelar_agenda_info: {
            pipelineId: this.calcomPipelineCancelarAgenda || null,
            faseId: this.calcomFaseCancelarAgenda || null
          },
          calcom_atendente_cancelar_agenda: this.calcomAtendenteCancelarAgenda || null,
          calcom_remarcar_agenda_info: {
            pipelineId: this.calcomPipelineRemarcarAgenda || null,
            faseId: this.calcomFaseRemarcarAgenda || null
          },
          calcom_atendente_remarcar_agenda: this.calcomAtendenteRemarcarAgenda || null,
          calcom_template_lembrete_id: this.calcomTemplateLembrete || null,
        };

        await api.post(`/painel/ia/treinamento/${this.selectedTrainingId}/calcom/configuracao`, payload);

        window.showToastSuccess?.('body', 'Configuração do Cal.com salva com sucesso!');
        this.fecharModalCalcom();
      } catch (error) {
        const mensagem = error?.response?.data?.error || 
                        error?.response?.data?.errors?.[Object.keys(error.response.data.errors || {})[0]]?.[0] ||
                        'Erro ao salvar configuração';
        window.showToastDanger?.('body', mensagem);
      } finally {
        this.calcomSalvando = false;
      }
    },
    fecharModalCalcom() {
      this.mostrarModalCalcom = false;
      // Não resetar dados, apenas fechar modal
    },
    resetCalcom() {
      this.calcomToken = '';
      this.calcomTokenValido = false;
      this.calcomTokenInvalido = false;
      this.calcomValidandoToken = false;
      this.calcomEventosDisponiveis = [];
      this.calcomCarregandoEventos = false;
      this.calcomEventosSelecionados = [];
      this.calcomPodeAgendar = false;
      this.calcomPodeCancelar = false;
      this.calcomSugerirHorarios = false;
      this.calcomPermitirConvidados = false;
      this.calcomRoundRobin = false;
      this.calcomPipelineMarcarAgenda = '';
      this.calcomFaseMarcarAgenda = '';
      this.calcomAtendenteMarcarAgenda = '';
      this.calcomPipelineCancelarAgenda = '';
      this.calcomFaseCancelarAgenda = '';
      this.calcomAtendenteCancelarAgenda = '';
      this.calcomPipelineRemarcarAgenda = '';
      this.calcomFaseRemarcarAgenda = '';
      this.calcomAtendenteRemarcarAgenda = '';
      this.calcomTemplateLembrete = null;
      this.mostrarModalCalcom = false;
      this.mostrarModalDetalhesEvento = false;
      this.eventoSelecionadoDetalhes = null;
    },
    toggleEventoSelecionado(eventoId) {
      const idStr = String(eventoId);
      // Criar uma nova cópia do array para garantir reatividade
      const novosSelecionados = [...this.calcomEventosSelecionados];
      const index = novosSelecionados.indexOf(idStr);
      
      if (index > -1) {
        // Remove se já está selecionado
        novosSelecionados.splice(index, 1);
      } else {
        // Adiciona se não está selecionado
        novosSelecionados.push(idStr);
      }
      
      // Atualizar o array de forma reativa
      this.calcomEventosSelecionados = novosSelecionados;
    },
    verDetalhesEvento(evento) {
      this.eventoSelecionadoDetalhes = evento;
      this.mostrarModalDetalhesEvento = true;
    },
    async salvarConfiguracaoCalcomSilencioso() {
      // Versão silenciosa para salvar junto com o treinamento
      if (!this.selectedTrainingId || !this.calcomToken || this.calcomToken === '***') {
        return;
      }

      const payload = {
        calcom_token: this.calcomToken,
        calcom_integracao_ativa: this.form.calcomIntegracaoAtiva,
        calcom_eventos_vinculados: this.calcomEventosSelecionados,
        calcom_pode_agendar: this.calcomPodeAgendar,
        calcom_pode_cancelar: this.calcomPodeCancelar,
        calcom_sugerir_horarios: this.calcomSugerirHorarios,
        calcom_permitir_convidados: this.calcomPermitirConvidados,
        calcom_round_robin: this.calcomRoundRobin,
        calcom_marcar_agenda_info: {
          pipelineId: this.calcomPipelineMarcarAgenda || null,
          faseId: this.calcomFaseMarcarAgenda || null
        },
        calcom_atendente_marcar_agenda: this.calcomAtendenteMarcarAgenda || null,
        calcom_cancelar_agenda_info: {
          pipelineId: this.calcomPipelineCancelarAgenda || null,
          faseId: this.calcomFaseCancelarAgenda || null
        },
        calcom_atendente_cancelar_agenda: this.calcomAtendenteCancelarAgenda || null,
        calcom_remarcar_agenda_info: {
          pipelineId: this.calcomPipelineRemarcarAgenda || null,
          faseId: this.calcomFaseRemarcarAgenda || null
        },
        calcom_atendente_remarcar_agenda: this.calcomAtendenteRemarcarAgenda || null,
      };

      await api.post(`/painel/ia/treinamento/${this.selectedTrainingId}/calcom/configuracao`, payload);
      
      // Recarregar estatísticas após salvar configuração
      if (this.form.calcomIntegracaoAtiva) {
        await this.carregarEstatisticasAgendamentos();
      }
    },
    async carregarEstatisticasAgendamentos() {
      if (!this.selectedTrainingId || !this.form.calcomIntegracaoAtiva) {
        this.estatisticasAgendamentos = null;
        return;
      }

      try {
        this.carregandoEstatisticas = true;
        const response = await api.get(`/painel/ia/treinamento/${this.selectedTrainingId}/calcom/estatisticas`);
        this.estatisticasAgendamentos = response.data;
      } catch (e) {
        console.error('Erro ao carregar estatísticas de agendamentos:', e);
        this.estatisticasAgendamentos = null;
      } finally {
        this.carregandoEstatisticas = false;
      }
    },
    nomePipeline(id) {
      const p = this.pipelinesAtendente.find(p => p.id === id);
      return p ? p.value : id;
    },
    nomeAtendente(id) {
      if (!id) return '';
      const idNormalizado = String(id);
      const usuario = this.usuarios.find(u => String(u.id) === idNormalizado);
      return usuario ? usuario.name : id;
    },
    nomeFase(tipo, faseId, pipelineIdManual = null) {
      let pipelineId = pipelineIdManual;

      if (!pipelineId) {
        const map = {
          endLease: 'pipelineWhenToEndLease',
          offline: 'pipelineWhenOffline',
          human: 'pipelineWhenWantsAttendant',
        };
        pipelineId = this.form[map[tipo]];
      }

      const fases = this.todasFases[pipelineId] || this.fases[tipo] || [];
      const fase = fases.find(f => f.id === faseId);
      return fase ? fase.nome : faseId;
    },
    handleHorarioChange(dia) {
      const h = this.form.horarioFuncionamento[dia];
      if (!h.ativo) {
        h.inicio = '';
        h.fim = '';
      }
    },
    handleHorarioToggle(dia) {
      const ativo = this.diasAtivos.includes(dia);
      if (!ativo) {
        this.form.horarioFuncionamento[dia].inicio = '';
        this.form.horarioFuncionamento[dia].fim = '';
      }
    },
    async getUsuarios() {
      try {
        const response = await api.get('/painel/usuarios',
          {
            params: {
              data: 1
            }
          }
        );

        this.usuarios = response.data;
      } catch (e) {
        console.error('Erro ao buscar usuários:', e);
      }
    },
    async getPipelinesAtendente() {
      try {
        const userId = window.userId;
        if (!userId) return;
        
        const response = await api.get(`/painel/oportunidades-pipelines`,
          {
            params: {
              data: 1
            }
          }
        );

        this.pipelinesAtendente = response.data;
      } catch (e) {
        console.error('Erro ao buscar pipelines do atendente:', e);
      }
    },
    async getTemplatesTarefas() {
      try {
        // Buscar templates do tipo 'tarefa' (tipo = 2)
        const response = await api.get('/painel/config-hyperflow-templates/templates-tarefas', {
          params: {
            tipo: 'tarefa'
          }
        });
        
        this.templatesTarefas = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      } catch (e) {
        console.error('Erro ao buscar templates de tarefas:', e);
        this.templatesTarefas = [];
      }
    },
    onPipelineChangeLoadFases(tipo) {
      const formPhaseByTipo = {
        endLease: 'phaseWhenToEndLease',
        generateBudget: 'phaseWhenGenerateBudget',
        offline: 'offlinePhase',
        human: 'phaseWhenWantsAttendant'
      };

      if (tipo === 'redirect') {
        this.novoRedirecionamento.faseId = '';
      } else if (tipo === 'calcomMarcar') {
        this.calcomFaseMarcarAgenda = '';
      } else if (tipo === 'calcomCancelar') {
        this.calcomFaseCancelarAgenda = '';
      } else if (tipo === 'calcomRemarcar') {
        this.calcomFaseRemarcarAgenda = '';
      } else if (formPhaseByTipo[tipo]) {
        this.form[formPhaseByTipo[tipo]] = '';
      }

      this.loadFases(tipo);
    },
    async loadFases(tipo) {
      const pipelineKeyMap = {
        endLease: 'pipelineWhenToEndLease',
        generateBudget: 'pipelineWhenGenerateBudget',
        offline: 'pipelineWhenOffline',
        human: 'pipelineWhenWantsAttendant',
        calcomMarcar: 'calcomPipelineMarcarAgenda',
        calcomCancelar: 'calcomPipelineCancelarAgenda',
        calcomRemarcar: 'calcomPipelineRemarcarAgenda'
      };

      const phaseKeyMap = {
        endLease: 'phaseWhenToEndLease',
        generateBudget: 'phaseWhenGenerateBudget',
        offline: 'offlinePhase',
        human: 'phaseWhenWantsAttendant',
      };

      let pipelineId = '';

      if (tipo === 'redirect') {
        pipelineId = this.novoRedirecionamento.pipelineId;
      } else if (tipo.startsWith('calcom')) {
        pipelineId = this[pipelineKeyMap[tipo]];
      } else {
        pipelineId = this.form[pipelineKeyMap[tipo]];
      }

      const loader = document.getElementById('overlayer-loading');

      if (!pipelineId) {
        this.fases[tipo] = [];
        if (phaseKeyMap[tipo]) {
          this.form[phaseKeyMap[tipo]] = '';
        }
        return;
      }

      try {
        loader?.classList.add('show-overlayer');

        const response = await api.get(`/painel/oportunidades-pipelines/listar-fases/${pipelineId}`);

        const fasesFormatadas = Array.isArray(response.data.fases)
          ? response.data.fases.map(f => ({ id: f.id, nome: f.value }))
          : [];

        this.fases[tipo] = fasesFormatadas;

        if (pipelineId) {
          this.todasFases[pipelineId] = fasesFormatadas;
        }
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao buscar fases da pipeline.');
        this.fases[tipo] = [];
      } finally {
        loader?.classList.remove('show-overlayer');
      }
    },
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    formatToolLabel(tool) {
      return tool
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
    },
    async getOpenAIModels() {
      try {
        const response = await api.get('/painel/ia/modelos');

        if (Array.isArray(response.data)) {
          this.modelosDisponiveis = response.data.sort((a, b) => a.id.localeCompare(b.id));
        } else {
          console.warn('Resposta inesperada:', response.data);
        }
      } catch (error) {
        window.showToastDanger?.('body', 'Erro ao buscar modelos da IA');
      }
    }
  }
}
</script>

<style scoped>
  .custom-form__card {
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  }
  .custom-modal-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    padding: 20px;
    animation: fadeIn 0.2s ease-in;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .custom-modal {
    border-radius: 12px;
    padding: 0;
    width: 80%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .custom-modal-header {
    padding: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .custom-modal-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
  }

  .custom-modal-footer {
    padding: 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    animation: slideUp 0.3s ease-out;
  }

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  body[data-theme="dark"] .custom-modal {
    background-color: #1e1e1e;
    color: white;
  }

  body[data-theme="dark"] .custom-modal-header,
  body[data-theme="dark"] .custom-modal-footer {
    border-color: rgba(255, 255, 255, 0.1);
  }

  body:not([data-theme="dark"]) .custom-modal {
    background-color: white;
    color: #333;
  }

  /* Header do Modal */
  .modal-header-custom {
    padding: 20px 24px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  }

  body[data-theme="dark"] .modal-header-custom {
    background: linear-gradient(135deg, #2d2d2d 0%, #1e1e1e 100%);
    border-bottom-color: #404040;
  }

  .btn-close-modal {
    background: transparent;
    border: none;
    color: #6c757d;
    font-size: 1.2rem;
    padding: 4px 8px;
    cursor: pointer;
    transition: color 0.2s;
  }

  .btn-close-modal:hover {
    color: #dc3545;
  }

  /* Body do Modal */
  .modal-body-custom {
    padding: 24px;
    overflow-y: auto;
    flex: 1;
  }

  /* Seções de Configuração */
  .config-section {
    margin-bottom: 28px;
  }

  .config-section:last-child {
    margin-bottom: 0;
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid #e9ecef;
  }

  body[data-theme="dark"] .section-header {
    border-bottom-color: #404040;
  }

  .section-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
    color: #333;
  }

  body[data-theme="dark"] .section-title {
    color: #fff;
  }

  .section-content {
    padding-left: 8px;
  }

  /* Input Token */
  .input-group-token {
    margin-top: 12px;
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
  }

  .input-icon {
    position: absolute;
    left: 14px;
    color: #6c757d;
    z-index: 1;
  }

  .input-token {
    flex: 1;
    padding-left: 40px;
    padding-right: 12px;
    height: 48px;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    font-size: 0.95rem;
    transition: all 0.2s;
  }

  .input-token:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    outline: none;
  }

  .btn-validate-token {
    height: 48px;
    padding: 0 20px;
    border-radius: 8px;
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s;
  }

  .btn-validate-token:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  }

  .help-text {
    margin-top: 8px;
    font-size: 0.85rem;
    color: #6c757d;
    line-height: 1.5;
  }

  .alert-success-custom,
  .alert-danger-custom,
  .alert-warning-custom {
    padding: 12px 16px;
    border-radius: 8px;
    border-left: 4px solid;
    display: flex;
    align-items: center;
  }

  .alert-success-custom {
    background-color: #d4edda;
    border-color: #28a745;
    color: #155724;
  }

  .alert-danger-custom {
    background-color: #f8d7da;
    border-color: #dc3545;
    color: #721c24;
  }

  .alert-warning-custom {
    background-color: #fff3cd;
    border-color: #ffc107;
    color: #856404;
  }

  body[data-theme="dark"] .alert-success-custom {
    background-color: #1e4620;
    color: #90ee90;
  }

  body[data-theme="dark"] .alert-danger-custom {
    background-color: #4a1e1e;
    color: #ff6b6b;
  }

  body[data-theme="dark"] .alert-warning-custom {
    background-color: #4a3e1e;
    color: #ffd93d;
  }

  /* Loading */
  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #6c757d;
  }

  /* Lista de Eventos */
  .eventos-list-container {
    max-height: 450px;
    overflow-y: auto;
    padding: 8px;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background: #f8f9fa;
  }

  body[data-theme="dark"] .eventos-list-container {
    background: #2d2d2d;
    border-color: #404040;
  }

  .evento-card {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;
    margin-bottom: 12px;
    background: white;
    border: 2px solid #e9ecef;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s;
  }

  .evento-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #007bff;
  }

  .evento-card.evento-selecionado {
    background: #f0f7ff;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  }

  body[data-theme="dark"] .evento-card {
    background: #1e1e1e;
    border-color: #404040;
  }

  body[data-theme="dark"] .evento-card.evento-selecionado {
    background: #1a2332;
    border-color: #007bff;
  }

  .evento-checkbox-wrapper {
    margin-top: 4px;
  }

  .evento-checkbox {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .evento-content {
    flex: 1;
  }

  .evento-header {
    margin-bottom: 8px;
  }

  .evento-title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    color: #333;
  }

  body[data-theme="dark"] .evento-title {
    color: #fff;
  }

  .evento-description {
    font-size: 0.9rem;
    color: #6c757d;
    margin-bottom: 12px;
    line-height: 1.5;
  }

  .evento-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
  }

  .badge-time {
    background-color: #17a2b8;
    color: white;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.8rem;
  }

  .badge-location {
    background-color: #6c757d;
    color: white;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.8rem;
  }

  .badge-price {
    background-color: #28a745;
    color: white;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.8rem;
  }

  .badge-warning-badge {
    background-color: #ffc107;
    color: #333;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.8rem;
  }

  .evento-durations {
    margin-top: 8px;
    color: #6c757d;
    font-size: 0.85rem;
  }

  .btn-detalhes {
    margin-top: 8px;
    border-radius: 6px;
    font-size: 0.85rem;
  }

  /* Permissões */
  .permissions-list {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 10px;
    border: 1px solid #e9ecef;
  }

  body[data-theme="dark"] .permissions-list {
    background: #2d2d2d;
    border-color: #404040;
  }

  .permission-item {
    padding: 16px;
    margin-bottom: 12px;
    background: white;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    transition: all 0.2s;
  }

  .permission-item:last-child {
    margin-bottom: 0;
  }

  .permission-item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: translateX(4px);
  }

  body[data-theme="dark"] .permission-item {
    background: #1e1e1e;
    border-color: #404040;
  }

  .permission-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .permission-info {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    flex: 1;
  }

  .permission-icon-wrapper {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
  }

  .permission-icon-wrapper.icon-success {
    background-color: #d4edda;
    color: #28a745;
  }

  .permission-icon-wrapper.icon-danger {
    background-color: #f8d7da;
    color: #dc3545;
  }

  .permission-icon-wrapper.icon-info {
    background-color: #d1ecf1;
    color: #17a2b8;
  }

  .permission-icon-wrapper.icon-warning {
    background-color: #fff3cd;
    color: #ffc107;
  }

  .permission-text {
    flex: 1;
  }

  .permission-title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 4px 0;
    color: #333;
  }

  body[data-theme="dark"] .permission-title {
    color: #fff;
  }

  .permission-description {
    font-size: 0.85rem;
    color: #6c757d;
    margin: 0;
    line-height: 1.4;
  }

  /* Estilos para os sliders (toggle switches) */
  .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 28px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.3s;
    border-radius: 28px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  input:checked + .slider {
    background-color: #007bff;
  }

  input:focus + .slider {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
  }

  input:checked + .slider:before {
    transform: translateX(24px);
  }

  /* Footer do Modal */
  .modal-footer-custom {
    padding: 20px 24px;
    border-top: 1px solid #e9ecef;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #f8f9fa;
  }

  body[data-theme="dark"] .modal-footer-custom {
    background: #2d2d2d;
    border-top-color: #404040;
  }

  /* Modal de Detalhes do Evento */
  .evento-detalhes-modal {
    max-width: 650px;
  }

  .detalhe-section-header {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #e9ecef;
  }

  body[data-theme="dark"] .detalhe-section-header {
    border-bottom-color: #404040;
  }

  .evento-titulo-principal {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
    color: #333;
  }

  body[data-theme="dark"] .evento-titulo-principal {
    color: #fff;
  }

  .detalhe-item {
    margin-bottom: 24px;
  }

  .detalhe-item:last-child {
    margin-bottom: 0;
  }

  .detalhe-label {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-size: 0.95rem;
    color: #495057;
  }

  body[data-theme="dark"] .detalhe-label {
    color: #adb5bd;
  }

  .detalhe-value {
    margin-left: 24px;
  }

  .detalhe-text {
    margin: 0;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
    line-height: 1.6;
    white-space: pre-wrap;
  }

  body[data-theme="dark"] .detalhe-text {
    background: #2d2d2d;
  }

  .detalhe-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
  }

  .detalhe-badge {
    display: inline-block;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 500;
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .locations-list,
  .limits-list,
  .config-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  /* Estilos para formulários nos modais */
  .form-label-custom {
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    display: block;
    font-size: 0.95rem;
  }

  body[data-theme="dark"] .form-label-custom {
    color: #adb5bd;
  }

  .form-control-custom {
    border: 2px solid #dee2e6;
    border-radius: 8px;
    padding: 10px 12px;
    transition: all 0.2s;
  }

  /* Aumentar altura dos selects especificamente */
  select.form-control-custom {
    min-height: 48px;
    padding: 12px 14px;
    line-height: 1.5;
    font-size: 0.95rem;
  }

  .form-control-custom:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    outline: none;
  }

  body[data-theme="dark"] .form-control-custom {
    background-color: #2d2d2d;
    border-color: #404040;
    color: #fff;
  }

  /* Lista de Redirecionamentos */
  .redirecionamentos-list-container {
    max-height: 450px;
    overflow-y: auto;
    padding: 8px;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background: #f8f9fa;
  }

  body[data-theme="dark"] .redirecionamentos-list-container {
    background: #2d2d2d;
    border-color: #404040;
  }

  .redirecionamento-item {
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    transition: all 0.2s;
  }

  .redirecionamento-item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }

  body[data-theme="dark"] .redirecionamento-item {
    background: #1e1e1e;
    border-color: #404040;
  }

  .redirecionamento-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
  }

  .redirecionamento-info {
    flex: 1;
  }

  .redirecionamento-field {
    margin-bottom: 8px;
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .redirecionamento-field:last-child {
    margin-bottom: 0;
  }

  .redirecionamento-field strong {
    color: #333;
    margin-right: 4px;
  }

  body[data-theme="dark"] .redirecionamento-field strong {
    color: #fff;
  }

  .btn-remove {
    white-space: nowrap;
    border-radius: 6px;
    transition: all 0.2s;
  }

  .btn-remove:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
  }

  .ia-http-tools-panel {
    background: #f8f9fa;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 1rem;
  }

  .ia-http-tools-panel__header {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  }

  .ia-http-tools-panel__header-actions {
    flex-shrink: 0;
  }

  .ia-http-tools-table {
    background: #fff;
  }

  .ia-http-tool-editor {
    border: 1px solid #007bff;
    margin-top: 0.5rem;
  }

  body[data-theme="dark"] .ia-http-tools-panel {
    background-color: #2a2c2f !important;
    border-color: #495057 !important;
    color: #ddd !important;
  }

  body[data-theme="dark"] .ia-http-tools-panel .text-muted {
    color: #aaa !important;
  }

  body[data-theme="dark"] .ia-http-tools-panel code {
    background-color: #3a3d42;
    color: #f8d7da;
  }

  body[data-theme="dark"] .ia-http-tools-panel .alert-info {
    background-color: #1a3a4a !important;
    border-color: #2c5f7a !important;
    color: #b8daff !important;
  }

  body[data-theme="dark"] .ia-http-tools-table {
    background-color: #1e1e1e !important;
    color: #ddd !important;
  }

  body[data-theme="dark"] .ia-http-tools-table thead th {
    background-color: #2a2c2f !important;
    border-color: #404040 !important;
    color: #fff !important;
  }

  body[data-theme="dark"] .ia-http-tools-table td,
  body[data-theme="dark"] .ia-http-tools-table th {
    border-color: #404040 !important;
  }

  body[data-theme="dark"] .ia-http-tools-table tbody tr:hover {
    background-color: #2a2c2f;
  }

  body[data-theme="dark"] .ia-http-tool-editor {
    background-color: #1e1e1e !important;
    border-color: #4dabf7 !important;
  }

  body[data-theme="dark"] .ia-http-tool-editor .card-header {
    background-color: #2a2c2f !important;
    border-bottom-color: #404040 !important;
    color: #fff !important;
  }

  body[data-theme="dark"] .ia-http-tool-editor .card-body {
    background-color: #1e1e1e !important;
    color: #ddd !important;
  }

  .ia-http-config-row {
    align-items: flex-start;
  }

  .ia-http-config-block {
    display: flex;
    flex-direction: column;
  }

  .ia-http-subsection-header {
    align-items: center;
    display: grid;
    gap: 0.5rem 0.75rem;
    grid-template-columns: minmax(0, 1fr) 6.75rem;
    margin-bottom: 0.5rem;
    min-height: 32px;
  }

  .ia-http-subsection-header__title {
    align-self: center;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.25;
    margin: 0;
    min-width: 0;
  }

  .ia-http-subsection-header__btn {
    align-self: center;
    flex-shrink: 0;
    font-size: 0.75rem;
    justify-self: stretch;
    line-height: 1.2;
    padding: 0.25rem 0.35rem;
    text-align: center;
    white-space: nowrap;
    width: 100%;
  }

  .ia-http-subsection-header__btn--placeholder {
    pointer-events: none;
    visibility: hidden;
  }

  .ia-http-subsection-hint {
    margin-bottom: 0.5rem;
    margin-top: -0.15rem;
  }

  .ia-http-kv-row {
    align-items: center;
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .ia-http-kv-row:last-child {
    margin-bottom: 0;
  }

  .ia-http-kv-row__key {
    flex: 0 0 38%;
    min-width: 0;
  }

  .ia-http-kv-row__value {
    flex: 1;
    min-width: 0;
  }

  .ia-http-kv-row__remove {
    flex-shrink: 0;
    line-height: 1;
    min-width: 28px;
    padding-left: 0.35rem;
    padding-right: 0.35rem;
  }

  .ia-http-scroll-list {
    max-height: 240px;
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 0.35rem;
  }

  .ia-http-variables-list .ia-http-variable-row:last-child {
    margin-bottom: 0;
  }

  .ia-http-variable-row {
    align-items: end;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    display: grid;
    gap: 0.5rem;
    grid-template-areas:
      "name type required remove"
      "desc desc desc desc";
    grid-template-columns: 1fr 100px 90px 32px;
    margin-bottom: 0.75rem;
    padding: 0.5rem;
  }

  .ia-http-variable-row__name {
    grid-area: name;
  }

  .ia-http-variable-row__type {
    grid-area: type;
  }

  .ia-http-variable-row__required {
    grid-area: required;
  }

  .ia-http-variable-row__remove {
    align-self: end;
    grid-area: remove;
  }

  .ia-http-variable-row__description {
    grid-area: desc;
  }

  .ia-http-system-variables-panel {
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin-bottom: 1.75rem !important;
    margin-top: 0.25rem;
    overflow: hidden;
  }

  .ia-http-system-variables-panel + .ia-http-section-card,
  .ia-http-system-variables-panel + .ia-http-output-builder {
    margin-top: 0.25rem;
  }

  .ia-http-system-variables-panel__toggle {
    align-items: center;
    background: #f8f9fa;
    border: 0;
    display: flex;
    gap: 0.75rem;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    text-align: left;
    width: 100%;
  }

  .ia-http-system-variables-panel__toggle:hover {
    background: #f1f3f5;
  }

  .ia-http-system-variables-panel__toggle-text {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    min-width: 0;
  }

  .ia-http-system-variables-panel__title {
    color: #212529;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.3;
  }

  .ia-http-system-variables-panel__subtitle {
    color: #6c757d;
    font-size: 0.78rem;
    line-height: 1.35;
  }

  .ia-http-system-variables-panel__subtitle code {
    font-size: 0.75rem;
  }

  .ia-http-system-variables-panel__toggle-icon {
    color: #6c757d;
    flex-shrink: 0;
  }

  .ia-http-system-variables-panel__body {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    padding: 0.75rem 1rem 1rem;
  }

  .ia-http-variables-legend {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 0.78rem;
    gap: 0.35rem 0.5rem;
    margin-bottom: 0.75rem;
  }

  .ia-http-variables-legend__item {
    align-items: center;
    display: inline-flex;
    gap: 0.35rem;
  }

  .ia-http-variables-legend__item code {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    font-size: 0.72rem;
    padding: 0.1rem 0.35rem;
  }

  .ia-http-variables-legend__divider {
    color: #adb5bd;
  }

  .ia-http-system-variables-toolbar {
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
    margin-bottom: 0.75rem;
  }

  .ia-http-system-variables-search {
    max-width: 100%;
  }

  .ia-http-system-variables-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
  }

  .ia-http-system-variables-tab {
    align-items: center;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 999px;
    color: #495057;
    display: inline-flex;
    font-size: 0.78rem;
    gap: 0.35rem;
    line-height: 1.2;
    padding: 0.25rem 0.65rem;
  }

  .ia-http-system-variables-tab:hover {
    background: #f8f9fa;
  }

  .ia-http-system-variables-tab--active {
    background: #e7f1ff;
    border-color: #9ec5fe;
    color: #0d6efd;
    font-weight: 600;
  }

  .ia-http-system-variables-tab__count {
    background: rgba(0, 0, 0, 0.06);
    border-radius: 999px;
    font-size: 0.68rem;
    line-height: 1;
    padding: 0.15rem 0.4rem;
  }

  .ia-http-system-variables-tab--active .ia-http-system-variables-tab__count {
    background: rgba(13, 110, 253, 0.12);
  }

  .ia-http-system-variables-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
    max-height: 220px;
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 0.25rem;
  }

  .ia-http-system-variable-chip {
    align-items: center;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    gap: 0.15rem;
    max-width: 100%;
    padding: 0.4rem 0.55rem;
    text-align: left;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .ia-http-system-variable-chip:hover {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.15rem rgba(13, 110, 253, 0.12);
  }

  .ia-http-system-variable-chip__key {
    color: #0d6efd;
    font-size: 0.72rem;
    white-space: nowrap;
  }

  .ia-http-system-variable-chip__label {
    color: #6c757d;
    font-size: 0.68rem;
    line-height: 1.25;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ia-http-system-variable-chip__group {
    background: #f1f3f5;
    border-radius: 999px;
    color: #495057;
    font-size: 0.62rem;
    line-height: 1;
    padding: 0.15rem 0.4rem;
  }

  body[data-theme="dark"] .ia-http-system-variables-panel {
    border-color: #404040;
  }

  body[data-theme="dark"] .ia-http-system-variables-panel__toggle {
    background: #2a2a2a;
  }

  body[data-theme="dark"] .ia-http-system-variables-panel__toggle:hover {
    background: #333;
  }

  body[data-theme="dark"] .ia-http-system-variables-panel__title {
    color: #f1f3f5;
  }

  body[data-theme="dark"] .ia-http-system-variables-panel__body {
    background-color: #252525;
    border-top-color: #404040;
  }

  body[data-theme="dark"] .ia-http-variables-legend__item code {
    background: rgba(255, 255, 255, 0.08);
    color: #ddd;
  }

  body[data-theme="dark"] .ia-http-system-variables-tab,
  body[data-theme="dark"] .ia-http-system-variable-chip {
    background: #2a2a2a;
    border-color: #404040;
    color: #ddd;
  }

  body[data-theme="dark"] .ia-http-system-variables-tab--active {
    background: #1a3a5c;
    border-color: #4d8fd1;
    color: #9ec5fe;
  }

  body[data-theme="dark"] .ia-http-system-variable-chip__key {
    color: #9ec5fe;
  }

  body[data-theme="dark"] .ia-http-system-variable-chip__group {
    background: #333;
    color: #ccc;
  }

  body[data-theme="dark"] .ia-http-variable-row {
    background-color: #252525;
    border-color: #404040;
  }

  .ia-http-output-builder__actions {
    gap: 0.35rem;
  }

  @media (max-width: 767.98px) {
    .ia-http-tools-panel__header-actions {
      width: 100%;
    }

    .ia-http-tools-panel__header-actions .btn {
      width: 100%;
    }

    .ia-http-tools-table__url-col {
      display: none;
    }

    .ia-http-variable-row {
      grid-template-areas:
        "name name"
        "type required"
        "desc desc"
        "remove remove";
      grid-template-columns: 1fr 1fr;
    }

    .ia-http-variable-row__remove {
      justify-self: end;
    }

    .ia-http-kv-row {
      align-items: stretch;
      flex-wrap: wrap;
    }

    .ia-http-kv-row__key,
    .ia-http-kv-row__value {
      flex: 1 1 100%;
    }

    .ia-http-kv-row__remove {
      align-self: center;
      margin-left: auto;
    }

    .ia-http-subsection-header {
      grid-template-columns: minmax(0, 1fr) auto;
    }

    .ia-http-subsection-header__btn {
      justify-self: end;
      width: auto;
    }

    .ia-http-field-row {
      align-items: stretch;
      flex-direction: column;
    }

    .ia-http-field-row__alias,
    .ia-http-field-row__path {
      flex: 1 1 auto;
      width: 100%;
    }
  }

  .ia-http-preview {
    background: #1f2933;
    border-radius: 4px;
    color: #f8f9fa;
    font-size: 0.78rem;
    max-height: 260px;
    overflow: auto;
    padding: 0.75rem;
    white-space: pre-wrap;
  }

  .ia-http-output-builder {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .ia-http-section-card {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 1rem;
  }

  body[data-theme="dark"] .ia-http-section-card {
    background: #1e1e1e;
    border-color: #404040;
  }

  .ia-http-ai-output-card {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.12rem rgba(0, 123, 255, 0.12);
  }

  .ia-http-preview--ai {
    background: #0f172a;
    border: 1px solid rgba(255, 255, 255, 0.12);
    font-size: 0.9rem;
    max-height: 380px;
    min-height: 140px;
  }

  .ia-http-field-row {
    align-items: flex-end;
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
  }

  .ia-http-field-row__alias {
    flex: 0 0 34%;
  }

  .ia-http-field-row__path {
    flex: 1;
  }

  .ia-http-field-row__remove {
    margin-bottom: 1px;
  }

  .ia-http-selected-fields {
    max-height: 260px;
    overflow-y: auto;
    padding-right: 0.35rem;
  }

  .ia-http-suggestions {
    max-height: 180px;
    overflow: auto;
  }

  .redirecionamentos-list {
    max-height: 400px;
    overflow-y: auto;
    margin-top: 15px;
  }

  .custom-modal-tabs {
    display: flex;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    padding: 0 20px;
    background-color: #f8f9fa;
    flex-shrink: 0;
  }

  body[data-theme="dark"] .custom-modal-tabs {
    background-color: #1a1a1a;
    border-bottom-color: rgba(255, 255, 255, 0.1);
  }

  .tab-button {
    padding: 12px 24px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 500;
    color: #6c757d;
    border-bottom: 3px solid transparent;
    transition: all 0.3s ease;
    margin-bottom: -2px;
  }

  .tab-button:hover {
    color: #007bff;
    background-color: rgba(0, 123, 255, 0.05);
  }

  .tab-button.active {
    color: #007bff;
    border-bottom-color: #007bff;
    background-color: transparent;
  }

  body[data-theme="dark"] .tab-button {
    color: #adb5bd;
  }

  body[data-theme="dark"] .tab-button:hover {
    color: #4dabf7;
    background-color: rgba(77, 171, 247, 0.1);
  }

  body[data-theme="dark"] .tab-button.active {
    color: #4dabf7;
    border-bottom-color: #4dabf7;
  }

  .tab-content {
    min-height: 400px;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .custom-modal-finalizar-locacao {
    max-width: 1000px !important;
  }

  /* Gap para flexbox (compatibilidade) */
  .gap-2 > * {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }

  /* Estilos para seção de estatísticas Cal.com no modo escuro */
  body[data-theme="dark"] .calcom-estatisticas {
    background-color: #2a2c2f !important;
    color: #ddd !important;
  }

  body[data-theme="dark"] .calcom-estatisticas h6 {
    color: #fff !important;
  }

  body[data-theme="dark"] .calcom-estatisticas .text-muted {
    color: #aaa !important;
  }

  body[data-theme="dark"] .calcom-estatisticas .text-muted strong {
    color: #ddd !important;
  }

  body[data-theme="dark"] .calcom-estatisticas .badge-light {
    background-color: #3a3d42 !important;
    color: #ddd !important;
    border-color: #495057 !important;
  }

  /* Seletor de tags (checkboxes + cor) — substitui select multiple */
  .ia-tag-search {
    max-width: 320px;
  }

  .ia-tag-picker {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    padding: 8px 10px;
    max-height: 180px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.02);
  }

  .ia-tag-picker--modal {
    max-height: 200px;
  }

  .ia-tag-picker--inline {
    max-height: 140px;
  }

  .ia-tag-picker__item {
    margin-bottom: 2px;
  }

  .ia-tag-picker__label {
    cursor: pointer;
    display: inline-flex !important;
    align-items: center;
    font-size: 0.875rem;
    font-weight: normal;
    line-height: 1.3;
  }

  .ia-tag-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    min-width: 10px;
    border-radius: 50%;
    margin-right: 6px;
    flex-shrink: 0;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
  }

  .tool-task-config-card,
  .tool-task-rule-card {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.02);
  }

  .tool-task-automation-card {
    border: 1px solid rgba(0, 123, 255, 0.22);
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 14px;
    background: rgba(0, 123, 255, 0.04);
  }

  .tool-task-automation-card--disabled {
    border-color: rgba(108, 117, 125, 0.25);
    background: rgba(108, 117, 125, 0.06);
  }

  .tool-task-config-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 12px;
  }

  .tool-task-rule-card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .custom-modal-tool-tasks {
    max-width: 980px !important;
  }

  .tool-task-placeholders {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 8px;
  }

  .tool-task-placeholder-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px;
    border: 1px solid rgba(23, 162, 184, 0.25);
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.55);
  }

  .tool-task-placeholder-item code {
    font-size: 0.85rem;
  }

  body[data-theme="dark"] .tool-task-config-card,
  body[data-theme="dark"] .tool-task-rule-card {
    background: #1e1e1e;
    border-color: #404040;
  }

  body[data-theme="dark"] .tool-task-automation-card {
    background: rgba(77, 171, 247, 0.08);
    border-color: rgba(77, 171, 247, 0.28);
  }

  body[data-theme="dark"] .tool-task-automation-card--disabled {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.12);
  }

  body[data-theme="dark"] .tool-task-placeholder-item {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(77, 171, 247, 0.25);
  }

  body[data-theme="dark"] .ia-tag-picker {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.12);
  }

  .ia-tag-picker--disabled {
    opacity: 0.92;
  }

  .ia-tag-picker__label--disabled {
    cursor: default;
    pointer-events: none;
    color: rgba(0, 0, 0, 0.65);
  }

  body[data-theme="dark"] .ia-tag-picker__label--disabled {
    color: rgba(255, 255, 255, 0.65);
  }

  /* ===== Base de conhecimento (RAG) ===== */
  .kb-uploader,
  .kb-url-import {
    background: rgba(0, 0, 0, 0.025);
    border: 1px dashed rgba(0, 0, 0, 0.15);
    border-radius: 0.5rem;
    padding: 0.875rem 1rem;
  }

  .kb-item__url {
    word-break: break-all;
  }

  body[data-theme="dark"] .kb-uploader,
  body[data-theme="dark"] .kb-url-import {
    background: rgba(255, 255, 255, 0.03);
    border-color: rgba(255, 255, 255, 0.15);
  }

  .kb-empty {
    border: 1px dashed rgba(0, 0, 0, 0.12);
    border-radius: 0.5rem;
    padding: 2rem 1rem;
    background: rgba(0, 0, 0, 0.015);
  }

  body[data-theme="dark"] .kb-empty {
    border-color: rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.02);
  }

  .kb-empty-icon {
    font-size: 2.25rem;
    color: rgba(0, 0, 0, 0.25);
  }

  body[data-theme="dark"] .kb-empty-icon {
    color: rgba(255, 255, 255, 0.3);
  }

  .kb-list {
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.5rem;
    overflow: hidden;
  }

  body[data-theme="dark"] .kb-list {
    border-color: rgba(255, 255, 255, 0.1);
  }

  .kb-item {
    display: grid;
    grid-template-columns: 36px 1fr auto auto;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    background: transparent;
    transition: background-color 0.15s ease;
  }

  body[data-theme="dark"] .kb-item {
    border-top-color: rgba(255, 255, 255, 0.08);
  }

  .kb-item:first-child {
    border-top: none;
  }

  .kb-item:hover {
    background: rgba(0, 0, 0, 0.02);
  }

  body[data-theme="dark"] .kb-item:hover {
    background: rgba(255, 255, 255, 0.03);
  }

  .kb-item--error {
    background: rgba(220, 53, 69, 0.04);
  }

  .kb-item--processing,
  .kb-item--pending {
    background: rgba(23, 162, 184, 0.04);
  }

  .kb-item__icon {
    font-size: 1.5rem;
    text-align: center;
  }

  .kb-item__title {
    font-weight: 600;
    word-break: break-word;
    line-height: 1.2;
  }

  .kb-item__meta {
    margin-top: 0.15rem;
  }

  .kb-item__meta .kb-sep {
    margin: 0 0.35rem;
    opacity: 0.6;
  }

  .kb-item__status {
    white-space: nowrap;
  }

  .kb-item__actions {
    display: flex;
    gap: 0.25rem;
  }

  @media (max-width: 575.98px) {
    .kb-item {
      grid-template-columns: 32px 1fr;
      grid-template-areas:
        "icon body"
        ".    status"
        ".    actions";
    }
    .kb-item__icon { grid-area: icon; }
    .kb-item__body { grid-area: body; }
    .kb-item__status { grid-area: status; justify-self: start; margin-top: 0.25rem; }
    .kb-item__actions { grid-area: actions; margin-top: 0.5rem; }
  }
</style>
